import { createTranslations, type Language } from '../../../i18n/types';

export default createTranslations({
  en: {
    lobbyTitle: 'Rush Mid',
    ticket: 'Ticket',
    format: 'Format',
    side: 'Side',
    sideCt: 'Counter-Terrorists',
    sideT: 'Terrorists',
    sideAny: 'Any',
    skinLabel: 'Skin',
    practiceBots: 'Vs bots',
    playWithBots: 'Play with bots · free',
    winRangeTitle: 'Skin for a win',
    skip: 'Skip',
    howtoTitle: 'How to play',
    howtoNext: 'Next',
    howtoStart: 'Got it, let’s play',
    howtoSkip: 'Skip',
    howtoSlide1Title: 'Turn-based PvP',
    howtoSlide1Text:
      'The ticket is your entry. Opponents are real players with the same ticket. The winning team splits the bank.',
    howtoSlide2Title: 'The buy doesn’t decide',
    howtoSlide2Text:
      'Everyone gets the same budget. Weapons set the style: the AWP is a rare heavy shot, the machine gun fires often and steady.',
    howtoSlide3Title: 'Read your opponent',
    howtoSlide3Text:
      'Each round you pick a stance. Watch what your opponent did last round — and counter it.',
    howtoSlide4Title: 'A skin split by contribution',
    howtoSlide4Text:
      'The bank is split by damage and utility, then paid out as a skin worth your share. Even if you die, your contribution counts. The bank fills from every ticket’s spin — a win pays out a skin worth at least your entry +50%, the ceiling is ×5.',
    howtoTryBots: 'Try it free first — vs bots',
    howtoLoopTitle: 'How a match goes',
    howtoLoopStep1: 'Pick a ticket, a side and a format — that’s your entry.',
    howtoLoopStep2: 'Buy phase: weapon, armor and utility on an equal budget.',
    howtoLoopStep3: 'Turn-based fight: every round — a stance or an action. Pick your target with a tap.',
    howtoLoopStep4: 'The match bank is split among the winners by contribution and paid out as a skin.',
    howtoStancesTitle: 'Stances',
    howtoRpsCaption: 'The arrow shows who beats whom',
    howtoStancesText:
      '[[defense|Defense]] reflects part of the damage, [[maneuver|Dodge]] lowers the enemy’s accuracy, [[attack|Attack]] boosts your fire.',
    howtoWeaponsTitle: 'Weapons',
    howtoWeaponAwp: 'AWP — all or nothing: rare shot, huge crit.',
    howtoWeaponRifle: 'Rifle — the balanced classic.',
    howtoWeaponLmg: 'Machine gun — often and steady, no crit swings.',
    howtoUtilityTitle: 'Utility',
    howtoSmokeTargetNote: 'Smoke covers an ally — tap a teammate to pick who it shields.',
    howtoUtilTeamNote: 'Smoke and flash exist only in team modes.',
    howtoMoneyTitle: 'Money',
    howtoMoney1: 'The buy budget is equal for everyone — it sets the style, not the power.',
    howtoMoney2: 'The prize is a skin split by contribution: damage + utility. Dying doesn’t erase it.',
    howtoMoney3: 'The bank fills from every ticket’s spin: a win pays out a skin worth at least your entry +50%, the ceiling is ×5.',
    howtoMoney4: 'Every ticket is one bank spin — from half up to 2.5× the ticket per spin. Pricier ticket — bigger bank.',
    history: 'History',
    partyJoin: 'Join by code',
    partyJoinPlaceholder: 'Party code',
    partyJoinAction: 'Join',
    partyShare: 'Invite friends',
    partyKick: 'Remove from party',
    partyShareText: 'Join my SHOT party — code {{code}}',
    partyErrNotFound: 'Party not found — check the code.',
    partyErrInGame: 'That party is already in a game — finish it first.',
    partyErrFull: 'That party is full.',
    partyErrInMatch: 'Finish your active match first.',
    multiaccErr: 'You cannot join here.',
    maintenanceErr: 'The game is updating — check back in a couple of minutes.',
    balanceErr: 'Not enough coins for the entry — top up your balance and come back.',
    topUpBalance: 'Top up balance',
    maintenanceBanner: 'The game is updating — matches reopen in a couple of minutes.',
    updateBanner: 'A new version is out — update to keep playing.',
    updateNow: 'Update',
    comingSoonBadge: 'Coming soon',
    comingSoonHint: 'The mode hasn’t opened yet — stay tuned.',
    partyLeaderTag: 'leader',
    partyLeave: 'Leave party',
    partyCodeLabel: 'Party code',
    partyCopy: 'Copy',
    partyCopied: 'Copied',
    partyCreatedBy: 'Created by {{name}}',
    partyLeaderBadge: 'Leader',
    partyReadyYes: 'Ready',
    partyReadyNo: 'Not ready',
    partyWaitingOthers: 'Waiting for the other players',
    partyConfirmReady: 'Confirm you are ready to start.',
    partyImReady: 'I am ready',
    partyYou: 'You',
    partyShareBtn: 'Share',
    partyReadyCount: 'Ready: {{n}} of {{m}}',
    mode1: '1 v 1',
    mode2: '2 v 2',
    mode5: '5 v 5',
    modeN: '{{size}} v {{size}}',
    gamesTab: 'Games',
    introCard: 'Rush Mid is a Counter-Strike-style take on case battles: players enter a match with a fixed ticket, fight each other, and a win pays out a skin worth a share tied to the entry price.',
    openGamesTitle: 'Open games',
    howToPlayLink: 'how to play',
    winUpToPrefix: 'for a win up to',
    winUpToSuffix: '',
    waitingForPlayer: 'waiting for a player…',
    winRangeChip: 'a win pays',
    notEnoughShort: 'missing',
    homeAllGames: 'all games',
    createGame: 'Create game · ',
    createGameShort: 'Create game',
    gamesEmptyTitle: 'Nothing here yet',
    gamesEmpty: 'No open games yet — create the first one',
    gamesBack: 'Back to games',
    openGameTitle: 'Game',
    joinSide: 'Sit',
    confirmSitTitle: 'Join the game',
    confirmSitMessage: 'Sit in for {{amount}}?',
    confirmSitYes: 'Sit',
    gameFull: 'All seats are taken',
    partyBadge: 'party ×{{k}}',
    tabFighter: 'Fighter',
    squadTitle: 'Party',
    inviteFriends: 'Invite friends',
    leaderPicking: 'The leader is picking a game…',
    partyWontFit: 'party ×{{k}} won’t fit',
    graceLockedBadge: 'newcomer game · {{s}}s',
    graceLockedHint: 'A newcomer is warming up here. The lobby opens to everyone in {{s}}s.',
    partyFits: 'party ×{{k}} fits',
    wontFit: 'won’t fit',
    memberBadge: 'In a party ×{{k}}',
    createSheetTitle: 'Create game',
    createSheetSubtitle: 'Pick a ticket, format and side',
    botFillIn: 'Bots fill in {{s}}s',
    leaveGame: 'Leave',
    youLabel: 'you',
    gameInvite: 'Invite',
    gameShareText: 'Come join my Rush Mid game',
    gameShareButton: 'Play',
    replayTitle: 'Match replay',
    shareReplay: 'Share replay',
    replayShareText: 'Check out this Rush Mid match',
    replayShareButton: 'Watch replay',
    gameGone: 'This game has already started or closed',
    tipLabel: 'Tip',
    preparing: 'Preparing the battle…',
    loadingGame: 'Loading battle…',
    loading: 'Loading…',
    errorTitle: 'RushMid error',
    backToLobby: 'Back to games',
    reloadScreen: 'Reload screen',
    buyTitle: 'Buy',
    remaining: 'Remaining',
    yourFighter: 'Your fighter',
    hp: 'HP',
    armorShort: 'armor',
    weapon: 'Weapon',
    armor: 'Armor',
    grenade: 'Grenade',
    grenadeTaken: 'Taken',
    medkit: 'Medkit',
    accuracy: 'Accuracy',
    stance: 'Stance',
    stanceCenter: 'Centre',
    stanceAttack: 'Attack',
    stanceDefense: 'Defense',
    stanceManeuver: 'Dodge',
    knife: 'Knife',
    smoke: 'Smoke',
    flash: 'Flash',
    nadeSmoke: 'Smoke',
    nadeFrag: 'Frag',
    logSmoke: 'smoke',
    logAdrenaline: 'adrenaline',
    adrenaline: 'adrenaline',
    afkBadge: 'AFK',
    afkWarn: 'Miss one more round and you forfeit your winnings',
    fire: 'Fire',
    pickAlly: 'Select a teammate',
    pickEnemy: 'Select an enemy',
    confirmAction: 'Confirm',
    waiting: 'Waiting…',
    choosing: 'Choosing…',
    watchingReplay: 'Watching…',
    youWin: 'Victory',
    youLose: 'Defeat',
    sideWins: 'WIN',
    matchDraw: 'Draw',
    drawRefund: 'Coins refunded',
    botShort: 'Bot',
    copyMatchId: 'Copy match ID',
    matchIdCopied: 'Copied',
    roundN: 'Round {{round}}',
    autoStart: 'Auto-start in',
    grenadeNone: 'No',
    allies: 'Allies',
    enemies: 'Enemies',
    loadout: 'Loadout',
    toBattle: 'To battle',
    toBattleIn: 'To battle in {{sec}}s',
    statDamage: 'Damage',
    statRate: 'Rate',
    statCrit: 'Crit',
    statAccuracy: 'Accuracy',
    weaponAwp: 'AWP',
    weaponRifle: 'Rifle',
    weaponLmg: 'Machine gun',
    weaponAwpBlurb: 'Hits hard but rarely. High crit — either kills or misses.',
    weaponRifleBlurb: 'Balanced damage and rate of fire.',
    weaponLmgBlurb: 'Often but weak. Steadily racks up damage.',
    armorNone: 'No armor',
    armorLight: 'Light vest',
    armorHeavy: 'Heavy vest',
    armorNoneBlurb: 'Maximum firepower, but fragile.',
    armorLightBlurb: 'Slightly cuts damage and crit.',
    armorHeavyBlurb: 'Heavily cuts peak damage and crit — counters AWP.',
    armorNumbers: '{{points}} armor points · bullet −30% dmg, crits pierce',
    gearInfoOpen: 'How it works',
    gearInfoTitle: 'Gear in numbers',
    gearFragInfo: 'Up to {{max}} dmg to the target — armor won’t save; shrapnel clips one more enemy. [[defense|Defense]] takes ×1.35, [[maneuver|Maneuver]] ×0.8.',
    gearSmokeInfo: 'Smoke an ally: for {{rounds}} rounds he takes −{{mit}}% bullet damage. Knife and grenade ignore smoke.',
    gearFlashInfo: 'Blinds up to 3 enemies for {{rounds}} rounds: half accuracy, no crits.',
    gearMedkitInfo: 'Heals {{frac}}% of missing HP (at least {{floor}}). You don’t shoot this round and are open to the knife.',
    gearKnifeInfo: 'Free, every round. Target not shooting or braced in [[defense|Defense]] — {{dmg}} through armor, execute at ≤30% HP. Target in [[attack|Attack]] or [[maneuver|Maneuver]] — only {{weak}}, and you eat its point-blank fire.',
    resultWin: 'Victory',
    resultTeamWin: 'Team won',
    resultDefeat: 'Defeat',
    resultWinSub: 'Your team won — you get a skin worth your share of the bank, split by contribution (MVP).',
    resultTeamWinSub: 'Your team won. Your fighter fell, but you still earned a skin worth your share by contribution (MVP).',
    resultDefeatSub: 'The team lost — better luck next round.',
    scoreboardTitle: 'Scoreboard',
    payout: 'Win',
    total: 'Total',
    again: 'Again',
    wonShort: 'Victory',
    viewLog: 'View log',
    roundLog: 'Log',
    roundLogTitle: 'Battle log',
    roundLogEmpty: 'First round is still playing',
    raffleTicketsTitle: '+{{n}} raffle tickets',
    raffleChipWin: 'Win +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triple +{{n}}',
    raffleChipQuad: 'Quad +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: 'Win at 1 HP +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    dropRevealTapHint: 'Tap to continue',
    dropYouTitle: 'Your drop',
    dropLabel: 'Drop',
    watch: 'Watch',
    liveNowTitle: 'Live now',
    liveEmpty: 'No matches running right now',
    liveRoundBadge: 'Live · round {{n}}',
    spectate: 'Watch',
    matchOver: 'Match over',
    logMiss: 'miss',
    logMissEvade: 'miss — dodged',
    logMissBlind: 'miss — blinded',
    logReflect: 'reflected',
    logPunish: 'return fire',
    logLegend: '✦ crit pierces armor · ⚡ adrenaline',
    logKilledBy: 'killed by',
    colKills: 'K',
    canvasMiss: 'MISS',
    canvasMissEvade: 'DODGE',
    canvasMissBlind: 'BLIND',
    historyTitle: 'History',
    back: 'Back',
    matchDetailError: 'Couldn’t load this match. It may not exist — bot practice keeps no record.',
    historySubtitle: 'Your latest Rush Mid battles.',
    historyEmptyTitle: 'You have not played yet',
    historyEmptyDescription: 'Play your first Rush Mid battle — it will show up here.',
    win: 'Victory',
    defeat: 'Defeat',
    timeJustNow: 'just now',
    timeMinAgo: '{{min}} min ago',
    timeHoursAgo: '{{hours}} h ago',
    timeDaysAgo: '{{days}} d ago',
    ratingTab: 'Rating',
    yourRating: 'Your rating',
    earned: 'Earned',
    rating: 'Rating',
    played: 'Played',
    wins: 'Wins',
    winsCol: 'Wins',
    losses: 'Losses',
    lossesCol: 'Losses',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Win rate',
    player: 'Player',
    topPlayers: 'Top players',
    ratingUnratedTitle: 'No rating yet',
    ratingUnratedDescription: 'Play a match in this format to get a rating.',
    ratingEmptyTitle: 'No one here yet',
    ratingEmptyDescription: 'Be the first to play in this format.',
    raffleTab: 'Raffle',
  },
  ru: {
    lobbyTitle: 'Rush Mid',
    ticket: 'Билет',
    format: 'Формат',
    side: 'Сторона',
    sideCt: 'Контр-террористы',
    sideT: 'Террористы',
    sideAny: 'Любая',
    skinLabel: 'Скин',
    practiceBots: 'С ботами',
    playWithBots: 'Играть с ботами · бесплатно',
    winRangeTitle: 'Скин за победу',
    skip: 'Пропустить',
    howtoTitle: 'Как играть',
    howtoNext: 'Дальше',
    howtoStart: 'Понятно, играем',
    howtoSkip: 'Пропустить',
    howtoSlide1Title: 'Пошаговый PvP',
    howtoSlide1Text:
      'Билет — твой вход в матч. Соперники — реальные игроки с таким же билетом. Победившая команда делит банк.',
    howtoSlide2Title: 'Закуп не решает',
    howtoSlide2Text:
      'Бюджет у всех одинаковый. Оружие задаёт стиль: AWP — редкий тяжёлый выстрел, пулемёт бьёт часто и ровно.',
    howtoSlide3Title: 'Читай соперника',
    howtoSlide3Text:
      'Каждый раунд выбираешь стойку. Смотри, что соперник делал в прошлом раунде — и контри его.',
    howtoSlide4Title: 'Скин — по вкладу',
    howtoSlide4Text:
      'Банк делится по урону и утилите, а выплачивается скином нужной стоимости. Даже если погиб — вклад засчитан. Банк набирается прокрутами всех билетов: победа приносит скин стоимостью минимум вход +50%, потолок — ×5.',
    howtoTryBots: 'Сначала попробуй бесплатно — с ботами',
    howtoLoopTitle: 'Как проходит матч',
    howtoLoopStep1: 'Выбираешь билет, сторону и формат — это твой вход в матч.',
    howtoLoopStep2: 'Закуп: оружие, броня и утилита на равный бюджет.',
    howtoLoopStep3: 'Пошаговый бой: каждый раунд — стойка или действие. Цель выбираешь тапом.',
    howtoLoopStep4: 'Банк матча делится между победителями по вкладу и выплачивается скином.',
    howtoStancesTitle: 'Стойки',
    howtoRpsCaption: 'Стрелка показывает, кто кого бьёт',
    howtoStancesText:
      '[[defense|Защита]] отражает часть урона, [[maneuver|Манёвр]] сбивает точность врага, [[attack|Атака]] усиливает твой огонь.',
    howtoWeaponsTitle: 'Оружие',
    howtoWeaponAwp: 'AWP — всё или ничего: редкий выстрел, огромный крит.',
    howtoWeaponRifle: 'Винтовка — сбалансированная классика.',
    howtoWeaponLmg: 'Пулемёт — часто и ровно, без качелей крита.',
    howtoUtilityTitle: 'Утилита',
    howtoSmokeTargetNote: 'Дым прикрывает союзника — тапни своего, чтобы выбрать, кого закрыть.',
    howtoUtilTeamNote: 'Дым и флешка — только в командных режимах.',
    howtoMoneyTitle: 'Деньги',
    howtoMoney1: 'Бюджет закупа у всех равный — он решает стиль, а не силу.',
    howtoMoney2: 'Приз — скин, он делится по вкладу: урон + утилита. Смерть вклад не стирает.',
    howtoMoney3: 'Банк набирается прокрутами всех билетов: победа приносит скин стоимостью минимум вход +50%, потолок — ×5.',
    howtoMoney4: 'Каждый билет — один прокрут банка: от половины до 2.5 билета за прокрут. Дороже билет — больше банк.',
    history: 'История',
    partyJoin: 'Войти по коду',
    partyJoinPlaceholder: 'Код пати',
    partyJoinAction: 'Войти',
    partyShare: 'Позвать друзей',
    partyKick: 'Убрать из пати',
    partyShareText: 'Залетай ко мне в пати SHOT — код {{code}}',
    partyErrNotFound: 'Пати не найдена — проверь код.',
    partyErrInGame: 'Пати уже в игре — сначала закончи её.',
    partyErrFull: 'Пати заполнена.',
    partyErrInMatch: 'Сначала закончи активный матч.',
    multiaccErr: 'Ты не можешь присоединиться сюда.',
    maintenanceErr: 'Идёт обновление игры — загляни через пару минут.',
    balanceErr: 'Не хватает монет на вход — пополни баланс и возвращайся.',
    topUpBalance: 'Пополнить баланс',
    maintenanceBanner: 'Идёт обновление игры — матчи откроются через пару минут.',
    updateBanner: 'Вышло обновление — обнови, чтобы играть.',
    updateNow: 'Обновить',
    comingSoonBadge: 'Скоро',
    comingSoonHint: 'Режим ещё не открыт — следи за новостями.',
    partyLeaderTag: 'лидер',
    partyLeave: 'Выйти из пати',
    partyCodeLabel: 'Код пати',
    partyCopy: 'Копировать',
    partyCopied: 'Скопировано',
    partyCreatedBy: 'Создано {{name}}',
    partyLeaderBadge: 'Лидер',
    partyReadyYes: 'Готов',
    partyReadyNo: 'Не готов',
    partyWaitingOthers: 'Ожидает остальных игроков',
    partyConfirmReady: 'Подтверди готовность, чтобы начать игру.',
    partyImReady: 'Я готов',
    partyYou: 'Ты',
    partyShareBtn: 'Поделиться',
    partyReadyCount: 'Готово: {{n}} из {{m}}',
    mode1: '1 на 1',
    mode2: '2 на 2',
    mode5: '5 на 5',
    modeN: '{{size}} на {{size}}',
    gamesTab: 'Игры',
    introCard: 'Rush Mid — это игровой аналог кейс-баттлов в стиле Counter-Strike: игроки заходят в матч с фиксированным билетом, сражаются между собой, и победители делят банк по вкладу — каждый получает скин на стоимость своей доли.',
    openGamesTitle: 'Открытые игры',
    howToPlayLink: 'как играть',
    winUpToPrefix: 'за победу до',
    winUpToSuffix: '',
    waitingForPlayer: 'ждём игрока…',
    winRangeChip: 'за победу',
    notEnoughShort: 'не хватает',
    homeAllGames: 'все игры',
    createGame: 'Создать игру · ',
    createGameShort: 'Создать игру',
    gamesEmptyTitle: 'Здесь пока пусто',
    gamesEmpty: 'Открытых игр пока нет — создай первую',
    gamesBack: 'К списку игр',
    openGameTitle: 'Игра',
    joinSide: 'Сесть',
    confirmSitTitle: 'Сесть в игру',
    confirmSitMessage: 'Сесть в игру за {{amount}}?',
    confirmSitYes: 'Сесть',
    gameFull: 'Все места заняты',
    partyBadge: 'пати ×{{k}}',
    tabFighter: 'Боец',
    squadTitle: 'Пати',
    inviteFriends: 'Позвать друзей',
    leaderPicking: 'Лидер выбирает игру…',
    partyWontFit: 'пати ×{{k}} не влезет',
    graceLockedBadge: 'игра новичка · {{s}} с',
    graceLockedHint: 'Тут разминается новичок. Для всех откроется через {{s}} с.',
    partyFits: 'пати ×{{k}} влезет',
    wontFit: 'не влезет',
    memberBadge: 'В пати ×{{k}}',
    createSheetTitle: 'Создать игру',
    createSheetSubtitle: 'Выбери билет, формат и сторону',
    botFillIn: 'Боты добьют через {{s}} с',
    leaveGame: 'Выйти',
    youLabel: 'ты',
    gameInvite: 'Пригласить',
    gameShareText: 'Залетай ко мне в игру Rush Mid',
    gameShareButton: 'Играть',
    replayTitle: 'Реплей матча',
    shareReplay: 'Поделиться реплеем',
    replayShareText: 'Зацени этот матч в Rush Mid',
    replayShareButton: 'Смотреть реплей',
    gameGone: 'Эта игра уже началась или закрылась',
    tipLabel: 'Совет',
    preparing: 'Готовим бой…',
    loadingGame: 'Загружаем бой…',
    loading: 'Загрузка…',
    errorTitle: 'Ошибка RushMid',
    backToLobby: 'К играм',
    reloadScreen: 'Обновить экран',
    buyTitle: 'Закуп',
    remaining: 'Осталось',
    yourFighter: 'Твой боец',
    hp: 'HP',
    armorShort: 'бр.',
    weapon: 'Оружие',
    armor: 'Броня',
    grenade: 'Граната',
    grenadeTaken: 'Взята',
    medkit: 'Аптечка',
    accuracy: 'Точность',
    stance: 'Стойка',
    stanceCenter: 'Центр',
    stanceAttack: 'Атака',
    stanceDefense: 'Защита',
    stanceManeuver: 'Манёвр',
    knife: 'Нож',
    smoke: 'Дым',
    flash: 'Флешка',
    nadeSmoke: 'Дымовая',
    nadeFrag: 'Осколочная',
    logSmoke: 'дым',
    logAdrenaline: 'адреналин',
    adrenaline: 'адреналин',
    afkBadge: 'AFK',
    afkWarn: 'Ещё один пропуск — останешься без выигрыша',
    fire: 'Огонь',
    pickAlly: 'Выбери своего',
    pickEnemy: 'Выбери врага',
    confirmAction: 'В бой',
    waiting: 'Ждём…',
    choosing: 'Выбирает…',
    watchingReplay: 'Смотрим…',
    youWin: 'Победа',
    youLose: 'Поражение',
    sideWins: 'ПОБЕДА',
    matchDraw: 'Ничья',
    drawRefund: 'Монеты возвращены',
    botShort: 'Бот',
    copyMatchId: 'Копировать ID матча',
    matchIdCopied: 'Скопировано',
    roundN: 'Раунд {{round}}',
    autoStart: 'Старт через',
    grenadeNone: 'Нет',
    allies: 'Союзники',
    enemies: 'Враги',
    loadout: 'Закуп',
    toBattle: 'В бой',
    toBattleIn: 'В бой через {{sec}} сек',
    statDamage: 'Урон',
    statRate: 'Темп',
    statCrit: 'Крит',
    statAccuracy: 'Точность',
    weaponAwp: 'AWP',
    weaponRifle: 'Автомат',
    weaponLmg: 'Пулемёт',
    weaponAwpBlurb: 'Бьёт сильно, но редко. Высокий крит — либо выносит, либо мажет.',
    weaponRifleBlurb: 'Сбалансированный урон и темп.',
    weaponLmgBlurb: 'Часто, но слабо. Ровно набивает урон.',
    armorNone: 'Без брони',
    armorLight: 'Лёгкий жилет',
    armorHeavy: 'Тяжёлый жилет',
    armorNoneBlurb: 'Максимум огневой мощи, но хрупкий.',
    armorLightBlurb: 'Немного режет урон и крит.',
    armorHeavyBlurb: 'Сильно режет пиковый урон и крит — против AWP.',
    armorNumbers: '{{points}} очков брони · пуля −30% урона, крит пробивает',
    gearInfoOpen: 'Как работает?',
    gearInfoTitle: 'Снаряжение в цифрах',
    gearFragInfo: 'До {{max}} урона по цели — броня не спасает; осколок задевает ещё одного врага. По [[defense|Защите]] ×1.35, по [[maneuver|Манёвру]] ×0.8.',
    gearSmokeInfo: 'Дым на союзника: {{rounds}} раунда он получает −{{mit}}% урона от пуль. Нож и граната дым игнорируют.',
    gearFlashInfo: 'Слепит до 3 врагов на {{rounds}} раунда: точность вдвое ниже, крита нет.',
    gearMedkitInfo: 'Лечит {{frac}}% нехватки HP (минимум {{floor}}). В этот раунд ты не стреляешь и открыт для ножа.',
    gearKnifeInfo: 'Бесплатный, каждый раунд. Цель не стреляет или сидит в [[defense|Защите]] — {{dmg}} сквозь броню, при HP ≤ 30% — казнь. Цель в [[attack|Атаке]] или [[maneuver|Манёвре]] — всего {{weak}}, и ты ловишь её выстрел в упор.',
    resultWin: 'Победа',
    resultTeamWin: 'Команда победила',
    resultDefeat: 'Поражение',
    resultWinSub: 'Команда победила — ты получаешь скин на стоимость своей доли банка, по вкладу (MVP).',
    resultTeamWinSub: 'Команда победила. Боец пал, но ты всё равно получил скин по своей доле — по вкладу (MVP).',
    resultDefeatSub: 'Команда проиграла — в следующий раз повезёт.',
    scoreboardTitle: 'Таблица',
    payout: 'Выигрыш',
    total: 'Итог',
    again: 'Ещё раз',
    wonShort: 'Победили',
    viewLog: 'Посмотреть лог',
    roundLog: 'Лог',
    roundLogTitle: 'Ход боя',
    roundLogEmpty: 'Первый раунд ещё идёт',
    raffleTicketsTitle: '+{{n}} билетов розыгрыша',
    raffleChipWin: 'Победа +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Трипл +{{n}}',
    raffleChipQuad: 'Квадра +{{n}}',
    raffleChipAce: 'Эйс +{{n}}',
    raffleChipOneHp: 'Победа с 1 HP +{{n}}',
    raffleChipClutch2: 'Клатч 1v2 +{{n}}',
    raffleChipClutch3: 'Клатч 1v3 +{{n}}',
    dropRevealTapHint: 'Нажми, чтобы продолжить',
    dropYouTitle: 'Твой дроп',
    dropLabel: 'Дроп',
    watch: 'Посмотреть',
    liveNowTitle: 'Идут сейчас',
    liveEmpty: 'Сейчас никто не играет',
    liveRoundBadge: 'Идёт бой · раунд {{n}}',
    spectate: 'Смотреть',
    matchOver: 'Матч завершён',
    logMiss: 'мимо',
    logMissEvade: 'мимо — уворот',
    logMissBlind: 'мимо — ослеплён',
    logReflect: 'отражено',
    logPunish: 'ответный огонь',
    logLegend: '✦ крит пробивает броню · ⚡ адреналин',
    logKilledBy: 'убил',
    colKills: 'К',
    canvasMiss: 'МИМО',
    canvasMissEvade: 'УВОРОТ',
    canvasMissBlind: 'ОСЛЕП',
    historyTitle: 'История',
    back: 'Назад',
    matchDetailError: 'Не получилось загрузить матч. Возможно, записи нет — тренировка с ботами не сохраняется.',
    historySubtitle: 'Твои последние бои в Rush Mid.',
    historyEmptyTitle: 'Ты ещё не играл',
    historyEmptyDescription: 'Сыграй первый бой в Rush Mid — он появится здесь.',
    win: 'Победа',
    defeat: 'Поражение',
    timeJustNow: 'только что',
    timeMinAgo: '{{min}} мин назад',
    timeHoursAgo: '{{hours}} ч назад',
    timeDaysAgo: '{{days}} дн назад',
    ratingTab: 'Рейтинг',
    yourRating: 'Твой рейтинг',
    earned: 'Заработано',
    rating: 'Рейтинг',
    played: 'Сыграно',
    wins: 'Побед',
    winsCol: 'Победы',
    losses: 'Поражений',
    lossesCol: 'Поражения',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Винрейт',
    player: 'Игрок',
    topPlayers: 'Топ игроков',
    ratingUnratedTitle: 'Рейтинга пока нет',
    ratingUnratedDescription: 'Сыграй матч в этом формате, чтобы получить рейтинг.',
    ratingEmptyTitle: 'Здесь пока пусто',
    ratingEmptyDescription: 'Сыграй первым в этом формате.',
    raffleTab: 'Розыгрыш',
  },
  uz: {
    lobbyTitle: 'Rush Mid',
    ticket: 'Bilet',
    format: 'Format',
    side: 'Tomon',
    sideCt: 'Kontr-terrorchilar',
    sideT: 'Terrorchilar',
    sideAny: 'Har qanday',
    skinLabel: 'Skin',
    practiceBots: "Botlar bilan",
    playWithBots: 'Botlar bilan oʻynash · bepul',
    winRangeTitle: 'Gʻalaba uchun skin',
    skip: 'Oʻtkazib yuborish',
    howtoTitle: 'Qanday oʻynash',
    howtoNext: 'Keyingi',
    howtoStart: 'Tushunarli, oʻynaymiz',
    howtoSkip: 'Oʻtkazib yuborish',
    howtoSlide1Title: 'Navbatma-navbat PvP',
    howtoSlide1Text:
      'Bilet — sening kirishing. Raqiblar — xuddi shu biletli haqiqiy oʻyinchilar. Gʻolib jamoa bankni boʻlishadi.',
    howtoSlide2Title: 'Xarid hal qilmaydi',
    howtoSlide2Text:
      'Hammada bir xil byudjet. Qurol uslubni belgilaydi: AWP — kam otadigan ogʻir zarba, pulemyot tez va barqaror otadi.',
    howtoSlide3Title: 'Raqibni oʻqi',
    howtoSlide3Text:
      'Har raundda turish tanlaysan. Raqib oʻtgan raundda nima qilganini koʻr — va unga qarshi oʻyna.',
    howtoSlide4Title: 'Skin — hissaga koʻra',
    howtoSlide4Text:
      'Bank zarar va utilita boʻyicha boʻlinadi, soʻng shu qiymatdagi skin sifatida beriladi. Oʻlsang ham hissang hisobda. Bank har biletning aylanishidan toʻladi: gʻalaba kamida kirish +50% qiymatidagi skin beradi, shift — ×5.',
    howtoTryBots: 'Avval bepul sinab koʻr — botlar bilan',
    howtoLoopTitle: 'Match qanday oʻtadi',
    howtoLoopStep1: 'Bilet, tomon va formatni tanlaysan — bu sening kirishing.',
    howtoLoopStep2: "Xarid: teng byudjetga qurol, zirh va utilita.",
    howtoLoopStep3: "Navbatma-navbat jang: har raund — turish yoki harakat. Nishonni tap bilan tanlaysan.",
    howtoLoopStep4: 'Match banki gʻoliblar orasida hissaga koʻra boʻlinadi va skin sifatida beriladi.',
    howtoStancesTitle: 'Turishlar',
    howtoRpsCaption: 'Strelka kim kimni yengishini koʻrsatadi',
    howtoStancesText:
      "[[defense|Himoya]] zararning bir qismini qaytaradi, [[maneuver|Manyovr]] dushman aniqligini pasaytiradi, [[attack|Hujum]] otishingni kuchaytiradi.",
    howtoWeaponsTitle: 'Qurollar',
    howtoWeaponAwp: "AWP — hammasi yoki hech narsa: kam otadi, ulkan krit.",
    howtoWeaponRifle: 'Vintovka — muvozanatli klassika.',
    howtoWeaponLmg: "Pulemyot — tez va barqaror, krit tebranishlarisiz.",
    howtoUtilityTitle: 'Utilita',
    howtoSmokeTargetNote: "Tutun sherikni yopadi — kimni yopishni sherikni tap qilib tanlaysan.",
    howtoUtilTeamNote: "Tutun va flesh faqat jamoaviy rejimlarda bor.",
    howtoMoneyTitle: 'Pul',
    howtoMoney1: "Xarid byudjeti hammada teng — u uslubni belgilaydi, kuchni emas.",
    howtoMoney2: 'Mukofot — skin, u hissaga koʻra boʻlinadi: zarar + utilita. Oʻlim hissani oʻchirmaydi.',
    howtoMoney3: 'Bank har biletning aylanishidan toʻladi: gʻalaba kamida kirish +50% qiymatidagi skin beradi, shift — ×5.',
    howtoMoney4: "Har bilet — bankning bitta aylanishi: har aylanishda yarmidan 2.5 biletgacha. Bilet qimmatroq — bank kattaroq.",
    history: 'Tarix',
    partyJoin: 'Kod bilan kirish',
    partyJoinPlaceholder: 'Parti kodi',
    partyJoinAction: 'Kirish',
    partyShare: 'Doʻstlarni chaqirish',
    partyKick: 'Partiyadan chiqarish',
    partyShareText: 'SHOT partimga qoʻshil — kod {{code}}',
    partyErrNotFound: 'Parti topilmadi — kodni tekshir.',
    partyErrInGame: 'Bu parti allaqachon oʻyinda — avval uni tugatinglar.',
    partyErrFull: 'Parti toʻlgan.',
    partyErrInMatch: 'Avval faol matchni tugat.',
    multiaccErr: 'Bu yerga qoʻshila olmaysan.',
    maintenanceErr: 'Oʻyin yangilanmoqda — bir-ikki daqiqadan soʻng qaytib kel.',
    balanceErr: 'Kirish uchun tanga yetmaydi — balansni toʻldirib qayt.',
    topUpBalance: 'Balansni toʻldirish',
    maintenanceBanner: 'Oʻyin yangilanmoqda — oʻyinlar bir-ikki daqiqada ochiladi.',
    updateBanner: 'Yangilanish chiqdi — oʻynash uchun yangila.',
    updateNow: 'Yangilash',
    comingSoonBadge: 'Tez orada',
    comingSoonHint: 'Rejim hali ochilmadi — kuzatib bor.',
    partyLeaderTag: 'lider',
    partyLeave: 'Partidan chiqish',
    partyCodeLabel: 'Parti kodi',
    partyCopy: 'Nusxa olish',
    partyCopied: 'Nusxa olindi',
    partyCreatedBy: '{{name}} yaratdi',
    partyLeaderBadge: 'Lider',
    partyReadyYes: 'Tayyor',
    partyReadyNo: 'Tayyor emas',
    partyWaitingOthers: 'Qolgan oʻyinchilar kutilyapti',
    partyConfirmReady: 'Boshlash uchun tayyorligingni tasdiqla.',
    partyImReady: 'Men tayyorman',
    partyYou: 'Sen',
    partyShareBtn: 'Ulashish',
    partyReadyCount: 'Tayyor: {{n}}/{{m}}',
    mode1: '1 ga 1',
    mode2: '2 ga 2',
    mode5: '5 ga 5',
    modeN: '{{size}} ga {{size}}',
    gamesTab: 'Oʻyinlar',
    introCard: 'Rush Mid — Counter-Strike uslubidagi keys-battl oʻyini: oʻyinchilar belgilangan bilet bilan matchga kiradi, bir-biri bilan jang qiladi va gʻoliblar bankni hissaga koʻra boʻlishadi — har biri oʻz ulushi qiymatidagi skin oladi.',
    openGamesTitle: 'Ochiq oʻyinlar',
    howToPlayLink: 'qanday oʻynaladi',
    winUpToPrefix: 'gʻalaba uchun',
    winUpToSuffix: 'gacha',
    waitingForPlayer: 'oʻyinchini kutamiz…',
    winRangeChip: 'gʻalaba uchun',
    notEnoughShort: 'yetmaydi:',
    homeAllGames: 'barcha oʻyinlar',
    createGame: 'Oʻyin yaratish · ',
    createGameShort: 'Oʻyin yaratish',
    gamesEmptyTitle: 'Hozircha boʻsh',
    gamesEmpty: 'Hali ochiq oʻyinlar yoʻq — birinchisini yarat',
    gamesBack: "Oʻyinlar roʻyxatiga",
    openGameTitle: "Oʻyin",
    joinSide: 'Oʻtirish',
    confirmSitTitle: 'Oʻyinga qoʻshilish',
    confirmSitMessage: '{{amount}} evaziga oʻtirasanmi?',
    confirmSitYes: 'Oʻtirish',
    gameFull: 'Barcha joylar band',
    partyBadge: 'parti ×{{k}}',
    tabFighter: 'Jangchi',
    squadTitle: 'Parti',
    inviteFriends: 'Doʻstlarni chaqirish',
    leaderPicking: 'Lider oʻyin tanlayapti…',
    partyWontFit: 'parti ×{{k}} sigʻmaydi',
    graceLockedBadge: 'yangi oʻyinchi · {{s}} s',
    graceLockedHint: 'Bu yerda yangi oʻyinchi qizdirmoqda. Hamma uchun {{s}} s dan keyin ochiladi.',
    partyFits: 'parti ×{{k}} sigʻadi',
    wontFit: 'sigʻmaydi',
    memberBadge: 'Parti ×{{k}}',
    createSheetTitle: 'Oʻyin yaratish',
    createSheetSubtitle: 'Bilet, format va tomonni tanla',
    botFillIn: 'Botlar {{s}} s dan keyin toʻldiradi',
    leaveGame: 'Chiqish',
    youLabel: 'sen',
    gameInvite: 'Taklif qilish',
    gameShareText: "Rush Mid oʻyinimga qoʻshil",
    gameShareButton: 'Oʻynash',
    replayTitle: 'Match replayi',
    shareReplay: 'Replayni ulashish',
    replayShareText: 'Bu Rush Mid matchiga qara',
    replayShareButton: "Replayni koʻrish",
    gameGone: 'Bu oʻyin allaqachon boshlangan yoki yopilgan',
    tipLabel: 'Maslahat',
    preparing: 'Jang tayyorlanmoqda…',
    loadingGame: 'Jang yuklanmoqda…',
    loading: 'Yuklanmoqda…',
    errorTitle: 'RushMid xatosi',
    backToLobby: 'Oʻyinlarga qaytish',
    reloadScreen: 'Ekranni yangilash',
    buyTitle: 'Xarid',
    remaining: 'Qoldi',
    yourFighter: 'Sening jangching',
    hp: 'HP',
    armorShort: 'zirh',
    weapon: 'Qurol',
    armor: 'Zirh',
    grenade: 'Granata',
    grenadeTaken: 'Olindi',
    medkit: 'Aptechka',
    accuracy: 'Aniqlik',
    stance: 'Holat',
    stanceCenter: 'Markaz',
    stanceAttack: 'Hujum',
    stanceDefense: 'Himoya',
    stanceManeuver: 'Manyovr',
    knife: 'Pichoq',
    smoke: 'Tutun',
    flash: 'Flesh',
    nadeSmoke: 'Tutun',
    nadeFrag: 'Oskolka',
    logSmoke: 'tutun',
    logAdrenaline: 'adrenalin',
    adrenaline: 'adrenalin',
    afkBadge: 'AFK',
    afkWarn: 'Yana bir raundni oʻtkazib yuborsang — yutuqsiz qolasan',
    fire: 'Otish',
    pickAlly: 'Sherikni tanla',
    pickEnemy: 'Dushmanni tanla',
    confirmAction: 'Jangga',
    waiting: 'Kutilmoqda…',
    choosing: 'Tanlamoqda…',
    watchingReplay: 'Koʻrilmoqda…',
    youWin: 'Gʻalaba',
    youLose: 'Magʻlubiyat',
    sideWins: 'YUTDI',
    matchDraw: 'Durang',
    drawRefund: 'Tangalar qaytarildi',
    botShort: 'Bot',
    copyMatchId: 'Match ID nusxa',
    matchIdCopied: 'Nusxa olindi',
    roundN: 'Raund {{round}}',
    autoStart: 'Avtostart',
    grenadeNone: 'Yoʻq',
    allies: 'Ittifoqchilar',
    enemies: 'Raqiblar',
    loadout: 'Jihoz',
    toBattle: 'Jangga',
    toBattleIn: '{{sec}}s dan keyin jangga',
    statDamage: 'Zarar',
    statRate: 'Temp',
    statCrit: 'Krit',
    statAccuracy: 'Aniqlik',
    weaponAwp: 'AWP',
    weaponRifle: 'Avtomat',
    weaponLmg: 'Pulemyot',
    weaponAwpBlurb: 'Kuchli uradi, lekin kamdan-kam. Yuqori krit — yo oʻldiradi, yo tegmaydi.',
    weaponRifleBlurb: 'Muvozanatli zarar va oʻq otish tezligi.',
    weaponLmgBlurb: 'Tez-tez, lekin kuchsiz. Bir tekisda zarar toʻplaydi.',
    armorNone: 'Zirhsiz',
    armorLight: 'Yengil jilet',
    armorHeavy: 'Ogʻir jilet',
    armorNoneBlurb: 'Maksimal oʻt kuchi, lekin moʻrt.',
    armorLightBlurb: 'Zarar va kritni biroz kamaytiradi.',
    armorHeavyBlurb: 'Choʻqqi zarar va kritni kuchli kamaytiradi — AWPga qarshi.',
    armorNumbers: '{{points}} bron ochkosi · oʻq −30% zarar, krit teshib oʻtadi',
    gearInfoOpen: 'Qanday ishlaydi?',
    gearInfoTitle: 'Jihozlar raqamlarda',
    gearFragInfo: 'Nishonga {{max}} gacha zarar — bron qutqarmaydi; parcha yana bitta dushmanga tegadi. [[defense|Himoyaga]] ×1.35, [[maneuver|Manyovrga]] ×0.8.',
    gearSmokeInfo: 'Tutun sherikka: {{rounds}} raund davomida oʻqdan −{{mit}}% zarar oladi. Pichoq va granata tutunni pisand qilmaydi.',
    gearFlashInfo: '{{rounds}} raundga 3 tagacha dushmanni koʻr qiladi: aniqlik ikki baravar past, krit yoʻq.',
    gearMedkitInfo: 'Yetishmayotgan HP ning {{frac}}% ini davolaydi (kamida {{floor}}). Bu raundda otmaysan va pichoqqa ochiqsan.',
    gearKnifeInfo: 'Bepul, har raund. Nishon otmayotgan yoki [[defense|Himoyada]] boʻlsa — bron orqali {{dmg}}, HP ≤ 30% da qatl. [[attack|Hujum]] yoki [[maneuver|Manyovrda]] boʻlsa — bor-yoʻgʻi {{weak}}, ustiga uning oʻqini yaqindan yeysan.',
    resultWin: 'Gʻalaba',
    resultTeamWin: 'Jamoa gʻalaba qozondi',
    resultDefeat: 'Magʻlubiyat',
    resultWinSub: 'Jamoa gʻalaba qozondi — hissangga koʻra ulushing qiymatidagi skinni olasan (MVP).',
    resultTeamWinSub: 'Jamoa gʻalaba qozondi. Jangching halok boʻldi, lekin hissangga koʻra skin ulushini olding (MVP).',
    resultDefeatSub: "Jamoa yutqazdi — keyingi safar omad kulib boqadi.",
    scoreboardTitle: 'Jadval',
    payout: 'Yutuq',
    total: 'Yakun',
    again: 'Yana bir bor',
    wonShort: 'Yutdi',
    viewLog: "Logni koʻrish",
    roundLog: 'Log',
    roundLogTitle: 'Jang jarayoni',
    roundLogEmpty: 'Birinchi raund hali davom etmoqda',
    raffleTicketsTitle: '+{{n}} yutuq bileti',
    raffleChipWin: 'Gʻalaba +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triple +{{n}}',
    raffleChipQuad: 'Quad +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: '1 HP bilan gʻalaba +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    dropRevealTapHint: 'Davom etish uchun bos',
    dropYouTitle: 'Sening droping',
    dropLabel: 'Drop',
    watch: "Koʻrish",
    liveNowTitle: 'Hozir ketmoqda',
    liveEmpty: 'Hozir hech kim oʻynamayapti',
    liveRoundBadge: 'Jang ketmoqda · raund {{n}}',
    spectate: "Koʻrish",
    matchOver: 'Match tugadi',
    logMiss: 'tegmadi',
    logMissEvade: 'tegmadi — chap berdi',
    logMissBlind: 'tegmadi — koʻr boʻlgan',
    logReflect: 'qaytarildi',
    logPunish: 'javob oʻqi',
    logLegend: '✦ krit bronni teshadi · ⚡ adrenalin',
    logKilledBy: "oʻldirdi",
    colKills: 'K',
    canvasMiss: 'TEGMADI',
    canvasMissEvade: 'CHAP BERDI',
    canvasMissBlind: 'KOʻR',
    historyTitle: 'Tarix',
    back: 'Orqaga',
    matchDetailError: 'Matchni yuklab boʻlmadi. Yozuv yoʻq boʻlishi mumkin — botlar bilan mashq saqlanmaydi.',
    historySubtitle: 'Sening Rush Midʼdagi soʻnggi janglaring.',
    historyEmptyTitle: 'Sen hali oʻynamagansan',
    historyEmptyDescription: 'Rush Midʼda birinchi jangingni oʻyna — u shu yerda paydo boʻladi.',
    win: 'Gʻalaba',
    defeat: 'Magʻlubiyat',
    timeJustNow: 'hozirgina',
    timeMinAgo: '{{min}} daq oldin',
    timeHoursAgo: '{{hours}} soat oldin',
    timeDaysAgo: '{{days}} kun oldin',
    ratingTab: 'Reyting',
    yourRating: 'Sening reytinging',
    earned: 'Ishlangan',
    rating: 'Reyting',
    played: 'Oʻynaldi',
    wins: 'Gʻalabalar',
    winsCol: 'Gʻalabalar',
    losses: 'Magʻlubiyatlar',
    lossesCol: 'Magʻlubiyatlar',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Gʻalaba %',
    player: 'Oʻyinchi',
    topPlayers: 'Eng yaxshi oʻyinchilar',
    ratingUnratedTitle: 'Hali reyting yoʻq',
    ratingUnratedDescription: 'Reyting olish uchun bu formatda oʻyna.',
    ratingEmptyTitle: 'Hali boʻsh',
    ratingEmptyDescription: 'Bu formatda birinchi boʻlib oʻyna.',
    raffleTab: 'Yutuq',
  },
  fa: {
    lobbyTitle: 'Rush Mid',
    ticket: 'بلیت',
    format: 'قالب',
    side: 'تیم',
    sideCt: 'کانتر-تروریست',
    sideT: 'تروریست',
    sideAny: 'فرقی ندارد',
    skinLabel: 'اسکین',
    practiceBots: 'مقابل بات',
    playWithBots: 'بازی با بات · رایگان',
    winRangeTitle: 'اسکین برای برد',
    skip: 'رد کن',
    howtoTitle: 'چطور بازی کنیم',
    howtoNext: 'بعدی',
    howtoStart: 'فهمیدم، بریم',
    howtoSkip: 'رد کن',
    howtoSlide1Title: 'PvP نوبتی',
    howtoSlide1Text:
      'بلیت ورودی توست. حریف‌ها بازیکن‌های واقعی با همان بلیت‌اند. تیم برنده بانک را تقسیم می‌کند.',
    howtoSlide2Title: 'خرید تعیین‌کننده نیست',
    howtoSlide2Text:
      'بودجه همه یکی است. سلاح سبک بازی را می‌سازد: AWP شلیک سنگین و کم‌شمار است، مسلسل زیاد و یکنواخت می‌زند.',
    howtoSlide3Title: 'حریفت را بخوان',
    howtoSlide3Text: 'هر راند یک ژست انتخاب می‌کنی. ببین حریفت راند قبل چه کرد — و جوابش را بده.',
    howtoSlide4Title: 'اسکین به نسبت سهم',
    howtoSlide4Text:
      'بانک بر پایه دمیج و آیتم تقسیم می‌شود و به شکل اسکینی به ارزش سهم تو پرداخت می‌شود. حتی اگر بمیری، سهمت حساب است. بانک از چرخش هر بلیت پر می‌شود — برد دست‌کم اسکینی به ارزش ورودی +50% می‌دهد، سقف ×5 است.',
    howtoTryBots: 'اول رایگان امتحان کن — مقابل بات',
    howtoLoopTitle: 'یک مسابقه چطور می‌گذرد',
    howtoLoopStep1: 'بلیت، تیم و قالب را انتخاب کن — این ورودی توست.',
    howtoLoopStep2: 'مرحله خرید: سلاح، جلیقه و آیتم با بودجه برابر.',
    howtoLoopStep3: 'نبرد نوبتی: هر راند یک ژست یا یک کار. هدفت را با یک لمس انتخاب کن.',
    howtoLoopStep4: 'بانک مسابقه به نسبت سهم بین برنده‌ها تقسیم و به شکل اسکین پرداخت می‌شود.',
    howtoStancesTitle: 'ژست‌ها',
    howtoRpsCaption: 'فلش نشان می‌دهد چه چیزی چه چیزی را می‌برد',
    howtoStancesText:
      '[[defense|دفاع]] بخشی از دمیج را برمی‌گرداند، [[maneuver|جاخالی]] دقت دشمن را کم می‌کند، [[attack|حمله]] آتش تو را بیشتر می‌کند.',
    howtoWeaponsTitle: 'سلاح‌ها',
    howtoWeaponAwp: 'AWP — همه یا هیچ: شلیک کم، کریت سنگین.',
    howtoWeaponRifle: 'رایفل — کلاسیک متعادل.',
    howtoWeaponLmg: 'مسلسل — زیاد و یکنواخت، بدون نوسان کریت.',
    howtoUtilityTitle: 'آیتم‌ها',
    howtoSmokeTargetNote: 'دود روی هم‌تیمی می‌نشیند — یکی را لمس کن تا زیر پوششش بگیری.',
    howtoUtilTeamNote: 'دود و فلش فقط در حالت‌های تیمی هستند.',
    howtoMoneyTitle: 'پول',
    howtoMoney1: 'بودجه خرید برای همه برابر است — سبک را می‌سازد، نه قدرت را.',
    howtoMoney2: 'جایزه اسکینی است که به نسبت سهم تقسیم می‌شود: دمیج + آیتم. مردن پاکش نمی‌کند.',
    howtoMoney3: 'بانک از چرخش هر بلیت پر می‌شود: برد دست‌کم اسکینی به ارزش ورودی +50% می‌دهد، سقف ×5 است.',
    howtoMoney4: 'هر بلیت یک چرخش بانک است — از نصف تا 2.5 برابر بلیت در هر چرخش. بلیت گران‌تر — بانک بزرگ‌تر.',
    history: 'تاریخچه',
    partyJoin: 'ورود با کد',
    partyJoinPlaceholder: 'کد پارتی',
    partyJoinAction: 'وارد شو',
    partyShare: 'دعوت دوستان',
    partyKick: 'حذف از پارتی',
    partyShareText: 'به پارتی من در SHOT بیا — کد {{code}}',
    partyErrNotFound: 'پارتی پیدا نشد — کد را بررسی کن.',
    partyErrInGame: 'آن پارتی در بازی است — اول تمامش کن.',
    partyErrFull: 'آن پارتی پر است.',
    partyErrInMatch: 'اول مسابقه فعالت را تمام کن.',
    multiaccErr: 'نمی‌توانی اینجا وارد شوی.',
    maintenanceErr: 'بازی در حال به‌روزرسانی است — چند دقیقه دیگر سر بزن.',
    balanceErr: 'سکه برای ورودی کافی نیست — موجودیت را شارژ کن و برگرد.',
    topUpBalance: 'شارژ موجودی',
    maintenanceBanner: 'بازی در حال به‌روزرسانی است — مسابقه‌ها چند دقیقه دیگر باز می‌شوند.',
    updateBanner: 'نسخه تازه آمده — برای ادامه بازی به‌روز کن.',
    updateNow: 'به‌روزرسانی',
    comingSoonBadge: 'به‌زودی',
    comingSoonHint: 'این حالت هنوز باز نشده — منتظر بمان.',
    partyLeaderTag: 'سرگروه',
    partyLeave: 'خروج از پارتی',
    partyCodeLabel: 'کد پارتی',
    partyCopy: 'کپی',
    partyCopied: 'کپی شد',
    partyCreatedBy: 'ساخته {{name}}',
    partyLeaderBadge: 'سرگروه',
    partyReadyYes: 'آماده',
    partyReadyNo: 'آماده نیست',
    partyWaitingOthers: 'منتظر بقیه بازیکن‌ها',
    partyConfirmReady: 'تأیید کن که آماده شروعی.',
    partyImReady: 'آماده‌ام',
    partyYou: 'تو',
    partyShareBtn: 'اشتراک',
    partyReadyCount: 'آماده: {{n}} از {{m}}',
    mode1: '1 v 1',
    mode2: '2 v 2',
    mode5: '5 v 5',
    modeN: '{{size}} v {{size}}',
    gamesTab: 'بازی‌ها',
    introCard:
      'Rush Mid روایت Counter-Strike از نبرد کیس است: بازیکن‌ها با بلیتی ثابت وارد مسابقه می‌شوند، با هم می‌جنگند و برد اسکینی به ارزش سهمی وابسته به قیمت ورودی می‌دهد.',
    openGamesTitle: 'بازی‌های باز',
    howToPlayLink: 'چطور بازی کنیم',
    winUpToPrefix: 'برای برد تا',
    winUpToSuffix: '',
    waitingForPlayer: 'منتظر بازیکن…',
    winRangeChip: 'برد می‌دهد',
    notEnoughShort: 'کم داری',
    homeAllGames: 'همه بازی‌ها',
    createGame: 'ساخت بازی · ',
    createGameShort: 'ساخت بازی',
    gamesEmptyTitle: 'هنوز چیزی اینجا نیست',
    gamesEmpty: 'هنوز بازی بازی نیست — اولی را بساز',
    gamesBack: 'برگشت به بازی‌ها',
    openGameTitle: 'بازی',
    joinSide: 'بنشین',
    confirmSitTitle: 'ورود به بازی',
    confirmSitMessage: 'به {{amount}} بنشینی؟',
    confirmSitYes: 'بنشین',
    gameFull: 'همه صندلی‌ها پر است',
    partyBadge: 'پارتی ×{{k}}',
    tabFighter: 'مبارز',
    squadTitle: 'پارتی',
    inviteFriends: 'دعوت دوستان',
    leaderPicking: 'سرگروه در حال انتخاب بازی است…',
    partyWontFit: 'پارتی ×{{k}} جا نمی‌شود',
    graceLockedBadge: 'بازی تازه‌کار · {{s}} ثانیه',
    graceLockedHint: 'یک تازه‌کار اینجا گرم می‌کند. لابی تا {{s}} ثانیه دیگر برای همه باز می‌شود.',
    partyFits: 'پارتی ×{{k}} جا می‌شود',
    wontFit: 'جا نمی‌شود',
    memberBadge: 'در پارتی ×{{k}}',
    createSheetTitle: 'ساخت بازی',
    createSheetSubtitle: 'بلیت، قالب و تیم را انتخاب کن',
    botFillIn: 'بات‌ها تا {{s}} ثانیه دیگر پر می‌کنند',
    leaveGame: 'خروج',
    youLabel: 'تو',
    gameInvite: 'دعوت',
    gameShareText: 'به بازی Rush Mid من بیا',
    gameShareButton: 'بازی کن',
    replayTitle: 'پخش مسابقه',
    shareReplay: 'اشتراک پخش',
    replayShareText: 'این مسابقه Rush Mid را ببین',
    replayShareButton: 'دیدن پخش',
    gameGone: 'این بازی شروع شده یا بسته شده',
    tipLabel: 'نکته',
    preparing: 'در حال آماده‌سازی نبرد…',
    loadingGame: 'در حال بارگذاری نبرد…',
    loading: 'در حال بارگذاری…',
    errorTitle: 'خطای RushMid',
    backToLobby: 'برگشت به بازی‌ها',
    reloadScreen: 'بارگذاری دوباره صفحه',
    buyTitle: 'خرید',
    remaining: 'باقی‌مانده',
    yourFighter: 'مبارز تو',
    hp: 'HP',
    armorShort: 'جلیقه',
    weapon: 'سلاح',
    armor: 'جلیقه',
    grenade: 'نارنجک',
    grenadeTaken: 'برداشته شد',
    medkit: 'کیت درمان',
    accuracy: 'دقت',
    stance: 'ژست',
    stanceCenter: 'وسط',
    stanceAttack: 'حمله',
    stanceDefense: 'دفاع',
    stanceManeuver: 'جاخالی',
    knife: 'چاقو',
    smoke: 'دود',
    flash: 'فلش',
    nadeSmoke: 'دود',
    nadeFrag: 'ترکشی',
    logSmoke: 'دود',
    logAdrenaline: 'آدرنالین',
    adrenaline: 'آدرنالین',
    afkBadge: 'AFK',
    afkWarn: 'یک راند دیگر را از دست بدهی، بردت را می‌بازی',
    fire: 'شلیک',
    pickAlly: 'یک هم‌تیمی انتخاب کن',
    pickEnemy: 'یک دشمن انتخاب کن',
    confirmAction: 'تأیید',
    waiting: 'در انتظار…',
    choosing: 'در حال انتخاب…',
    watchingReplay: 'در حال تماشا…',
    youWin: 'برد',
    youLose: 'باخت',
    sideWins: 'برد',
    matchDraw: 'مساوی',
    drawRefund: 'سکه‌ها برگشت',
    botShort: 'بات',
    copyMatchId: 'کپی شناسه مسابقه',
    matchIdCopied: 'کپی شد',
    roundN: 'راند {{round}}',
    autoStart: 'شروع خودکار تا',
    grenadeNone: 'ندارد',
    allies: 'هم‌تیمی‌ها',
    enemies: 'دشمن‌ها',
    loadout: 'تجهیزات',
    toBattle: 'به نبرد',
    toBattleIn: 'به نبرد تا {{sec}} ثانیه',
    statDamage: 'دمیج',
    statRate: 'سرعت شلیک',
    statCrit: 'کریت',
    statAccuracy: 'دقت',
    weaponAwp: 'AWP',
    weaponRifle: 'رایفل',
    weaponLmg: 'مسلسل',
    weaponAwpBlurb: 'سنگین می‌زند اما کم. کریت بالا — یا می‌کشد یا خطا می‌رود.',
    weaponRifleBlurb: 'دمیج و سرعت شلیک متعادل.',
    weaponLmgBlurb: 'زیاد اما ضعیف. دمیج را آرام‌آرام بالا می‌برد.',
    armorNone: 'بدون جلیقه',
    armorLight: 'جلیقه سبک',
    armorHeavy: 'جلیقه سنگین',
    armorNoneBlurb: 'بیشترین قدرت آتش، اما شکننده.',
    armorLightBlurb: 'کمی از دمیج و کریت کم می‌کند.',
    armorHeavyBlurb: 'از اوج دمیج و کریت زیاد کم می‌کند — جواب AWP.',
    armorNumbers: '{{points}} امتیاز جلیقه · گلوله −30% دمیج، کریت رد می‌شود',
    gearInfoOpen: 'چطور کار می‌کند',
    gearInfoTitle: 'تجهیزات در عدد',
    gearFragInfo:
      'تا {{max}} دمیج به هدف — جلیقه نجاتش نمی‌دهد؛ ترکش یک دشمن دیگر را هم می‌گیرد. [[defense|دفاع]] ×1.35 می‌خورد، [[maneuver|جاخالی]] ×0.8.',
    gearSmokeInfo: 'دود روی هم‌تیمی: تا {{rounds}} راند −{{mit}}% دمیج گلوله می‌خورد. چاقو و نارنجک دود را نمی‌بینند.',
    gearFlashInfo: 'تا 3 دشمن را {{rounds}} راند کور می‌کند: نصف دقت، بدون کریت.',
    gearMedkitInfo: '{{frac}}% از HP کم‌شده را برمی‌گرداند (دست‌کم {{floor}}). این راند شلیک نمی‌کنی و جلوی چاقو بازی.',
    gearKnifeInfo:
      'رایگان، هر راند. هدفی که شلیک نمی‌کند یا در [[defense|دفاع]] است — {{dmg}} از روی جلیقه، زیر 30% HP اعدام. هدفی در [[attack|حمله]] یا [[maneuver|جاخالی]] — فقط {{weak}}، و آتش نزدیکش را می‌خوری.',
    resultWin: 'برد',
    resultTeamWin: 'تیم برد',
    resultDefeat: 'باخت',
    resultWinSub: 'تیمت برد — اسکینی به ارزش سهمت از بانک می‌گیری، تقسیم‌شده بر پایه سهم (MVP).',
    resultTeamWinSub: 'تیمت برد. مبارزت افتاد، اما باز هم اسکینی به ارزش سهمت گرفتی (MVP).',
    resultDefeatSub: 'تیم باخت — راند بعد شانس بیشتری داری.',
    scoreboardTitle: 'جدول امتیاز',
    payout: 'برد',
    total: 'جمع',
    again: 'دوباره',
    wonShort: 'برد',
    viewLog: 'دیدن لاگ',
    roundLog: 'لاگ',
    roundLogTitle: 'لاگ نبرد',
    roundLogEmpty: 'راند اول هنوز در جریان است',
    raffleTicketsTitle: '+{{n}} بلیت قرعه‌کشی',
    raffleChipWin: 'برد +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'تریپل +{{n}}',
    raffleChipQuad: 'کواد +{{n}}',
    raffleChipAce: 'ایس +{{n}}',
    raffleChipOneHp: 'برد با 1 HP +{{n}}',
    raffleChipClutch2: 'کلاچ 1v2 +{{n}}',
    raffleChipClutch3: 'کلاچ 1v3 +{{n}}',
    dropRevealTapHint: 'برای ادامه لمس کن',
    dropYouTitle: 'دراپ تو',
    dropLabel: 'دراپ',
    watch: 'تماشا',
    liveNowTitle: 'الان زنده',
    liveEmpty: 'الان مسابقه‌ای در جریان نیست',
    liveRoundBadge: 'زنده · راند {{n}}',
    spectate: 'تماشا',
    matchOver: 'مسابقه تمام شد',
    logMiss: 'خطا',
    logMissEvade: 'خطا — جاخالی',
    logMissBlind: 'خطا — کور شده',
    logReflect: 'برگشت داده',
    logPunish: 'آتش متقابل',
    logLegend: '✦ کریت از جلیقه رد می‌شود · ⚡ آدرنالین',
    logKilledBy: 'کشته‌شده توسط',
    colKills: 'K',
    canvasMiss: 'خطا',
    canvasMissEvade: 'جاخالی',
    canvasMissBlind: 'کور',
    historyTitle: 'تاریخچه',
    back: 'برگرد',
    matchDetailError: 'این مسابقه باز نشد. شاید وجود نداشته باشد — تمرین با بات ثبت نمی‌شود.',
    historySubtitle: 'آخرین نبردهای Rush Mid تو.',
    historyEmptyTitle: 'هنوز بازی نکرده‌ای',
    historyEmptyDescription: 'اولین نبرد Rush Mid را بازی کن — همین‌جا نشان داده می‌شود.',
    win: 'برد',
    defeat: 'باخت',
    timeJustNow: 'همین الان',
    timeMinAgo: '{{min}} دقیقه پیش',
    timeHoursAgo: '{{hours}} ساعت پیش',
    timeDaysAgo: '{{days}} روز پیش',
    ratingTab: 'رده‌بندی',
    yourRating: 'رده تو',
    earned: 'کسب‌شده',
    rating: 'رده',
    played: 'بازی‌شده',
    wins: 'برد',
    winsCol: 'برد',
    losses: 'باخت',
    lossesCol: 'باخت',
    playedShort: 'م',
    winsShort: 'ب',
    lossesShort: 'خ',
    winrate: 'نرخ برد',
    player: 'بازیکن',
    topPlayers: 'بهترین بازیکنان',
    ratingUnratedTitle: 'هنوز رده‌ای نداری',
    ratingUnratedDescription: 'برای گرفتن رده در این قالب یک مسابقه بازی کن.',
    ratingEmptyTitle: 'هنوز کسی اینجا نیست',
    ratingEmptyDescription: 'اولین نفری باش که در این قالب بازی می‌کند.',
    raffleTab: 'قرعه‌کشی',
  },
  pt: {
    lobbyTitle: 'Rush Mid',
    ticket: 'Ingresso',
    format: 'Formato',
    side: 'Lado',
    sideCt: 'Contraterroristas',
    sideT: 'Terroristas',
    sideAny: 'Qualquer',
    skinLabel: 'Skin',
    practiceBots: 'Com bots',
    playWithBots: 'Jogar com bots · grátis',
    winRangeTitle: 'Skin pela vitória',
    skip: 'Pular',
    howtoTitle: 'Como jogar',
    howtoNext: 'Avançar',
    howtoStart: 'Entendi, bora jogar',
    howtoSkip: 'Pular',
    howtoSlide1Title: 'PvP por turnos',
    howtoSlide1Text:
      'O ingresso é sua entrada na partida. Os adversários são jogadores reais com o mesmo ingresso. O time vencedor divide o banco.',
    howtoSlide2Title: 'A compra não decide',
    howtoSlide2Text:
      'O orçamento é igual para todos. A arma define o estilo: a AWP é um tiro pesado e raro, a metralhadora atira com frequência e constância.',
    howtoSlide3Title: 'Leia o adversário',
    howtoSlide3Text:
      'A cada rodada você escolhe uma postura. Veja o que o adversário fez na rodada anterior — e contre.',
    howtoSlide4Title: 'A skin é por contribuição',
    howtoSlide4Text:
      'O banco é dividido por dano e utilitários, e pago como uma skin no valor da sua parte. Mesmo se você morrer, sua contribuição conta. O banco se forma com o giro de cada ingresso: a vitória rende uma skin que vale no mínimo a entrada +50%, o teto é ×5.',
    howtoTryBots: 'Experimente de graça primeiro — com bots',
    howtoLoopTitle: 'Como é uma partida',
    howtoLoopStep1: 'Você escolhe ingresso, lado e formato — essa é sua entrada na partida.',
    howtoLoopStep2: 'Compra: arma, colete e utilitários com orçamento igual.',
    howtoLoopStep3: 'Luta por turnos: a cada rodada — uma postura ou uma ação. O alvo você escolhe com um toque.',
    howtoLoopStep4: 'O banco da partida é dividido entre os vencedores por contribuição e pago como skin.',
    howtoStancesTitle: 'Posturas',
    howtoRpsCaption: 'A seta mostra quem vence quem',
    howtoStancesText:
      '[[defense|Defesa]] reflete parte do dano, [[maneuver|Esquiva]] reduz a precisão do inimigo, [[attack|Ataque]] reforça seu fogo.',
    howtoWeaponsTitle: 'Armas',
    howtoWeaponAwp: 'AWP — tudo ou nada: tiro raro, crítico enorme.',
    howtoWeaponRifle: 'Rifle — o clássico equilibrado.',
    howtoWeaponLmg: 'Metralhadora — frequente e constante, sem oscilação de crítico.',
    howtoUtilityTitle: 'Utilitários',
    howtoSmokeTargetNote: 'O smoke cobre um aliado — toque em um companheiro para escolher quem proteger.',
    howtoUtilTeamNote: 'Smoke e flash só existem nos modos em equipe.',
    howtoMoneyTitle: 'Dinheiro',
    howtoMoney1: 'O orçamento de compra é igual para todos — ele define o estilo, não a força.',
    howtoMoney2: 'O prêmio é uma skin dividida por contribuição: dano + utilitários. Morrer não apaga a contribuição.',
    howtoMoney3: 'O banco se forma com o giro de cada ingresso: a vitória rende uma skin que vale no mínimo a entrada +50%, o teto é ×5.',
    howtoMoney4: 'Cada ingresso é um giro do banco: de metade até 2,5 ingressos por giro. Ingresso mais caro — banco maior.',
    history: 'Histórico',
    partyJoin: 'Entrar por código',
    partyJoinPlaceholder: 'Código do grupo',
    partyJoinAction: 'Entrar',
    partyShare: 'Chamar amigos',
    partyKick: 'Tirar do grupo',
    partyShareText: 'Entra no meu grupo no SHOT — código {{code}}',
    partyErrNotFound: 'Grupo não encontrado — confira o código.',
    partyErrInGame: 'Esse grupo já está em jogo — termine primeiro.',
    partyErrFull: 'Esse grupo está cheio.',
    partyErrInMatch: 'Termine sua partida ativa primeiro.',
    multiaccErr: 'Você não pode entrar aqui.',
    maintenanceErr: 'O jogo está atualizando — volte em alguns minutos.',
    balanceErr: 'Moedas insuficientes para a entrada — deposite e volte.',
    topUpBalance: 'Depositar',
    maintenanceBanner: 'O jogo está atualizando — as partidas voltam em alguns minutos.',
    updateBanner: 'Saiu uma atualização — atualize para continuar jogando.',
    updateNow: 'Atualizar',
    comingSoonBadge: 'Em breve',
    comingSoonHint: 'O modo ainda não abriu — fique de olho.',
    partyLeaderTag: 'líder',
    partyLeave: 'Sair do grupo',
    partyCodeLabel: 'Código do grupo',
    partyCopy: 'Copiar',
    partyCopied: 'Copiado',
    partyCreatedBy: 'Criado por {{name}}',
    partyLeaderBadge: 'Líder',
    partyReadyYes: 'Pronto',
    partyReadyNo: 'Não está pronto',
    partyWaitingOthers: 'Esperando os outros jogadores',
    partyConfirmReady: 'Confirme que está pronto para começar.',
    partyImReady: 'Estou pronto',
    partyYou: 'Você',
    partyShareBtn: 'Compartilhar',
    partyReadyCount: 'Prontos: {{n}} de {{m}}',
    mode1: '1 x 1',
    mode2: '2 x 2',
    mode5: '5 x 5',
    modeN: '{{size}} x {{size}}',
    gamesTab: 'Jogos',
    introCard: 'Rush Mid é uma versão das batalhas de caixas no estilo Counter-Strike: os jogadores entram na partida com um ingresso fixo, lutam entre si, e os vencedores dividem o banco por contribuição — cada um recebe uma skin no valor da sua parte.',
    openGamesTitle: 'Jogos abertos',
    howToPlayLink: 'como jogar',
    winUpToPrefix: 'pela vitória até',
    winUpToSuffix: '',
    waitingForPlayer: 'esperando jogador…',
    winRangeChip: 'pela vitória',
    notEnoughShort: 'faltam',
    homeAllGames: 'todos os jogos',
    createGame: 'Criar jogo · ',
    createGameShort: 'Criar jogo',
    gamesEmptyTitle: 'Nada por aqui ainda',
    gamesEmpty: 'Nenhum jogo aberto ainda — crie o primeiro',
    gamesBack: 'Voltar aos jogos',
    openGameTitle: 'Jogo',
    joinSide: 'Sentar',
    confirmSitTitle: 'Entrar no jogo',
    confirmSitMessage: 'Entrar no jogo por {{amount}}?',
    confirmSitYes: 'Sentar',
    gameFull: 'Todas as vagas estão ocupadas',
    partyBadge: 'grupo ×{{k}}',
    tabFighter: 'Lutador',
    squadTitle: 'Grupo',
    inviteFriends: 'Chamar amigos',
    leaderPicking: 'O líder está escolhendo o jogo…',
    partyWontFit: 'grupo ×{{k}} não cabe',
    graceLockedBadge: 'jogo de novato · {{s}} s',
    graceLockedHint: 'Um novato está se aquecendo aqui. Abre para todos em {{s}} s.',
    partyFits: 'grupo ×{{k}} cabe',
    wontFit: 'não cabe',
    memberBadge: 'Em grupo ×{{k}}',
    createSheetTitle: 'Criar jogo',
    createSheetSubtitle: 'Escolha ingresso, formato e lado',
    botFillIn: 'Bots completam em {{s}} s',
    leaveGame: 'Sair',
    youLabel: 'você',
    gameInvite: 'Convidar',
    gameShareText: 'Entra no meu jogo de Rush Mid',
    gameShareButton: 'Jogar',
    replayTitle: 'Replay da partida',
    shareReplay: 'Compartilhar replay',
    replayShareText: 'Olha essa partida de Rush Mid',
    replayShareButton: 'Ver replay',
    gameGone: 'Este jogo já começou ou fechou',
    tipLabel: 'Dica',
    preparing: 'Preparando a batalha…',
    loadingGame: 'Carregando a batalha…',
    loading: 'Carregando…',
    errorTitle: 'Erro do RushMid',
    backToLobby: 'Aos jogos',
    reloadScreen: 'Recarregar tela',
    buyTitle: 'Compra',
    remaining: 'Restante',
    yourFighter: 'Seu lutador',
    hp: 'HP',
    armorShort: 'col.',
    weapon: 'Arma',
    armor: 'Colete',
    grenade: 'Granada',
    grenadeTaken: 'Pega',
    medkit: 'Kit médico',
    accuracy: 'Precisão',
    stance: 'Postura',
    stanceCenter: 'Centro',
    stanceAttack: 'Ataque',
    stanceDefense: 'Defesa',
    stanceManeuver: 'Esquiva',
    knife: 'Faca',
    smoke: 'Smoke',
    flash: 'Flash',
    nadeSmoke: 'Smoke',
    nadeFrag: 'HE',
    logSmoke: 'smoke',
    logAdrenaline: 'adrenalina',
    adrenaline: 'adrenalina',
    afkBadge: 'AFK',
    afkWarn: 'Mais uma rodada perdida e você fica sem o prêmio',
    fire: 'Fogo',
    pickAlly: 'Escolha um aliado',
    pickEnemy: 'Escolha um inimigo',
    confirmAction: 'Confirmar',
    waiting: 'Esperando…',
    choosing: 'Escolhendo…',
    watchingReplay: 'Assistindo…',
    youWin: 'Vitória',
    youLose: 'Derrota',
    sideWins: 'VITÓRIA',
    matchDraw: 'Empate',
    drawRefund: 'Moedas devolvidas',
    botShort: 'Bot',
    copyMatchId: 'Copiar ID da partida',
    matchIdCopied: 'Copiado',
    roundN: 'Rodada {{round}}',
    autoStart: 'Começa em',
    grenadeNone: 'Não',
    allies: 'Aliados',
    enemies: 'Inimigos',
    loadout: 'Compra',
    toBattle: 'Para a batalha',
    toBattleIn: 'Batalha em {{sec}} s',
    statDamage: 'Dano',
    statRate: 'Cadência',
    statCrit: 'Crít.',
    statAccuracy: 'Precisão',
    weaponAwp: 'AWP',
    weaponRifle: 'Rifle',
    weaponLmg: 'Metralhadora',
    weaponAwpBlurb: 'Bate forte, mas raramente. Crítico alto — ou mata, ou erra.',
    weaponRifleBlurb: 'Dano e cadência equilibrados.',
    weaponLmgBlurb: 'Frequente, mas fraca. Acumula dano de forma constante.',
    armorNone: 'Sem colete',
    armorLight: 'Colete leve',
    armorHeavy: 'Colete pesado',
    armorNoneBlurb: 'Poder de fogo máximo, mas frágil.',
    armorLightBlurb: 'Reduz um pouco o dano e o crítico.',
    armorHeavyBlurb: 'Reduz muito o dano máximo e o crítico — contra a AWP.',
    armorNumbers: '{{points}} pontos de colete · bala −30% de dano, o crítico atravessa',
    gearInfoOpen: 'Como funciona?',
    gearInfoTitle: 'Equipamento em números',
    gearFragInfo: 'Até {{max}} de dano no alvo — o colete não salva; o estilhaço pega mais um inimigo. Em [[defense|Defesa]] ×1.35, em [[maneuver|Esquiva]] ×0.8.',
    gearSmokeInfo: 'Smoke em um aliado: por {{rounds}} rodadas ele leva −{{mit}}% de dano de bala. Faca e granada ignoram o smoke.',
    gearFlashInfo: 'Cega até 3 inimigos por {{rounds}} rodadas: metade da precisão, sem crítico.',
    gearMedkitInfo: 'Cura {{frac}}% do HP que falta (no mínimo {{floor}}). Nesta rodada você não atira e fica aberto para a faca.',
    gearKnifeInfo: 'Grátis, toda rodada. Alvo que não atira ou está em [[defense|Defesa]] — {{dmg}} através do colete, execução com HP ≤ 30%. Alvo em [[attack|Ataque]] ou [[maneuver|Esquiva]] — só {{weak}}, e você leva o tiro dele à queima-roupa.',
    resultWin: 'Vitória',
    resultTeamWin: 'O time venceu',
    resultDefeat: 'Derrota',
    resultWinSub: 'Seu time venceu — você recebe uma skin no valor da sua parte do banco, por contribuição (MVP).',
    resultTeamWinSub: 'Seu time venceu. Seu lutador caiu, mas você ainda ganhou uma skin no valor da sua parte — por contribuição (MVP).',
    resultDefeatSub: 'O time perdeu — na próxima dá certo.',
    scoreboardTitle: 'Placar',
    payout: 'Prêmio',
    total: 'Total',
    again: 'De novo',
    wonShort: 'Vitória',
    viewLog: 'Ver log',
    roundLog: 'Log',
    roundLogTitle: 'Andamento da batalha',
    roundLogEmpty: 'A primeira rodada ainda está rolando',
    raffleTicketsTitle: '+{{n}} ingressos do sorteio',
    raffleChipWin: 'Vitória +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triplo +{{n}}',
    raffleChipQuad: 'Quadra +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: 'Vitória com 1 HP +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    dropRevealTapHint: 'Toque para continuar',
    dropYouTitle: 'Seu drop',
    dropLabel: 'Drop',
    watch: 'Ver',
    liveNowTitle: 'Rolando agora',
    liveEmpty: 'Ninguém está jogando agora',
    liveRoundBadge: 'Ao vivo · rodada {{n}}',
    spectate: 'Assistir',
    matchOver: 'Partida encerrada',
    logMiss: 'errou',
    logMissEvade: 'errou — esquivou',
    logMissBlind: 'errou — cego',
    logReflect: 'refletido',
    logPunish: 'revide',
    logLegend: '✦ crítico atravessa o colete · ⚡ adrenalina',
    logKilledBy: 'morto por',
    colKills: 'K',
    canvasMiss: 'ERROU',
    canvasMissEvade: 'ESQUIVA',
    canvasMissBlind: 'CEGO',
    historyTitle: 'Histórico',
    back: 'Voltar',
    matchDetailError: 'Não deu para carregar a partida. Talvez não exista registro — treino com bots não é salvo.',
    historySubtitle: 'Suas últimas batalhas no Rush Mid.',
    historyEmptyTitle: 'Você ainda não jogou',
    historyEmptyDescription: 'Jogue sua primeira batalha no Rush Mid — ela vai aparecer aqui.',
    win: 'Vitória',
    defeat: 'Derrota',
    timeJustNow: 'agora mesmo',
    timeMinAgo: '{{min}} min atrás',
    timeHoursAgo: '{{hours}} h atrás',
    timeDaysAgo: '{{days}} d atrás',
    ratingTab: 'Rating',
    yourRating: 'Seu rating',
    earned: 'Ganho',
    rating: 'Rating',
    played: 'Jogadas',
    wins: 'Vitórias',
    winsCol: 'Vitórias',
    losses: 'Derrotas',
    lossesCol: 'Derrotas',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Taxa de vitórias',
    player: 'Jogador',
    topPlayers: 'Top jogadores',
    ratingUnratedTitle: 'Ainda sem rating',
    ratingUnratedDescription: 'Jogue uma partida neste formato para ter um rating.',
    ratingEmptyTitle: 'Nada por aqui ainda',
    ratingEmptyDescription: 'Seja o primeiro a jogar neste formato.',
    raffleTab: 'Sorteio',
  },
  tr: {
    lobbyTitle: 'Rush Mid',
    ticket: 'Bilet',
    format: 'Format',
    side: 'Taraf',
    sideCt: 'Anti-Teröristler',
    sideT: 'Teröristler',
    sideAny: 'Fark etmez',
    skinLabel: 'Skin',
    practiceBots: 'Botlarla',
    playWithBots: 'Botlarla oyna · bedava',
    winRangeTitle: 'Zafer için skin',
    skip: 'Atla',
    howtoTitle: 'Nasıl oynanır',
    howtoNext: 'İleri',
    howtoStart: 'Anladım, oynayalım',
    howtoSkip: 'Atla',
    howtoSlide1Title: 'Sıra tabanlı PvP',
    howtoSlide1Text:
      'Bilet, maça girişin. Rakipler aynı bilete sahip gerçek oyuncular. Kazanan takım bankayı paylaşır.',
    howtoSlide2Title: 'Alım belirleyici değil',
    howtoSlide2Text:
      'Bütçe herkes için aynı. Silah tarzı belirler: AWP nadir ve ağır bir atış, makineli sık ve düzenli vurur.',
    howtoSlide3Title: 'Rakibini oku',
    howtoSlide3Text:
      'Her raund bir duruş seçersin. Rakibin geçen raund ne yaptığına bak — ve karşılık ver.',
    howtoSlide4Title: 'Skin — katkıya göre',
    howtoSlide4Text:
      'Banka hasara ve yardımcı ekipmana göre bölünür, payın kadar değerde bir skin olarak ödenir. Ölsen bile katkın sayılır. Banka tüm biletlerin çevrimiyle dolar: zafer en az giriş +50% değerinde skin getirir, tavan ×5.',
    howtoTryBots: 'Önce bedava dene — botlarla',
    howtoLoopTitle: 'Maç nasıl geçer',
    howtoLoopStep1: 'Bilet, taraf ve format seçersin — bu senin maça girişin.',
    howtoLoopStep2: 'Alım: eşit bütçeyle silah, zırh ve yardımcı ekipman.',
    howtoLoopStep3: 'Sıra tabanlı dövüş: her raund — bir duruş ya da bir hamle. Hedefi dokunarak seçersin.',
    howtoLoopStep4: 'Maç bankası kazananlar arasında katkıya göre bölünür ve skin olarak ödenir.',
    howtoStancesTitle: 'Duruşlar',
    howtoRpsCaption: 'Ok, kimin kimi yendiğini gösterir',
    howtoStancesText:
      '[[defense|Savunma]] hasarın bir kısmını yansıtır, [[maneuver|Kaçınma]] düşmanın isabetini düşürür, [[attack|Saldırı]] ateşini güçlendirir.',
    howtoWeaponsTitle: 'Silahlar',
    howtoWeaponAwp: 'AWP — ya hep ya hiç: nadir atış, devasa krit.',
    howtoWeaponRifle: 'Tüfek — dengeli klasik.',
    howtoWeaponLmg: 'Makineli — sık ve düzenli, krit dalgalanması yok.',
    howtoUtilityTitle: 'Yardımcı ekipman',
    howtoSmokeTargetNote: 'Smoke bir takım arkadaşını korur — kimi koruyacağını seçmek için ona dokun.',
    howtoUtilTeamNote: 'Smoke ve flash sadece takım modlarında var.',
    howtoMoneyTitle: 'Para',
    howtoMoney1: 'Alım bütçesi herkes için eşit — tarzı belirler, gücü değil.',
    howtoMoney2: 'Ödül bir skin ve katkıya göre bölünür: hasar + yardımcı ekipman. Ölmek katkıyı silmez.',
    howtoMoney3: 'Banka tüm biletlerin çevrimiyle dolar: zafer en az giriş +50% değerinde skin getirir, tavan ×5.',
    howtoMoney4: 'Her bilet bir banka çevrimi: çevrim başına biletin yarısından 2,5 katına kadar. Bilet pahalıysa banka da büyük.',
    history: 'Geçmiş',
    partyJoin: 'Kodla katıl',
    partyJoinPlaceholder: 'Parti kodu',
    partyJoinAction: 'Katıl',
    partyShare: 'Arkadaşlarını çağır',
    partyKick: 'Partiden çıkar',
    partyShareText: "SHOT'taki partime katıl — kod {{code}}",
    partyErrNotFound: 'Parti bulunamadı — kodu kontrol et.',
    partyErrInGame: 'Bu parti zaten oyunda — önce onu bitir.',
    partyErrFull: 'Bu parti dolu.',
    partyErrInMatch: 'Önce aktif maçını bitir.',
    multiaccErr: 'Buraya katılamazsın.',
    maintenanceErr: 'Oyun güncelleniyor — birkaç dakika sonra tekrar bak.',
    balanceErr: 'Giriş için coin yetmiyor — bakiye yükle ve geri gel.',
    topUpBalance: 'Bakiye yükle',
    maintenanceBanner: 'Oyun güncelleniyor — maçlar birkaç dakika sonra açılır.',
    updateBanner: 'Güncelleme çıktı — oynamak için güncelle.',
    updateNow: 'Güncelle',
    comingSoonBadge: 'Yakında',
    comingSoonHint: 'Mod henüz açılmadı — takipte kal.',
    partyLeaderTag: 'lider',
    partyLeave: 'Partiden ayrıl',
    partyCodeLabel: 'Parti kodu',
    partyCopy: 'Kopyala',
    partyCopied: 'Kopyalandı',
    partyCreatedBy: '{{name}} kurdu',
    partyLeaderBadge: 'Lider',
    partyReadyYes: 'Hazır',
    partyReadyNo: 'Hazır değil',
    partyWaitingOthers: 'Diğer oyuncular bekleniyor',
    partyConfirmReady: 'Başlamak için hazır olduğunu onayla.',
    partyImReady: 'Hazırım',
    partyYou: 'Sen',
    partyShareBtn: 'Paylaş',
    partyReadyCount: 'Hazır: {{n}} / {{m}}',
    mode1: '1v1',
    mode2: '2v2',
    mode5: '5v5',
    modeN: '{{size}}v{{size}}',
    gamesTab: 'Oyunlar',
    introCard: 'Rush Mid, kasa savaşlarının Counter-Strike tarzı bir versiyonu: oyuncular maça sabit bir biletle girer, birbirleriyle savaşır ve kazananlar bankayı katkıya göre paylaşır — herkes kendi payı değerinde bir skin alır.',
    openGamesTitle: 'Açık oyunlar',
    howToPlayLink: 'nasıl oynanır',
    winUpToPrefix: 'zaferde en fazla',
    winUpToSuffix: '',
    waitingForPlayer: 'oyuncu bekleniyor…',
    winRangeChip: 'zaferde',
    notEnoughShort: 'eksik:',
    homeAllGames: 'tüm oyunlar',
    createGame: 'Oyun kur · ',
    createGameShort: 'Oyun kur',
    gamesEmptyTitle: 'Şimdilik boş',
    gamesEmpty: 'Henüz açık oyun yok — ilkini sen kur',
    gamesBack: 'Oyunlara dön',
    openGameTitle: 'Oyun',
    joinSide: 'Otur',
    confirmSitTitle: 'Oyuna gir',
    confirmSitMessage: '{{amount}} karşılığında oyuna girilsin mi?',
    confirmSitYes: 'Otur',
    gameFull: 'Tüm yerler dolu',
    partyBadge: 'parti ×{{k}}',
    tabFighter: 'Savaşçı',
    squadTitle: 'Parti',
    inviteFriends: 'Arkadaşlarını çağır',
    leaderPicking: 'Lider oyun seçiyor…',
    partyWontFit: 'parti ×{{k}} sığmaz',
    graceLockedBadge: 'yeni oyuncu maçı · {{s}} sn',
    graceLockedHint: 'Burada yeni bir oyuncu ısınıyor. {{s}} sn sonra herkese açılır.',
    partyFits: 'parti ×{{k}} sığar',
    wontFit: 'sığmaz',
    memberBadge: 'Partide ×{{k}}',
    createSheetTitle: 'Oyun kur',
    createSheetSubtitle: 'Bilet, format ve taraf seç',
    botFillIn: 'Botlar {{s}} sn sonra tamamlar',
    leaveGame: 'Ayrıl',
    youLabel: 'sen',
    gameInvite: 'Davet et',
    gameShareText: 'Rush Mid oyunuma katıl',
    gameShareButton: 'Oyna',
    replayTitle: 'Maç tekrarı',
    shareReplay: 'Tekrarı paylaş',
    replayShareText: 'Şu Rush Mid maçına bir bak',
    replayShareButton: 'Tekrarı izle',
    gameGone: 'Bu oyun zaten başladı ya da kapandı',
    tipLabel: 'İpucu',
    preparing: 'Savaş hazırlanıyor…',
    loadingGame: 'Savaş yükleniyor…',
    loading: 'Yükleniyor…',
    errorTitle: 'RushMid hatası',
    backToLobby: 'Oyunlara',
    reloadScreen: 'Ekranı yenile',
    buyTitle: 'Alım',
    remaining: 'Kalan',
    yourFighter: 'Savaşçın',
    hp: 'HP',
    armorShort: 'zırh',
    weapon: 'Silah',
    armor: 'Zırh',
    grenade: 'Bomba',
    grenadeTaken: 'Alındı',
    medkit: 'Sağlık kiti',
    accuracy: 'İsabet',
    stance: 'Duruş',
    stanceCenter: 'Merkez',
    stanceAttack: 'Saldırı',
    stanceDefense: 'Savunma',
    stanceManeuver: 'Kaçınma',
    knife: 'Bıçak',
    smoke: 'Smoke',
    flash: 'Flash',
    nadeSmoke: 'Smoke',
    nadeFrag: 'HE',
    logSmoke: 'smoke',
    logAdrenaline: 'adrenalin',
    adrenaline: 'adrenalin',
    afkBadge: 'AFK',
    afkWarn: 'Bir raund daha kaçırırsan kazancını kaybedersin',
    fire: 'Ateş',
    pickAlly: 'Takım arkadaşı seç',
    pickEnemy: 'Düşman seç',
    confirmAction: 'Onayla',
    waiting: 'Bekleniyor…',
    choosing: 'Seçiyor…',
    watchingReplay: 'İzleniyor…',
    youWin: 'Zafer',
    youLose: 'Yenilgi',
    sideWins: 'ZAFER',
    matchDraw: 'Berabere',
    drawRefund: 'Coinler iade edildi',
    botShort: 'Bot',
    copyMatchId: "Maç ID'sini kopyala",
    matchIdCopied: 'Kopyalandı',
    roundN: 'Raund {{round}}',
    autoStart: 'Otomatik başlangıç:',
    grenadeNone: 'Yok',
    allies: 'Müttefikler',
    enemies: 'Düşmanlar',
    loadout: 'Alım',
    toBattle: 'Savaşa',
    toBattleIn: '{{sec}} sn sonra savaşa',
    statDamage: 'Hasar',
    statRate: 'Atış hızı',
    statCrit: 'Krit',
    statAccuracy: 'İsabet',
    weaponAwp: 'AWP',
    weaponRifle: 'Tüfek',
    weaponLmg: 'Makineli',
    weaponAwpBlurb: 'Sert ama nadir vurur. Yüksek krit — ya indirir ya ıskalar.',
    weaponRifleBlurb: 'Dengeli hasar ve atış hızı.',
    weaponLmgBlurb: 'Sık ama zayıf. Hasarı düzenli biriktirir.',
    armorNone: 'Zırhsız',
    armorLight: 'Hafif yelek',
    armorHeavy: 'Ağır yelek',
    armorNoneBlurb: 'Maksimum ateş gücü ama kırılgan.',
    armorLightBlurb: 'Hasarı ve kriti biraz keser.',
    armorHeavyBlurb: 'Tepe hasarı ve kriti çok keser — AWP karşıtı.',
    armorNumbers: '{{points}} zırh puanı · mermi −30% hasar, krit deler',
    gearInfoOpen: 'Nasıl çalışır?',
    gearInfoTitle: 'Ekipman rakamlarla',
    gearFragInfo: 'Hedefe {{max}} hasara kadar — zırh kurtarmaz; şarapnel bir düşmana daha değer. [[defense|Savunma]] ×1.35, [[maneuver|Kaçınma]] ×0.8 alır.',
    gearSmokeInfo: 'Takım arkadaşına smoke: {{rounds}} raund boyunca −{{mit}}% mermi hasarı alır. Bıçak ve bomba smoke tanımaz.',
    gearFlashInfo: '3 düşmana kadar {{rounds}} raund kör eder: yarı isabet, krit yok.',
    gearMedkitInfo: 'Eksik HP’nin {{frac}}%’ini iyileştirir (en az {{floor}}). Bu raund ateş etmezsin ve bıçağa açıksın.',
    gearKnifeInfo: 'Bedava, her raund. Hedef ateş etmiyorsa ya da [[defense|Savunma]]’daysa — zırhı delen {{dmg}}, HP ≤ 30% ise infaz. Hedef [[attack|Saldırı]] ya da [[maneuver|Kaçınma]]’daysa — sadece {{weak}}, üstüne yakın mesafeden ateşini yersin.',
    resultWin: 'Zafer',
    resultTeamWin: 'Takım kazandı',
    resultDefeat: 'Yenilgi',
    resultWinSub: 'Takımın kazandı — bankadaki payın değerinde bir skin alırsın, katkıya göre (MVP).',
    resultTeamWinSub: 'Takımın kazandı. Savaşçın düştü ama yine de payın değerinde bir skin kazandın — katkıya göre (MVP).',
    resultDefeatSub: 'Takım kaybetti — bir dahakine şans seninle.',
    scoreboardTitle: 'Skor tablosu',
    payout: 'Kazanç',
    total: 'Toplam',
    again: 'Tekrar',
    wonShort: 'Kazandık',
    viewLog: 'Logu gör',
    roundLog: 'Log',
    roundLogTitle: 'Savaşın akışı',
    roundLogEmpty: 'İlk raund hâlâ sürüyor',
    raffleTicketsTitle: '+{{n}} çekiliş bileti',
    raffleChipWin: 'Zafer +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Üçlü +{{n}}',
    raffleChipQuad: 'Dörtlü +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: '1 HP ile zafer +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    dropRevealTapHint: 'Devam etmek için dokun',
    dropYouTitle: 'Senin dropun',
    dropLabel: 'Drop',
    watch: 'Gör',
    liveNowTitle: 'Şu an oynanıyor',
    liveEmpty: 'Şu an kimse oynamıyor',
    liveRoundBadge: 'Canlı · raund {{n}}',
    spectate: 'İzle',
    matchOver: 'Maç bitti',
    logMiss: 'ıska',
    logMissEvade: 'ıska — kaçındı',
    logMissBlind: 'ıska — kör',
    logReflect: 'yansıtıldı',
    logPunish: 'karşı ateş',
    logLegend: '✦ krit zırhı deler · ⚡ adrenalin',
    logKilledBy: 'öldürdü',
    colKills: 'K',
    canvasMiss: 'ISKA',
    canvasMissEvade: 'KAÇTI',
    canvasMissBlind: 'KÖR',
    historyTitle: 'Geçmiş',
    back: 'Geri',
    matchDetailError: 'Maç yüklenemedi. Kaydı olmayabilir — bot antrenmanı kaydedilmez.',
    historySubtitle: "Rush Mid'deki son savaşların.",
    historyEmptyTitle: 'Henüz oynamadın',
    historyEmptyDescription: "Rush Mid'de ilk savaşını oyna — burada görünecek.",
    win: 'Zafer',
    defeat: 'Yenilgi',
    timeJustNow: 'az önce',
    timeMinAgo: '{{min}} dk önce',
    timeHoursAgo: '{{hours}} sa önce',
    timeDaysAgo: '{{days}} gün önce',
    ratingTab: 'Puan',
    yourRating: 'Puanın',
    earned: 'Kazanılan',
    rating: 'Puan',
    played: 'Oynanan',
    wins: 'Zafer',
    winsCol: 'Zaferler',
    losses: 'Yenilgi',
    lossesCol: 'Yenilgiler',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'L',
    winrate: 'Kazanma oranı',
    player: 'Oyuncu',
    topPlayers: 'En iyi oyuncular',
    ratingUnratedTitle: 'Henüz puan yok',
    ratingUnratedDescription: 'Puan almak için bu formatta bir maç oyna.',
    ratingEmptyTitle: 'Şimdilik boş',
    ratingEmptyDescription: 'Bu formatta ilk oynayan sen ol.',
    raffleTab: 'Çekiliş',
  },
  uk: {
    lobbyTitle: 'Rush Mid',
    ticket: 'Квиток',
    format: 'Формат',
    side: 'Сторона',
    sideCt: 'Контртерористи',
    sideT: 'Терористи',
    sideAny: 'Будь-яка',
    skinLabel: 'Скін',
    practiceBots: 'З ботами',
    playWithBots: 'Грати з ботами · безкоштовно',
    winRangeTitle: 'Скін за перемогу',
    skip: 'Пропустити',
    howtoTitle: 'Як грати',
    howtoNext: 'Далі',
    howtoStart: 'Зрозуміло, граємо',
    howtoSkip: 'Пропустити',
    howtoSlide1Title: 'Покроковий PvP',
    howtoSlide1Text:
      'Квиток — твій вхід у матч. Суперники — справжні гравці з таким самим квитком. Команда-переможниця ділить банк.',
    howtoSlide2Title: 'Закупівля не вирішує',
    howtoSlide2Text:
      'Бюджет у всіх однаковий. Зброя задає стиль: AWP — рідкісний важкий постріл, кулемет б’є часто й рівно.',
    howtoSlide3Title: 'Читай суперника',
    howtoSlide3Text:
      'Щораунду обираєш стійку. Дивись, що суперник робив у попередньому раунді, — і контри його.',
    howtoSlide4Title: 'Скін — за заслуги',
    howtoSlide4Text:
      'Банк ділиться за уроном і утилітою, а виплачується скіном потрібної вартості. Навіть якщо загинув, заслуги враховано. Банк наповнюється прокрутами всіх квитків: перемога приносить скін вартістю щонайменше вхід +50%, стеля — ×5.',
    howtoTryBots: 'Спочатку спробуй безкоштовно — з ботами',
    howtoLoopTitle: 'Як проходить матч',
    howtoLoopStep1: 'Обираєш квиток, сторону й формат — це твій вхід у матч.',
    howtoLoopStep2: 'Закупівля: зброя, броня й утиліта на рівний бюджет.',
    howtoLoopStep3: 'Покроковий бій: щораунду — стійка або дія. Ціль обираєш тапом.',
    howtoLoopStep4: 'Банк матчу ділиться між переможцями за заслугами і виплачується скіном.',
    howtoStancesTitle: 'Стійки',
    howtoRpsCaption: 'Стрілка показує, хто кого б’є',
    howtoStancesText:
      '[[defense|Захист]] відбиває частину шкоди, [[maneuver|Маневр]] збиває точність ворога, [[attack|Атака]] посилює твій вогонь.',
    howtoWeaponsTitle: 'Зброя',
    howtoWeaponAwp: 'AWP — все або нічого: рідкісний постріл, величезний крит.',
    howtoWeaponRifle: 'Автомат — збалансована класика.',
    howtoWeaponLmg: 'Кулемет — часто й рівно, без гойдалок криту.',
    howtoUtilityTitle: 'Утиліта',
    howtoSmokeTargetNote: 'Дим прикриває союзника — тапни свого, щоб обрати, кого закрити.',
    howtoUtilTeamNote: 'Дим і флешка — тільки в командних режимах.',
    howtoMoneyTitle: 'Гроші',
    howtoMoney1: 'Бюджет закупівлі в усіх однаковий — він вирішує стиль, а не силу.',
    howtoMoney2: 'Приз — скін, він ділиться за заслугами: шкода + утиліта. Смерть заслуги не стирає.',
    howtoMoney3: 'Банк наповнюється прокрутами всіх квитків: перемога приносить скін вартістю щонайменше вхід +50%, стеля — ×5.',
    howtoMoney4: 'Кожен квиток — один прокрут банку: від половини до 2.5 квитка за прокрут. Дорожчий квиток — більший банк.',
    history: 'Історія',
    partyJoin: 'Увійти за кодом',
    partyJoinPlaceholder: 'Код паті',
    partyJoinAction: 'Увійти',
    partyShare: 'Позвати друзів',
    partyKick: 'Прибрати з паті',
    partyShareText: 'Залітай до мене в паті SHOT — код {{code}}',
    partyErrNotFound: 'Паті не знайдено — перевір код.',
    partyErrInGame: 'Паті вже в грі — спочатку закінчи її.',
    partyErrFull: 'Паті заповнена.',
    partyErrInMatch: 'Спочатку закінчи активний матч.',
    multiaccErr: 'Ти не можеш приєднатися сюди.',
    maintenanceErr: 'Триває оновлення гри — зазирни за кілька хвилин.',
    balanceErr: 'Не вистачає монет на вхід — поповни баланс і повертайся.',
    topUpBalance: 'Поповнити баланс',
    maintenanceBanner: 'Триває оновлення гри — матчі відкриються за кілька хвилин.',
    updateBanner: 'Вийшло оновлення — онови, щоб грати далі.',
    updateNow: 'Оновити',
    comingSoonBadge: 'Скоро',
    comingSoonHint: 'Режим ще не відкрито — стеж за новинами.',
    partyLeaderTag: 'лідер',
    partyLeave: 'Вийти з паті',
    partyCodeLabel: 'Код паті',
    partyCopy: 'Копіювати',
    partyCopied: 'Скопійовано',
    partyCreatedBy: 'Створено: {{name}}',
    partyLeaderBadge: 'Лідер',
    partyReadyYes: 'Готовий',
    partyReadyNo: 'Не готовий',
    partyWaitingOthers: 'Чекаємо на решту гравців',
    partyConfirmReady: 'Підтверди готовність, щоб почати гру.',
    partyImReady: 'Я готовий',
    partyYou: 'Ти',
    partyShareBtn: 'Поділитися',
    partyReadyCount: 'Готово: {{n}} з {{m}}',
    mode1: '1 на 1',
    mode2: '2 на 2',
    mode5: '5 на 5',
    modeN: '{{size}} на {{size}}',
    gamesTab: 'Ігри',
    introCard: 'Rush Mid — ігровий аналог кейс-батлів у стилі Counter-Strike: гравці заходять у матч із фіксованим квитком, б’ються між собою, а переможці ділять банк за заслугами — кожен отримує скін на вартість своєї частки.',
    openGamesTitle: 'Відкриті ігри',
    howToPlayLink: 'як грати',
    winUpToPrefix: 'за перемогу до',
    winUpToSuffix: '',
    waitingForPlayer: 'чекаємо на гравця…',
    winRangeChip: 'за перемогу',
    notEnoughShort: 'не вистачає',
    homeAllGames: 'усі ігри',
    createGame: 'Створити гру ·',
    createGameShort: 'Створити гру',
    gamesEmptyTitle: 'Тут поки порожньо',
    gamesEmpty: 'Відкритих ігор поки немає — створи першу',
    gamesBack: 'До списку ігор',
    openGameTitle: 'Гра',
    joinSide: 'Зайти',
    confirmSitTitle: 'Зайти в гру',
    confirmSitMessage: 'Зайти в гру за {{amount}}?',
    confirmSitYes: 'Зайти',
    gameFull: 'Усі місця зайняті',
    partyBadge: 'паті ×{{k}}',
    tabFighter: 'Боєць',
    squadTitle: 'Паті',
    inviteFriends: 'Позвати друзів',
    leaderPicking: 'Лідер обирає гру…',
    partyWontFit: 'паті ×{{k}} не влізе',
    graceLockedBadge: 'гра новачка · {{s}} с',
    graceLockedHint: 'Тут розминається новачок. Для всіх відкриється за {{s}} с.',
    partyFits: 'паті ×{{k}} влізе',
    wontFit: 'не влізе',
    memberBadge: 'У паті ×{{k}}',
    createSheetTitle: 'Створити гру',
    createSheetSubtitle: 'Обери квиток, формат і сторону',
    botFillIn: 'Боти доберуть за {{s}} с',
    leaveGame: 'Вийти',
    youLabel: 'ти',
    gameInvite: 'Запросити',
    gameShareText: 'Залітай до мене в гру Rush Mid',
    gameShareButton: 'Грати',
    replayTitle: 'Реплей матчу',
    shareReplay: 'Поділитися реплеєм',
    replayShareText: 'Зацени цей матч у Rush Mid',
    replayShareButton: 'Дивитися реплей',
    gameGone: 'Ця гра вже почалась або закрилась',
    tipLabel: 'Порада',
    preparing: 'Готуємо бій…',
    loadingGame: 'Завантажуємо бій…',
    loading: 'Завантаження…',
    errorTitle: 'Помилка RushMid',
    backToLobby: 'До ігор',
    reloadScreen: 'Оновити екран',
    buyTitle: 'Закупівля',
    remaining: 'Залишилось',
    yourFighter: 'Твій боєць',
    hp: 'HP',
    armorShort: 'бр.',
    weapon: 'Зброя',
    armor: 'Броня',
    grenade: 'Граната',
    grenadeTaken: 'Взято',
    medkit: 'Аптечка',
    accuracy: 'Точність',
    stance: 'Стійка',
    stanceCenter: 'Центр',
    stanceAttack: 'Атака',
    stanceDefense: 'Захист',
    stanceManeuver: 'Маневр',
    knife: 'Ніж',
    smoke: 'Дим',
    flash: 'Флешка',
    nadeSmoke: 'Димова',
    nadeFrag: 'Осколкова',
    logSmoke: 'дим',
    logAdrenaline: 'адреналін',
    adrenaline: 'адреналін',
    afkBadge: 'AFK',
    afkWarn: 'Ще один пропуск — залишишся без виграшу',
    fire: 'Вогонь',
    pickAlly: 'Обери свого',
    pickEnemy: 'Обери ворога',
    confirmAction: 'У бій',
    waiting: 'Чекаємо…',
    choosing: 'Обирає…',
    watchingReplay: 'Дивимось…',
    youWin: 'Перемога',
    youLose: 'Поразка',
    sideWins: 'ПЕРЕМОГА',
    matchDraw: 'Нічия',
    drawRefund: 'Монети повернено',
    botShort: 'Бот',
    copyMatchId: 'Копіювати ID матчу',
    matchIdCopied: 'Скопійовано',
    roundN: 'Раунд {{round}}',
    autoStart: 'Старт через',
    grenadeNone: 'Немає',
    allies: 'Союзники',
    enemies: 'Вороги',
    loadout: 'Закупівля',
    toBattle: 'У бій',
    toBattleIn: 'У бій через {{sec}} с',
    statDamage: 'Шкода',
    statRate: 'Темп',
    statCrit: 'Крит',
    statAccuracy: 'Точність',
    weaponAwp: 'AWP',
    weaponRifle: 'Автомат',
    weaponLmg: 'Кулемет',
    weaponAwpBlurb: 'Б’є сильно, але рідко. Високий крит — або виносить, або мажить.',
    weaponRifleBlurb: 'Збалансована шкода й темп.',
    weaponLmgBlurb: 'Часто, але слабко. Рівно набиває шкоду.',
    armorNone: 'Без броні',
    armorLight: 'Легкий жилет',
    armorHeavy: 'Важкий жилет',
    armorNoneBlurb: 'Максимум вогневої потужності, але тендітний.',
    armorLightBlurb: 'Трохи зменшує шкоду й крит.',
    armorHeavyBlurb: 'Сильно зменшує пікову шкоду й крит — проти AWP.',
    armorNumbers: '{{points}} очок броні · куля −30% шкоди, крит пробиває',
    gearInfoOpen: 'Як це працює?',
    gearInfoTitle: 'Спорядження в цифрах',
    gearFragInfo: 'До {{max}} шкоди по цілі — броня не врятує; уламок зачіпає ще одного ворога. По [[defense|Захисту]] ×1.35, по [[maneuver|Маневру]] ×0.8.',
    gearSmokeInfo: 'Дим на союзника: {{rounds}} раунди він отримує −{{mit}}% шкоди від куль. Ніж і граната дим ігнорують.',
    gearFlashInfo: 'Засліплює до 3 ворогів на {{rounds}} раунди: точність удвічі нижча, крита немає.',
    gearMedkitInfo: 'Лікує {{frac}}% нестачі HP (щонайменше {{floor}}). У цей раунд ти не стріляєш і відкритий для ножа.',
    gearKnifeInfo: 'Безкоштовний, щораунду. Ціль не стріляє або сидить у [[defense|Захисті]] — {{dmg}} крізь броню, при HP ≤ 30% — страта. Ціль в [[attack|Атаці]] або [[maneuver|Маневрі]] — лише {{weak}}, а ти ловиш її постріл упритул.',
    resultWin: 'Перемога',
    resultTeamWin: 'Команда перемогла',
    resultDefeat: 'Поразка',
    resultWinSub: 'Команда перемогла — ти отримуєш скін на вартість своєї частки банку, за заслугами (MVP).',
    resultTeamWinSub: 'Команда перемогла. Боєць упав, але ти все одно отримав скін за своєю часткою — за заслугами (MVP).',
    resultDefeatSub: 'Команда програла — наступного разу пощастить.',
    scoreboardTitle: 'Таблиця',
    payout: 'Виграш',
    total: 'Разом',
    again: 'Ще раз',
    wonShort: 'Перемогли',
    viewLog: 'Переглянути лог',
    roundLog: 'Лог',
    roundLogTitle: 'Хід бою',
    roundLogEmpty: 'Перший раунд ще триває',
    raffleTicketsTitle: '+{{n}} квитків розіграшу',
    raffleChipWin: 'Перемога +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Тріпл +{{n}}',
    raffleChipQuad: 'Квадра +{{n}}',
    raffleChipAce: 'Ейс +{{n}}',
    raffleChipOneHp: 'Перемога з 1 HP +{{n}}',
    raffleChipClutch2: 'Клатч 1v2 +{{n}}',
    raffleChipClutch3: 'Клатч 1v3 +{{n}}',
    dropRevealTapHint: 'Натисни, щоб продовжити',
    dropYouTitle: 'Твій дроп',
    dropLabel: 'Дроп',
    watch: 'Подивитися',
    liveNowTitle: 'Тривають зараз',
    liveEmpty: 'Зараз ніхто не грає',
    liveRoundBadge: 'Триває бій · раунд {{n}}',
    spectate: 'Дивитися',
    matchOver: 'Матч завершено',
    logMiss: 'повз',
    logMissEvade: 'повз — ухилення',
    logMissBlind: 'повз — засліплений',
    logReflect: 'відбито',
    logPunish: 'відповідний вогонь',
    logLegend: '✦ крит пробиває броню · ⚡ адреналін',
    logKilledBy: 'вбив',
    colKills: 'К',
    canvasMiss: 'ПОВЗ',
    canvasMissEvade: 'УХИЛ',
    canvasMissBlind: 'СЛІПИЙ',
    historyTitle: 'Історія',
    back: 'Назад',
    matchDetailError: 'Не вдалося завантажити матч. Можливо, запису немає — тренування з ботами не зберігається.',
    historySubtitle: 'Твої останні бої в Rush Mid.',
    historyEmptyTitle: 'Ти ще не грав',
    historyEmptyDescription: 'Зіграй перший бій у Rush Mid — він з’явиться тут.',
    win: 'Перемога',
    defeat: 'Поразка',
    timeJustNow: 'щойно',
    timeMinAgo: '{{min}} хв тому',
    timeHoursAgo: '{{hours}} год тому',
    timeDaysAgo: '{{days}} дн тому',
    ratingTab: 'Рейтинг',
    yourRating: 'Твій рейтинг',
    earned: 'Зароблено',
    rating: 'Рейтинг',
    played: 'Зіграно',
    wins: 'Перемог',
    winsCol: 'Перемоги',
    losses: 'Поразок',
    lossesCol: 'Поразки',
    playedShort: 'М',
    winsShort: 'П',
    lossesShort: 'Пр',
    winrate: 'Вінрейт',
    player: 'Гравець',
    topPlayers: 'Топ гравців',
    ratingUnratedTitle: 'Рейтингу поки немає',
    ratingUnratedDescription: 'Зіграй матч у цьому форматі, щоб отримати рейтинг.',
    ratingEmptyTitle: 'Тут поки порожньо',
    ratingEmptyDescription: 'Зіграй першим у цьому форматі.',
    raffleTab: 'Розіграш',
  },
  de: {
    lobbyTitle: 'Rush Mid',
    ticket: 'Ticket',
    format: 'Format',
    side: 'Seite',
    sideCt: 'Counter-Terroristen',
    sideT: 'Terroristen',
    sideAny: 'Beliebig',
    skinLabel: 'Skin',
    practiceBots: 'Gegen Bots',
    playWithBots: 'Gegen Bots spielen · gratis',
    winRangeTitle: 'Skin für den Sieg',
    skip: 'Überspringen',
    howtoTitle: 'So spielst du',
    howtoNext: 'Weiter',
    howtoStart: 'Verstanden, los geht’s',
    howtoSkip: 'Überspringen',
    howtoSlide1Title: 'Rundenbasiertes PvP',
    howtoSlide1Text:
      'Das Ticket ist dein Eintritt ins Match. Deine Gegner sind echte Spieler mit demselben Ticket. Das Siegerteam teilt sich die Bank.',
    howtoSlide2Title: 'Der Kauf entscheidet nicht',
    howtoSlide2Text:
      'Alle haben das gleiche Budget. Die Waffe bestimmt den Stil: Die AWP ist ein seltener, schwerer Schuss, das MG feuert oft und gleichmäßig.',
    howtoSlide3Title: 'Lies deinen Gegner',
    howtoSlide3Text:
      'Jede Runde wählst du eine Haltung. Schau, was dein Gegner in der letzten Runde gemacht hat – und kontere es.',
    howtoSlide4Title: 'Skin nach Leistung',
    howtoSlide4Text:
      'Die Bank wird nach Schaden und Utility aufgeteilt und als Skin im Wert deines Anteils ausgezahlt. Auch wenn du stirbst, zählt deine Leistung. Die Bank füllt sich durch die Drehs aller Tickets: Ein Sieg bringt einen Skin im Wert von mindestens Eintritt +50 %, die Obergrenze ist ×5.',
    howtoTryBots: 'Probier es erst gratis – gegen Bots',
    howtoLoopTitle: 'So läuft ein Match',
    howtoLoopStep1: 'Du wählst Ticket, Seite und Format – das ist dein Eintritt ins Match.',
    howtoLoopStep2: 'Kaufphase: Waffe, Rüstung und Utility mit gleichem Budget.',
    howtoLoopStep3: 'Rundenkampf: Jede Runde eine Haltung oder Aktion. Das Ziel wählst du per Tipp.',
    howtoLoopStep4: 'Die Matchbank wird nach Leistung unter den Siegern aufgeteilt und als Skin ausgezahlt.',
    howtoStancesTitle: 'Haltungen',
    howtoRpsCaption: 'Der Pfeil zeigt, wer wen schlägt',
    howtoStancesText:
      '[[defense|Verteidigung]] reflektiert einen Teil des Schadens, [[maneuver|Ausweichen]] senkt die Genauigkeit des Gegners, [[attack|Angriff]] verstärkt dein Feuer.',
    howtoWeaponsTitle: 'Waffen',
    howtoWeaponAwp: 'AWP – alles oder nichts: seltener Schuss, riesiger Crit.',
    howtoWeaponRifle: 'Gewehr – der ausgewogene Klassiker.',
    howtoWeaponLmg: 'MG – oft und gleichmäßig, keine Crit-Schwankungen.',
    howtoUtilityTitle: 'Utility',
    howtoSmokeTargetNote: 'Rauch schützt einen Verbündeten – tippe auf einen Teamkollegen, um zu wählen, wen er deckt.',
    howtoUtilTeamNote: 'Rauch und Flash gibt es nur in Team-Modi.',
    howtoMoneyTitle: 'Geld',
    howtoMoney1: 'Das Kaufbudget ist für alle gleich – es bestimmt den Stil, nicht die Stärke.',
    howtoMoney2: 'Der Preis ist ein Skin, aufgeteilt nach Leistung: Schaden + Utility. Sterben löscht die Leistung nicht.',
    howtoMoney3: 'Die Bank füllt sich durch die Drehs aller Tickets: Ein Sieg bringt einen Skin im Wert von mindestens Eintritt +50 %, die Obergrenze ist ×5.',
    howtoMoney4: 'Jedes Ticket ist ein Dreh der Bank – von der Hälfte bis zum 2,5-Fachen des Tickets pro Dreh. Teureres Ticket – größere Bank.',
    history: 'Verlauf',
    partyJoin: 'Per Code beitreten',
    partyJoinPlaceholder: 'Party-Code',
    partyJoinAction: 'Beitreten',
    partyShare: 'Freunde einladen',
    partyKick: 'Aus der Party entfernen',
    partyShareText: 'Komm in meine SHOT-Party – Code {{code}}',
    partyErrNotFound: 'Party nicht gefunden – prüfe den Code.',
    partyErrInGame: 'Diese Party ist schon im Spiel – beende es zuerst.',
    partyErrFull: 'Diese Party ist voll.',
    partyErrInMatch: 'Beende zuerst dein aktives Match.',
    multiaccErr: 'Du kannst hier nicht beitreten.',
    maintenanceErr: 'Das Spiel wird aktualisiert – schau in ein paar Minuten wieder vorbei.',
    balanceErr: 'Nicht genug Münzen für den Eintritt – lade dein Guthaben auf und komm zurück.',
    topUpBalance: 'Guthaben aufladen',
    maintenanceBanner: 'Das Spiel wird aktualisiert – Matches öffnen in ein paar Minuten wieder.',
    updateBanner: 'Es gibt ein Update – aktualisiere, um weiterzuspielen.',
    updateNow: 'Aktualisieren',
    comingSoonBadge: 'Bald verfügbar',
    comingSoonHint: 'Der Modus ist noch nicht geöffnet – bleib dran.',
    partyLeaderTag: 'Leader',
    partyLeave: 'Party verlassen',
    partyCodeLabel: 'Party-Code',
    partyCopy: 'Kopieren',
    partyCopied: 'Kopiert',
    partyCreatedBy: 'Erstellt von {{name}}',
    partyLeaderBadge: 'Leader',
    partyReadyYes: 'Bereit',
    partyReadyNo: 'Nicht bereit',
    partyWaitingOthers: 'Warten auf die anderen Spieler',
    partyConfirmReady: 'Bestätige, dass du bereit bist, um zu starten.',
    partyImReady: 'Ich bin bereit',
    partyYou: 'Du',
    partyShareBtn: 'Teilen',
    partyReadyCount: 'Bereit: {{n}} von {{m}}',
    mode1: '1 vs 1',
    mode2: '2 vs 2',
    mode5: '5 vs 5',
    modeN: '{{size}} vs {{size}}',
    gamesTab: 'Spiele',
    introCard: 'Rush Mid ist das Spiel-Pendant zu Case Battles im Counter-Strike-Stil: Spieler gehen mit einem festen Ticket ins Match, kämpfen gegeneinander, und die Sieger teilen die Bank nach Leistung – jeder bekommt einen Skin im Wert seines Anteils.',
    openGamesTitle: 'Offene Spiele',
    howToPlayLink: 'so spielst du',
    winUpToPrefix: 'für einen Sieg bis zu',
    winUpToSuffix: '',
    waitingForPlayer: 'warten auf einen Spieler…',
    winRangeChip: 'Sieg bringt',
    notEnoughShort: 'es fehlen',
    homeAllGames: 'alle Spiele',
    createGame: 'Spiel erstellen ·',
    createGameShort: 'Spiel erstellen',
    gamesEmptyTitle: 'Hier ist noch nichts',
    gamesEmpty: 'Noch keine offenen Spiele – erstelle das erste',
    gamesBack: 'Zurück zu den Spielen',
    openGameTitle: 'Spiel',
    joinSide: 'Beitreten',
    confirmSitTitle: 'Spiel beitreten',
    confirmSitMessage: 'Für {{amount}} beitreten?',
    confirmSitYes: 'Beitreten',
    gameFull: 'Alle Plätze sind belegt',
    partyBadge: 'Party ×{{k}}',
    tabFighter: 'Kämpfer',
    squadTitle: 'Party',
    inviteFriends: 'Freunde einladen',
    leaderPicking: 'Der Leader wählt ein Spiel…',
    partyWontFit: 'Party ×{{k}} passt nicht rein',
    graceLockedBadge: 'Neulingsspiel · {{s}} s',
    graceLockedHint: 'Hier wärmt sich ein Neuling auf. In {{s}} s öffnet sich die Lobby für alle.',
    partyFits: 'Party ×{{k}} passt rein',
    wontFit: 'passt nicht rein',
    memberBadge: 'In einer Party ×{{k}}',
    createSheetTitle: 'Spiel erstellen',
    createSheetSubtitle: 'Wähle Ticket, Format und Seite',
    botFillIn: 'Bots füllen in {{s}} s auf',
    leaveGame: 'Verlassen',
    youLabel: 'du',
    gameInvite: 'Einladen',
    gameShareText: 'Komm in mein Rush-Mid-Spiel',
    gameShareButton: 'Spielen',
    replayTitle: 'Match-Replay',
    shareReplay: 'Replay teilen',
    replayShareText: 'Schau dir dieses Match in Rush Mid an',
    replayShareButton: 'Replay ansehen',
    gameGone: 'Dieses Spiel hat schon begonnen oder wurde geschlossen',
    tipLabel: 'Tipp',
    preparing: 'Kampf wird vorbereitet…',
    loadingGame: 'Kampf wird geladen…',
    loading: 'Lädt…',
    errorTitle: 'RushMid-Fehler',
    backToLobby: 'Zu den Spielen',
    reloadScreen: 'Bildschirm neu laden',
    buyTitle: 'Kauf',
    remaining: 'Übrig',
    yourFighter: 'Dein Kämpfer',
    hp: 'HP',
    armorShort: 'Rüst.',
    weapon: 'Waffe',
    armor: 'Rüstung',
    grenade: 'Granate',
    grenadeTaken: 'Genommen',
    medkit: 'Medikit',
    accuracy: 'Genauigkeit',
    stance: 'Haltung',
    stanceCenter: 'Mitte',
    stanceAttack: 'Angriff',
    stanceDefense: 'Verteidigung',
    stanceManeuver: 'Ausweichen',
    knife: 'Messer',
    smoke: 'Rauch',
    flash: 'Flash',
    nadeSmoke: 'Rauchgranate',
    nadeFrag: 'Splittergranate',
    logSmoke: 'Rauch',
    logAdrenaline: 'Adrenalin',
    adrenaline: 'Adrenalin',
    afkBadge: 'AFK',
    afkWarn: 'Noch eine verpasste Runde und du gehst leer aus',
    fire: 'Feuer',
    pickAlly: 'Wähle einen Teamkollegen',
    pickEnemy: 'Wähle einen Gegner',
    confirmAction: 'Los',
    waiting: 'Warten…',
    choosing: 'Wählt…',
    watchingReplay: 'Zuschauen…',
    youWin: 'Sieg',
    youLose: 'Niederlage',
    sideWins: 'SIEG',
    matchDraw: 'Unentschieden',
    drawRefund: 'Münzen zurückerstattet',
    botShort: 'Bot',
    copyMatchId: 'Match-ID kopieren',
    matchIdCopied: 'Kopiert',
    roundN: 'Runde {{round}}',
    autoStart: 'Start in',
    grenadeNone: 'Nein',
    allies: 'Verbündete',
    enemies: 'Gegner',
    loadout: 'Ausrüstung',
    toBattle: 'Los',
    toBattleIn: 'Los in {{sec}} s',
    statDamage: 'Schaden',
    statRate: 'Feuerrate',
    statCrit: 'Crit',
    statAccuracy: 'Genauigkeit',
    weaponAwp: 'AWP',
    weaponRifle: 'Gewehr',
    weaponLmg: 'MG',
    weaponAwpBlurb: 'Trifft hart, aber selten. Hoher Crit – entweder Kill oder Fehlschuss.',
    weaponRifleBlurb: 'Ausgewogener Schaden und Feuerrate.',
    weaponLmgBlurb: 'Oft, aber schwach. Sammelt gleichmäßig Schaden.',
    armorNone: 'Keine Rüstung',
    armorLight: 'Leichte Weste',
    armorHeavy: 'Schwere Weste',
    armorNoneBlurb: 'Maximale Feuerkraft, aber zerbrechlich.',
    armorLightBlurb: 'Senkt Schaden und Crit etwas.',
    armorHeavyBlurb: 'Senkt Spitzenschaden und Crit stark – der Konter zur AWP.',
    armorNumbers: '{{points}} Rüstungspunkte · Kugel −30 % Schaden, Crits durchschlagen',
    gearInfoOpen: 'Wie funktioniert das?',
    gearInfoTitle: 'Ausrüstung in Zahlen',
    gearFragInfo: 'Bis zu {{max}} Schaden am Ziel – Rüstung hilft nicht; Splitter treffen einen weiteren Gegner. Gegen [[defense|Verteidigung]] ×1,35, gegen [[maneuver|Ausweichen]] ×0,8.',
    gearSmokeInfo: 'Rauch auf einen Verbündeten: {{rounds}} Runden lang erleidet er −{{mit}} % Kugelschaden. Messer und Granate ignorieren Rauch.',
    gearFlashInfo: 'Blendet bis zu 3 Gegner für {{rounds}} Runden: halbe Genauigkeit, keine Crits.',
    gearMedkitInfo: 'Heilt {{frac}} % der fehlenden HP (mindestens {{floor}}). In dieser Runde schießt du nicht und bist für das Messer offen.',
    gearKnifeInfo: 'Gratis, jede Runde. Ziel schießt nicht oder steht in [[defense|Verteidigung]] – {{dmg}} durch die Rüstung, bei HP ≤ 30 % Exekution. Ziel in [[attack|Angriff]] oder [[maneuver|Ausweichen]] – nur {{weak}}, und du fängst seinen Schuss aus nächster Nähe.',
    resultWin: 'Sieg',
    resultTeamWin: 'Team hat gewonnen',
    resultDefeat: 'Niederlage',
    resultWinSub: 'Dein Team hat gewonnen – du bekommst einen Skin im Wert deines Bankanteils, nach Leistung (MVP).',
    resultTeamWinSub: 'Dein Team hat gewonnen. Dein Kämpfer ist gefallen, aber du bekommst trotzdem einen Skin für deinen Anteil nach Leistung (MVP).',
    resultDefeatSub: 'Das Team hat verloren – nächstes Mal klappt es.',
    scoreboardTitle: 'Tabelle',
    payout: 'Gewinn',
    total: 'Gesamt',
    again: 'Nochmal',
    wonShort: 'Gewonnen',
    viewLog: 'Log ansehen',
    roundLog: 'Log',
    roundLogTitle: 'Kampfverlauf',
    roundLogEmpty: 'Die erste Runde läuft noch',
    raffleTicketsTitle: '+{{n}} Verlosungstickets',
    raffleChipWin: 'Sieg +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triple +{{n}}',
    raffleChipQuad: 'Quad +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: 'Sieg mit 1 HP +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    dropRevealTapHint: 'Tippen zum Fortfahren',
    dropYouTitle: 'Dein Drop',
    dropLabel: 'Drop',
    watch: 'Ansehen',
    liveNowTitle: 'Läuft gerade',
    liveEmpty: 'Gerade läuft kein Match',
    liveRoundBadge: 'Live · Runde {{n}}',
    spectate: 'Zuschauen',
    matchOver: 'Match beendet',
    logMiss: 'daneben',
    logMissEvade: 'daneben – ausgewichen',
    logMissBlind: 'daneben – geblendet',
    logReflect: 'reflektiert',
    logPunish: 'Gegenfeuer',
    logLegend: '✦ Crit durchschlägt Rüstung · ⚡ Adrenalin',
    logKilledBy: 'getötet von',
    colKills: 'K',
    canvasMiss: 'DANEBEN',
    canvasMissEvade: 'AUSWEICHEN',
    canvasMissBlind: 'GEBLENDET',
    historyTitle: 'Verlauf',
    back: 'Zurück',
    matchDetailError: 'Das Match konnte nicht geladen werden. Vielleicht gibt es keinen Eintrag – Bot-Training wird nicht gespeichert.',
    historySubtitle: 'Deine letzten Rush-Mid-Kämpfe.',
    historyEmptyTitle: 'Du hast noch nicht gespielt',
    historyEmptyDescription: 'Spiele deinen ersten Rush-Mid-Kampf – er erscheint hier.',
    win: 'Sieg',
    defeat: 'Niederlage',
    timeJustNow: 'gerade eben',
    timeMinAgo: 'vor {{min}} Min.',
    timeHoursAgo: 'vor {{hours}} Std.',
    timeDaysAgo: 'vor {{days}} T.',
    ratingTab: 'Rating',
    yourRating: 'Dein Rating',
    earned: 'Verdient',
    rating: 'Rating',
    played: 'Gespielt',
    wins: 'Siege',
    winsCol: 'Siege',
    losses: 'Niederlagen',
    lossesCol: 'Niederlagen',
    playedShort: 'M',
    winsShort: 'S',
    lossesShort: 'N',
    winrate: 'Siegquote',
    player: 'Spieler',
    topPlayers: 'Top-Spieler',
    ratingUnratedTitle: 'Noch kein Rating',
    ratingUnratedDescription: 'Spiele ein Match in diesem Format, um ein Rating zu bekommen.',
    ratingEmptyTitle: 'Hier ist noch nichts',
    ratingEmptyDescription: 'Spiele als Erster in diesem Format.',
    raffleTab: 'Verlosung',
  },
  es: {
    lobbyTitle: 'Rush Mid',
    ticket: 'Ticket',
    format: 'Formato',
    side: 'Bando',
    sideCt: 'Antiterroristas',
    sideT: 'Terroristas',
    sideAny: 'Cualquiera',
    skinLabel: 'Skin',
    practiceBots: 'Contra bots',
    playWithBots: 'Jugar contra bots · gratis',
    winRangeTitle: 'Skin por ganar',
    skip: 'Omitir',
    howtoTitle: 'Cómo jugar',
    howtoNext: 'Siguiente',
    howtoStart: 'Entendido, a jugar',
    howtoSkip: 'Omitir',
    howtoSlide1Title: 'PvP por turnos',
    howtoSlide1Text:
      'El ticket es tu entrada a la partida. Tus rivales son jugadores reales con el mismo ticket. El equipo ganador se reparte el bote.',
    howtoSlide2Title: 'La compra no decide',
    howtoSlide2Text:
      'Todos tienen el mismo presupuesto. El arma marca el estilo: la AWP es un disparo pesado y poco frecuente, la ametralladora dispara a menudo y de forma constante.',
    howtoSlide3Title: 'Lee a tu rival',
    howtoSlide3Text:
      'Cada ronda eliges una postura. Mira qué hizo tu rival en la ronda anterior y contrarréstalo.',
    howtoSlide4Title: 'Skin según tus méritos',
    howtoSlide4Text:
      'El bote se reparte según el daño y la utilidad, y se paga con un skin del valor de tu parte. Aunque mueras, tus méritos cuentan. El bote se llena con los giros de todos los tickets: ganar da un skin que vale como mínimo tu entrada +50 %, el tope es ×5.',
    howtoTryBots: 'Primero prueba gratis: contra bots',
    howtoLoopTitle: 'Cómo va una partida',
    howtoLoopStep1: 'Eliges ticket, bando y formato: esa es tu entrada a la partida.',
    howtoLoopStep2: 'Fase de compra: arma, armadura y utilidad con el mismo presupuesto.',
    howtoLoopStep3: 'Combate por turnos: cada ronda, una postura o una acción. Eliges el objetivo con un toque.',
    howtoLoopStep4: 'El bote de la partida se reparte entre los ganadores según sus méritos y se paga con un skin.',
    howtoStancesTitle: 'Posturas',
    howtoRpsCaption: 'La flecha muestra quién vence a quién',
    howtoStancesText:
      '[[defense|Defensa]] refleja parte del daño, [[maneuver|Esquiva]] reduce la precisión del enemigo, [[attack|Ataque]] potencia tu fuego.',
    howtoWeaponsTitle: 'Armas',
    howtoWeaponAwp: 'AWP: todo o nada, disparo poco frecuente y crítico enorme.',
    howtoWeaponRifle: 'Rifle: el clásico equilibrado.',
    howtoWeaponLmg: 'Ametralladora: a menudo y constante, sin altibajos de críticos.',
    howtoUtilityTitle: 'Utilidad',
    howtoSmokeTargetNote: 'El humo cubre a un aliado: toca a un compañero para elegir a quién protege.',
    howtoUtilTeamNote: 'El humo y la flash solo existen en modos por equipos.',
    howtoMoneyTitle: 'Dinero',
    howtoMoney1: 'El presupuesto de compra es igual para todos: marca el estilo, no la fuerza.',
    howtoMoney2: 'El premio es un skin repartido según los méritos: daño + utilidad. Morir no los borra.',
    howtoMoney3: 'El bote se llena con los giros de todos los tickets: ganar da un skin que vale como mínimo tu entrada +50 %, el tope es ×5.',
    howtoMoney4: 'Cada ticket es un giro del bote: de la mitad hasta 2,5 veces el ticket por giro. Ticket más caro, bote más grande.',
    history: 'Historial',
    partyJoin: 'Unirse con código',
    partyJoinPlaceholder: 'Código de party',
    partyJoinAction: 'Unirse',
    partyShare: 'Invitar amigos',
    partyKick: 'Sacar de la party',
    partyShareText: 'Únete a mi party de SHOT: código {{code}}',
    partyErrNotFound: 'Party no encontrada: revisa el código.',
    partyErrInGame: 'Esa party ya está en partida: termínala primero.',
    partyErrFull: 'Esa party está llena.',
    partyErrInMatch: 'Termina primero tu partida activa.',
    multiaccErr: 'No puedes unirte aquí.',
    maintenanceErr: 'El juego se está actualizando: vuelve en un par de minutos.',
    balanceErr: 'No tienes monedas suficientes para la entrada: recarga tu saldo y vuelve.',
    topUpBalance: 'Recargar saldo',
    maintenanceBanner: 'El juego se está actualizando: las partidas se abrirán en un par de minutos.',
    updateBanner: 'Hay una nueva versión: actualiza para seguir jugando.',
    updateNow: 'Actualizar',
    comingSoonBadge: 'Próximamente',
    comingSoonHint: 'El modo aún no está abierto: mantente atento.',
    partyLeaderTag: 'líder',
    partyLeave: 'Salir de la party',
    partyCodeLabel: 'Código de party',
    partyCopy: 'Copiar',
    partyCopied: 'Copiado',
    partyCreatedBy: 'Creada por {{name}}',
    partyLeaderBadge: 'Líder',
    partyReadyYes: 'Listo',
    partyReadyNo: 'No listo',
    partyWaitingOthers: 'Esperando al resto de jugadores',
    partyConfirmReady: 'Confirma que estás listo para empezar.',
    partyImReady: 'Estoy listo',
    partyYou: 'Tú',
    partyShareBtn: 'Compartir',
    partyReadyCount: 'Listos: {{n}} de {{m}}',
    mode1: '1 vs 1',
    mode2: '2 vs 2',
    mode5: '5 vs 5',
    modeN: '{{size}} vs {{size}}',
    gamesTab: 'Juegos',
    introCard: 'Rush Mid es el equivalente en juego de los Case Battles al estilo Counter-Strike: los jugadores entran a la partida con un ticket fijo, se enfrentan entre sí y los ganadores se reparten el bote según sus méritos: cada uno recibe un skin del valor de su parte.',
    openGamesTitle: 'Partidas abiertas',
    howToPlayLink: 'cómo jugar',
    winUpToPrefix: 'por ganar hasta',
    winUpToSuffix: '',
    waitingForPlayer: 'esperando a un jugador…',
    winRangeChip: 'ganar da',
    notEnoughShort: 'faltan',
    homeAllGames: 'todos los juegos',
    createGame: 'Crear partida ·',
    createGameShort: 'Crear partida',
    gamesEmptyTitle: 'Aún no hay nada aquí',
    gamesEmpty: 'Todavía no hay partidas abiertas: crea la primera',
    gamesBack: 'Volver a los juegos',
    openGameTitle: 'Partida',
    joinSide: 'Unirse',
    confirmSitTitle: 'Unirse a la partida',
    confirmSitMessage: '¿Unirte por {{amount}}?',
    confirmSitYes: 'Unirse',
    gameFull: 'Todos los lugares están ocupados',
    partyBadge: 'party ×{{k}}',
    tabFighter: 'Combatiente',
    squadTitle: 'Party',
    inviteFriends: 'Invitar amigos',
    leaderPicking: 'El líder está eligiendo una partida…',
    partyWontFit: 'party ×{{k}} no cabe',
    graceLockedBadge: 'partida de novato · {{s}} s',
    graceLockedHint: 'Un novato está calentando aquí. La sala se abrirá para todos en {{s}} s.',
    partyFits: 'party ×{{k}} cabe',
    wontFit: 'no cabe',
    memberBadge: 'En una party ×{{k}}',
    createSheetTitle: 'Crear partida',
    createSheetSubtitle: 'Elige ticket, formato y bando',
    botFillIn: 'Los bots completan en {{s}} s',
    leaveGame: 'Salir',
    youLabel: 'tú',
    gameInvite: 'Invitar',
    gameShareText: 'Únete a mi partida de Rush Mid',
    gameShareButton: 'Jugar',
    replayTitle: 'Repetición de la partida',
    shareReplay: 'Compartir repetición',
    replayShareText: 'Mira esta partida de Rush Mid',
    replayShareButton: 'Ver repetición',
    gameGone: 'Esta partida ya empezó o se cerró',
    tipLabel: 'Consejo',
    preparing: 'Preparando el combate…',
    loadingGame: 'Cargando el combate…',
    loading: 'Cargando…',
    errorTitle: 'Error de RushMid',
    backToLobby: 'A los juegos',
    reloadScreen: 'Recargar pantalla',
    buyTitle: 'Compra',
    remaining: 'Quedan',
    yourFighter: 'Tu combatiente',
    hp: 'HP',
    armorShort: 'arm.',
    weapon: 'Arma',
    armor: 'Armadura',
    grenade: 'Granada',
    grenadeTaken: 'Tomada',
    medkit: 'Botiquín',
    accuracy: 'Precisión',
    stance: 'Postura',
    stanceCenter: 'Centro',
    stanceAttack: 'Ataque',
    stanceDefense: 'Defensa',
    stanceManeuver: 'Esquiva',
    knife: 'Cuchillo',
    smoke: 'Humo',
    flash: 'Flash',
    nadeSmoke: 'De humo',
    nadeFrag: 'De fragmentación',
    logSmoke: 'humo',
    logAdrenaline: 'adrenalina',
    adrenaline: 'adrenalina',
    afkBadge: 'AFK',
    afkWarn: 'Un turno más sin jugar y te quedas sin premio',
    fire: 'Fuego',
    pickAlly: 'Elige a un compañero',
    pickEnemy: 'Elige a un enemigo',
    confirmAction: 'A combatir',
    waiting: 'Esperando…',
    choosing: 'Eligiendo…',
    watchingReplay: 'Mirando…',
    youWin: 'Victoria',
    youLose: 'Derrota',
    sideWins: 'VICTORIA',
    matchDraw: 'Empate',
    drawRefund: 'Monedas devueltas',
    botShort: 'Bot',
    copyMatchId: 'Copiar ID de la partida',
    matchIdCopied: 'Copiado',
    roundN: 'Ronda {{round}}',
    autoStart: 'Inicio en',
    grenadeNone: 'No',
    allies: 'Aliados',
    enemies: 'Enemigos',
    loadout: 'Equipo',
    toBattle: 'A combatir',
    toBattleIn: 'A combatir en {{sec}} s',
    statDamage: 'Daño',
    statRate: 'Cadencia',
    statCrit: 'Crítico',
    statAccuracy: 'Precisión',
    weaponAwp: 'AWP',
    weaponRifle: 'Rifle',
    weaponLmg: 'Ametralladora',
    weaponAwpBlurb: 'Golpea fuerte, pero poco. Crítico alto: o mata o falla.',
    weaponRifleBlurb: 'Daño y cadencia equilibrados.',
    weaponLmgBlurb: 'A menudo, pero débil. Acumula daño de forma constante.',
    armorNone: 'Sin armadura',
    armorLight: 'Chaleco ligero',
    armorHeavy: 'Chaleco pesado',
    armorNoneBlurb: 'Máxima potencia de fuego, pero frágil.',
    armorLightBlurb: 'Reduce un poco el daño y el crítico.',
    armorHeavyBlurb: 'Reduce mucho el daño máximo y el crítico: contra la AWP.',
    armorNumbers: '{{points}} puntos de armadura · bala −30 % de daño, los críticos atraviesan',
    gearInfoOpen: '¿Cómo funciona?',
    gearInfoTitle: 'Equipo en cifras',
    gearFragInfo: 'Hasta {{max}} de daño al objetivo: la armadura no salva; la metralla alcanza a otro enemigo más. Contra [[defense|Defensa]] ×1,35, contra [[maneuver|Esquiva]] ×0,8.',
    gearSmokeInfo: 'Humo sobre un aliado: durante {{rounds}} rondas recibe −{{mit}} % de daño de balas. El cuchillo y la granada ignoran el humo.',
    gearFlashInfo: 'Ciega hasta a 3 enemigos durante {{rounds}} rondas: la mitad de precisión y sin críticos.',
    gearMedkitInfo: 'Cura el {{frac}} % de la vida que falta (mínimo {{floor}}). Esa ronda no disparas y quedas expuesto al cuchillo.',
    gearKnifeInfo: 'Gratis, cada ronda. Objetivo que no dispara o está en [[defense|Defensa]]: {{dmg}} a través de la armadura, ejecución con HP ≤ 30 %. Objetivo en [[attack|Ataque]] o [[maneuver|Esquiva]]: solo {{weak}}, y recibes su disparo a quemarropa.',
    resultWin: 'Victoria',
    resultTeamWin: 'Ganó el equipo',
    resultDefeat: 'Derrota',
    resultWinSub: 'Tu equipo ganó: recibes un skin del valor de tu parte del bote, según tus méritos (MVP).',
    resultTeamWinSub: 'Tu equipo ganó. Tu combatiente cayó, pero igualmente recibes un skin por tu parte según tus méritos (MVP).',
    resultDefeatSub: 'El equipo perdió: la próxima ronda saldrá mejor.',
    scoreboardTitle: 'Tabla',
    payout: 'Premio',
    total: 'Total',
    again: 'Otra vez',
    wonShort: 'Ganaron',
    viewLog: 'Ver registro',
    roundLog: 'Registro',
    roundLogTitle: 'Desarrollo del combate',
    roundLogEmpty: 'La primera ronda sigue en juego',
    raffleTicketsTitle: '+{{n}} tickets del sorteo',
    raffleChipWin: 'Victoria +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triple +{{n}}',
    raffleChipQuad: 'Quad +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: 'Victoria con 1 HP +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    dropRevealTapHint: 'Toca para continuar',
    dropYouTitle: 'Tu drop',
    dropLabel: 'Drop',
    watch: 'Ver',
    liveNowTitle: 'En curso ahora',
    liveEmpty: 'Ahora mismo no hay partidas',
    liveRoundBadge: 'En vivo · ronda {{n}}',
    spectate: 'Ver',
    matchOver: 'Partida terminada',
    logMiss: 'fallo',
    logMissEvade: 'fallo: esquivado',
    logMissBlind: 'fallo: cegado',
    logReflect: 'reflejado',
    logPunish: 'fuego de respuesta',
    logLegend: '✦ el crítico atraviesa la armadura · ⚡ adrenalina',
    logKilledBy: 'eliminado por',
    colKills: 'K',
    canvasMiss: 'FALLO',
    canvasMissEvade: 'ESQUIVA',
    canvasMissBlind: 'CEGADO',
    historyTitle: 'Historial',
    back: 'Atrás',
    matchDetailError: 'No se pudo cargar esta partida. Quizá no exista: el entrenamiento con bots no se guarda.',
    historySubtitle: 'Tus últimos combates en Rush Mid.',
    historyEmptyTitle: 'Aún no has jugado',
    historyEmptyDescription: 'Juega tu primer combate en Rush Mid: aparecerá aquí.',
    win: 'Victoria',
    defeat: 'Derrota',
    timeJustNow: 'ahora mismo',
    timeMinAgo: 'hace {{min}} min',
    timeHoursAgo: 'hace {{hours}} h',
    timeDaysAgo: 'hace {{days}} d',
    ratingTab: 'Ranking',
    yourRating: 'Tu ranking',
    earned: 'Ganado',
    rating: 'Ranking',
    played: 'Jugadas',
    wins: 'Victorias',
    winsCol: 'Victorias',
    losses: 'Derrotas',
    lossesCol: 'Derrotas',
    playedShort: 'J',
    winsShort: 'V',
    lossesShort: 'D',
    winrate: '% de victorias',
    player: 'Jugador',
    topPlayers: 'Mejores jugadores',
    ratingUnratedTitle: 'Aún sin ranking',
    ratingUnratedDescription: 'Juega una partida en este formato para entrar en el ranking.',
    ratingEmptyTitle: 'Aún no hay nada aquí',
    ratingEmptyDescription: 'Sé el primero en jugar en este formato.',
    raffleTab: 'Sorteo',
  },
  pl: {
    lobbyTitle: 'Rush Mid',
    ticket: 'Bilet',
    format: 'Format',
    side: 'Strona',
    sideCt: 'Antyterroryści',
    sideT: 'Terroryści',
    sideAny: 'Dowolna',
    skinLabel: 'Skin',
    practiceBots: 'Z botami',
    playWithBots: 'Graj z botami · za darmo',
    winRangeTitle: 'Skin za wygraną',
    skip: 'Pomiń',
    howtoTitle: 'Jak grać',
    howtoNext: 'Dalej',
    howtoStart: 'Jasne, gramy',
    howtoSkip: 'Pomiń',
    howtoSlide1Title: 'Turowe PvP',
    howtoSlide1Text:
      'Bilet to twoje wejście do meczu. Rywale to prawdziwi gracze z takim samym biletem. Zwycięska drużyna dzieli pulę.',
    howtoSlide2Title: 'Zakup nie decyduje',
    howtoSlide2Text:
      'Każdy ma taki sam budżet. Broń wyznacza styl: AWP to rzadki, ciężki strzał, karabin maszynowy strzela często i równo.',
    howtoSlide3Title: 'Czytaj rywala',
    howtoSlide3Text:
      'W każdej rundzie wybierasz postawę. Patrz, co rywal robił w poprzedniej rundzie, i przeciwdziałaj.',
    howtoSlide4Title: 'Skin według zasług',
    howtoSlide4Text:
      'Pula dzieli się według obrażeń i utility, a wypłata idzie skinem o wartości twojej części. Nawet jeśli zginiesz, twoje zasługi się liczą. Pulę napełniają losowania wszystkich biletów: wygrana daje skina wartego co najmniej wejście +50%, sufit to ×5.',
    howtoTryBots: 'Najpierw spróbuj za darmo – z botami',
    howtoLoopTitle: 'Jak wygląda mecz',
    howtoLoopStep1: 'Wybierasz bilet, stronę i format – to twoje wejście do meczu.',
    howtoLoopStep2: 'Faza zakupów: broń, pancerz i utility za równy budżet.',
    howtoLoopStep3: 'Walka turowa: w każdej rundzie postawa albo akcja. Cel wybierasz tapnięciem.',
    howtoLoopStep4: 'Pula meczu dzieli się między zwycięzców według zasług i jest wypłacana skinem.',
    howtoStancesTitle: 'Postawy',
    howtoRpsCaption: 'Strzałka pokazuje, kto kogo pokonuje',
    howtoStancesText:
      '[[defense|Obrona]] odbija część obrażeń, [[maneuver|Unik]] obniża celność wroga, [[attack|Atak]] wzmacnia twój ogień.',
    howtoWeaponsTitle: 'Broń',
    howtoWeaponAwp: 'AWP – wszystko albo nic: rzadki strzał, ogromny krytyk.',
    howtoWeaponRifle: 'Karabin – zrównoważona klasyka.',
    howtoWeaponLmg: 'Karabin maszynowy – często i równo, bez huśtawek krytyka.',
    howtoUtilityTitle: 'Utility',
    howtoSmokeTargetNote: 'Dym osłania sojusznika – tapnij kolegę z drużyny, by wybrać, kogo osłonić.',
    howtoUtilTeamNote: 'Dym i flash są tylko w trybach drużynowych.',
    howtoMoneyTitle: 'Pieniądze',
    howtoMoney1: 'Budżet na zakupy jest taki sam dla wszystkich – decyduje o stylu, nie o sile.',
    howtoMoney2: 'Nagrodą jest skin dzielony według zasług: obrażenia + utility. Śmierć nie kasuje zasług.',
    howtoMoney3: 'Pulę napełniają losowania wszystkich biletów: wygrana daje skina wartego co najmniej wejście +50%, sufit to ×5.',
    howtoMoney4: 'Każdy bilet to jedno losowanie puli – od połowy do 2,5 biletu na losowanie. Droższy bilet – większa pula.',
    history: 'Historia',
    partyJoin: 'Dołącz kodem',
    partyJoinPlaceholder: 'Kod party',
    partyJoinAction: 'Dołącz',
    partyShare: 'Zaproś znajomych',
    partyKick: 'Usuń z party',
    partyShareText: 'Dołącz do mojego party w SHOT – kod {{code}}',
    partyErrNotFound: 'Nie znaleziono party – sprawdź kod.',
    partyErrInGame: 'To party jest już w grze – najpierw ją dokończ.',
    partyErrFull: 'To party jest pełne.',
    partyErrInMatch: 'Najpierw dokończ aktywny mecz.',
    multiaccErr: 'Nie możesz tu dołączyć.',
    maintenanceErr: 'Gra się aktualizuje – zajrzyj za kilka minut.',
    balanceErr: 'Brakuje monet na wejście – doładuj saldo i wróć.',
    topUpBalance: 'Doładuj saldo',
    maintenanceBanner: 'Gra się aktualizuje – mecze otworzą się za kilka minut.',
    updateBanner: 'Jest nowa wersja – zaktualizuj, żeby grać dalej.',
    updateNow: 'Aktualizuj',
    comingSoonBadge: 'Wkrótce',
    comingSoonHint: 'Tryb jeszcze nie jest otwarty – bądź na bieżąco.',
    partyLeaderTag: 'lider',
    partyLeave: 'Opuść party',
    partyCodeLabel: 'Kod party',
    partyCopy: 'Kopiuj',
    partyCopied: 'Skopiowano',
    partyCreatedBy: 'Utworzone przez {{name}}',
    partyLeaderBadge: 'Lider',
    partyReadyYes: 'Gotowy',
    partyReadyNo: 'Niegotowy',
    partyWaitingOthers: 'Czekamy na pozostałych graczy',
    partyConfirmReady: 'Potwierdź gotowość, żeby zacząć grę.',
    partyImReady: 'Jestem gotowy',
    partyYou: 'Ty',
    partyShareBtn: 'Udostępnij',
    partyReadyCount: 'Gotowi: {{n}} z {{m}}',
    mode1: '1 na 1',
    mode2: '2 na 2',
    mode5: '5 na 5',
    modeN: '{{size}} na {{size}}',
    gamesTab: 'Gry',
    introCard: 'Rush Mid to growy odpowiednik Case Battle w stylu Counter-Strike: gracze wchodzą do meczu ze stałym biletem, walczą między sobą, a zwycięzcy dzielą pulę według zasług – każdy dostaje skina o wartości swojej części.',
    openGamesTitle: 'Otwarte gry',
    howToPlayLink: 'jak grać',
    winUpToPrefix: 'za wygraną do',
    winUpToSuffix: '',
    waitingForPlayer: 'czekamy na gracza…',
    winRangeChip: 'wygrana daje',
    notEnoughShort: 'brakuje',
    homeAllGames: 'wszystkie gry',
    createGame: 'Utwórz grę ·',
    createGameShort: 'Utwórz grę',
    gamesEmptyTitle: 'Na razie pusto',
    gamesEmpty: 'Nie ma jeszcze otwartych gier – utwórz pierwszą',
    gamesBack: 'Do listy gier',
    openGameTitle: 'Gra',
    joinSide: 'Dołącz',
    confirmSitTitle: 'Dołącz do gry',
    confirmSitMessage: 'Dołączyć do gry za {{amount}}?',
    confirmSitYes: 'Dołącz',
    gameFull: 'Wszystkie miejsca zajęte',
    partyBadge: 'party ×{{k}}',
    tabFighter: 'Wojownik',
    squadTitle: 'Party',
    inviteFriends: 'Zaproś znajomych',
    leaderPicking: 'Lider wybiera grę…',
    partyWontFit: 'party ×{{k}} się nie zmieści',
    graceLockedBadge: 'gra nowicjusza · {{s}} s',
    graceLockedHint: 'Rozgrzewa się tu nowicjusz. Dla wszystkich lobby otworzy się za {{s}} s.',
    partyFits: 'party ×{{k}} się zmieści',
    wontFit: 'nie zmieści się',
    memberBadge: 'W party ×{{k}}',
    createSheetTitle: 'Utwórz grę',
    createSheetSubtitle: 'Wybierz bilet, format i stronę',
    botFillIn: 'Boty uzupełnią za {{s}} s',
    leaveGame: 'Wyjdź',
    youLabel: 'ty',
    gameInvite: 'Zaproś',
    gameShareText: 'Dołącz do mojej gry w Rush Mid',
    gameShareButton: 'Graj',
    replayTitle: 'Powtórka meczu',
    shareReplay: 'Udostępnij powtórkę',
    replayShareText: 'Zobacz ten mecz w Rush Mid',
    replayShareButton: 'Oglądaj powtórkę',
    gameGone: 'Ta gra już się zaczęła albo została zamknięta',
    tipLabel: 'Wskazówka',
    preparing: 'Przygotowujemy walkę…',
    loadingGame: 'Ładujemy walkę…',
    loading: 'Ładowanie…',
    errorTitle: 'Błąd RushMid',
    backToLobby: 'Do gier',
    reloadScreen: 'Odśwież ekran',
    buyTitle: 'Zakup',
    remaining: 'Zostało',
    yourFighter: 'Twój wojownik',
    hp: 'HP',
    armorShort: 'panc.',
    weapon: 'Broń',
    armor: 'Pancerz',
    grenade: 'Granat',
    grenadeTaken: 'Wzięty',
    medkit: 'Apteczka',
    accuracy: 'Celność',
    stance: 'Postawa',
    stanceCenter: 'Środek',
    stanceAttack: 'Atak',
    stanceDefense: 'Obrona',
    stanceManeuver: 'Unik',
    knife: 'Nóż',
    smoke: 'Dym',
    flash: 'Flash',
    nadeSmoke: 'Dymny',
    nadeFrag: 'Odłamkowy',
    logSmoke: 'dym',
    logAdrenaline: 'adrenalina',
    adrenaline: 'adrenalina',
    afkBadge: 'AFK',
    afkWarn: 'Jeszcze jedna pominięta runda i zostaniesz bez wygranej',
    fire: 'Ogień',
    pickAlly: 'Wybierz kolegę z drużyny',
    pickEnemy: 'Wybierz wroga',
    confirmAction: 'Do walki',
    waiting: 'Czekamy…',
    choosing: 'Wybiera…',
    watchingReplay: 'Oglądamy…',
    youWin: 'Wygrana',
    youLose: 'Porażka',
    sideWins: 'WYGRANA',
    matchDraw: 'Remis',
    drawRefund: 'Monety zwrócone',
    botShort: 'Bot',
    copyMatchId: 'Kopiuj ID meczu',
    matchIdCopied: 'Skopiowano',
    roundN: 'Runda {{round}}',
    autoStart: 'Start za',
    grenadeNone: 'Brak',
    allies: 'Sojusznicy',
    enemies: 'Wrogowie',
    loadout: 'Ekwipunek',
    toBattle: 'Do walki',
    toBattleIn: 'Do walki za {{sec}} s',
    statDamage: 'Obrażenia',
    statRate: 'Tempo',
    statCrit: 'Krytyk',
    statAccuracy: 'Celność',
    weaponAwp: 'AWP',
    weaponRifle: 'Karabin',
    weaponLmg: 'Karabin maszynowy',
    weaponAwpBlurb: 'Uderza mocno, ale rzadko. Wysoki krytyk – albo zabija, albo pudłuje.',
    weaponRifleBlurb: 'Zrównoważone obrażenia i tempo.',
    weaponLmgBlurb: 'Często, ale słabo. Równo nabija obrażenia.',
    armorNone: 'Bez pancerza',
    armorLight: 'Lekka kamizelka',
    armorHeavy: 'Ciężka kamizelka',
    armorNoneBlurb: 'Maksimum siły ognia, ale kruchy.',
    armorLightBlurb: 'Trochę obniża obrażenia i krytyk.',
    armorHeavyBlurb: 'Mocno obniża szczytowe obrażenia i krytyk – na AWP.',
    armorNumbers: '{{points}} pkt pancerza · pocisk −30% obrażeń, krytyk przebija',
    gearInfoOpen: 'Jak to działa?',
    gearInfoTitle: 'Ekwipunek w liczbach',
    gearFragInfo: 'Do {{max}} obrażeń w cel – pancerz nie uratuje; odłamek rani jeszcze jednego wroga. Na [[defense|Obronę]] ×1,35, na [[maneuver|Unik]] ×0,8.',
    gearSmokeInfo: 'Dym na sojusznika: przez {{rounds}} rundy dostaje −{{mit}}% obrażeń od pocisków. Nóż i granat ignorują dym.',
    gearFlashInfo: 'Oślepia do 3 wrogów na {{rounds}} rundy: celność o połowę niższa, brak krytyka.',
    gearMedkitInfo: 'Leczy {{frac}}% brakującego HP (co najmniej {{floor}}). W tej rundzie nie strzelasz i jesteś odkryty na nóż.',
    gearKnifeInfo: 'Za darmo, w każdej rundzie. Cel nie strzela albo jest w [[defense|Obronie]] – {{dmg}} przez pancerz, przy HP ≤ 30% egzekucja. Cel w [[attack|Ataku]] lub [[maneuver|Uniku]] – tylko {{weak}}, a ty dostajesz jego strzał z bliska.',
    resultWin: 'Wygrana',
    resultTeamWin: 'Drużyna wygrała',
    resultDefeat: 'Porażka',
    resultWinSub: 'Twoja drużyna wygrała – dostajesz skina o wartości swojej części puli, według zasług (MVP).',
    resultTeamWinSub: 'Twoja drużyna wygrała. Twój wojownik padł, ale i tak dostajesz skina za swoją część według zasług (MVP).',
    resultDefeatSub: 'Drużyna przegrała – następnym razem się uda.',
    scoreboardTitle: 'Tabela',
    payout: 'Wygrana',
    total: 'Razem',
    again: 'Jeszcze raz',
    wonShort: 'Wygrali',
    viewLog: 'Zobacz log',
    roundLog: 'Log',
    roundLogTitle: 'Przebieg walki',
    roundLogEmpty: 'Pierwsza runda jeszcze trwa',
    raffleTicketsTitle: '+{{n}} biletów losowania',
    raffleChipWin: 'Wygrana +{{n}}',
    raffleChipMvp: 'MVP +{{n}}',
    raffleChipTriple: 'Triple +{{n}}',
    raffleChipQuad: 'Quad +{{n}}',
    raffleChipAce: 'Ace +{{n}}',
    raffleChipOneHp: 'Wygrana z 1 HP +{{n}}',
    raffleChipClutch2: 'Clutch 1v2 +{{n}}',
    raffleChipClutch3: 'Clutch 1v3 +{{n}}',
    dropRevealTapHint: 'Dotknij, żeby kontynuować',
    dropYouTitle: 'Twój drop',
    dropLabel: 'Drop',
    watch: 'Zobacz',
    liveNowTitle: 'Trwają teraz',
    liveEmpty: 'Teraz nikt nie gra',
    liveRoundBadge: 'Na żywo · runda {{n}}',
    spectate: 'Oglądaj',
    matchOver: 'Mecz zakończony',
    logMiss: 'pudło',
    logMissEvade: 'pudło – unik',
    logMissBlind: 'pudło – oślepiony',
    logReflect: 'odbite',
    logPunish: 'ogień zwrotny',
    logLegend: '✦ krytyk przebija pancerz · ⚡ adrenalina',
    logKilledBy: 'zabity przez',
    colKills: 'K',
    canvasMiss: 'PUDŁO',
    canvasMissEvade: 'UNIK',
    canvasMissBlind: 'ŚLEPY',
    historyTitle: 'Historia',
    back: 'Wstecz',
    matchDetailError: 'Nie udało się załadować meczu. Możliwe, że nie ma zapisu – trening z botami się nie zapisuje.',
    historySubtitle: 'Twoje ostatnie walki w Rush Mid.',
    historyEmptyTitle: 'Brak rozegranych walk',
    historyEmptyDescription: 'Zagraj pierwszą walkę w Rush Mid – pojawi się tutaj.',
    win: 'Wygrana',
    defeat: 'Porażka',
    timeJustNow: 'przed chwilą',
    timeMinAgo: '{{min}} min temu',
    timeHoursAgo: '{{hours}} godz. temu',
    timeDaysAgo: '{{days}} dn. temu',
    ratingTab: 'Ranking',
    yourRating: 'Twój ranking',
    earned: 'Zarobiono',
    rating: 'Ranking',
    played: 'Rozegrano',
    wins: 'Wygrane',
    winsCol: 'Wygrane',
    losses: 'Porażki',
    lossesCol: 'Porażki',
    playedShort: 'M',
    winsShort: 'W',
    lossesShort: 'P',
    winrate: 'Winrate',
    player: 'Gracz',
    topPlayers: 'Najlepsi gracze',
    ratingUnratedTitle: 'Brak rankingu',
    ratingUnratedDescription: 'Zagraj mecz w tym formacie, żeby dostać ranking.',
    ratingEmptyTitle: 'Na razie pusto',
    ratingEmptyDescription: 'Zagraj jako pierwszy w tym formacie.',
    raffleTab: 'Losowanie',
  },
});

export const LOADING_PHRASES: Record<Language, string[]> = {
  ru: [
    'Накручиваем глушак…',
    'Перезаряжаемся…',
    'Закупаем гранаты…',
    'Точим ножи…',
    'Раскуриваем дымы…',
    'Калибруем сенсу…',
    'Чистим AWP…',
    'Учим раскидки…',
    'Заходим на мид…',
    'Греем наушники…',
    'Зовём тиммейтов…',
    'Разминаем пальцы…',
  ],
  en: [
    'Screwing on the silencer…',
    'Reloading…',
    'Buying grenades…',
    'Sharpening knives…',
    'Lighting up smokes…',
    'Calibrating sensitivity…',
    'Cleaning the AWP…',
    'Learning nade lineups…',
    'Rushing mid…',
    'Warming up the headset…',
    'Calling the teammates…',
    'Stretching fingers…',
  ],
  uz: [
    'Glushitelni burab qoʻyyapmiz…',
    'Qayta oʻqlanmoqdamiz…',
    'Granatalar olyapmiz…',
    'Pichoqlarni charxlaymiz…',
    'Tutun granatalarini yoqamiz…',
    'Sezgirlikni sozlaymiz…',
    'AWP ni tozalaymiz…',
    'Raskidkalarni oʻrganamiz…',
    'Midga kiramiz…',
    'Quloqchinni isitamiz…',
    'Jamoadoshlarni chaqiramiz…',
    'Barmoqlarni qizdiramiz…',
  ],
  fa: [
    'صداخفه‌کن را می‌بندیم…',
    'خشاب عوض می‌کنیم…',
    'نارنجک می‌خریم…',
    'چاقوها را تیز می‌کنیم…',
    'دودها را روشن می‌کنیم…',
    'حساسیت ماوس را تنظیم می‌کنیم…',
    'AWP را تمیز می‌کنیم…',
    'پرتاب نارنجک تمرین می‌کنیم…',
    'می‌زنیم به مید…',
    'هدست را گرم می‌کنیم…',
    'هم‌تیمی‌ها را صدا می‌زنیم…',
    'انگشت‌ها را گرم می‌کنیم…',
  ],
  pt: [
    'Rosqueando o silenciador…',
    'Recarregando…',
    'Comprando granadas…',
    'Afiando as facas…',
    'Acendendo os smokes…',
    'Calibrando a sensibilidade…',
    'Limpando a AWP…',
    'Decorando os lineups…',
    'Rushando o meio…',
    'Esquentando o headset…',
    'Chamando os teammates…',
    'Alongando os dedos…',
  ],
  tr: [
    'Susturucu takılıyor…',
    'Şarjör değiştiriliyor…',
    'Bomba alınıyor…',
    'Bıçaklar bileniyor…',
    'Smokelar yakılıyor…',
    'Hassasiyet ayarlanıyor…',
    'AWP temizleniyor…',
    'Bomba atışları çalışılıyor…',
    'Mide giriliyor…',
    'Kulaklık ısıtılıyor…',
    'Takım arkadaşları çağrılıyor…',
    'Parmaklar ısıtılıyor…',
  ],
  uk: [
    'Накручуємо глушник…',
    'Перезаряджаємось…',
    'Закуповуємо гранати…',
    'Гострим ножі…',
    'Розкурюємо дими…',
    'Калібруємо чутливість…',
    'Чистимо AWP…',
    'Вчимо розкидки…',
    'Заходимо на мід…',
    'Гріємо навушники…',
    'Кличемо тімейтів…',
    'Розминаємо пальці…',
  ],
  de: [
    'Schalldämpfer wird aufgeschraubt…',
    'Nachladen…',
    'Granaten werden gekauft…',
    'Messer werden geschliffen…',
    'Rauchgranaten werden gezündet…',
    'Empfindlichkeit wird kalibriert…',
    'Die AWP wird geputzt…',
    'Nade-Lineups werden gelernt…',
    'Wir rushen Mid…',
    'Das Headset wird aufgewärmt…',
    'Teammates werden gerufen…',
    'Finger werden gelockert…',
  ],
  es: [
    'Enroscando el silenciador…',
    'Recargando…',
    'Comprando granadas…',
    'Afilando cuchillos…',
    'Encendiendo humos…',
    'Calibrando la sensibilidad…',
    'Limpiando la AWP…',
    'Aprendiendo lineups de granadas…',
    'Entrando a mid…',
    'Calentando los auriculares…',
    'Llamando a los compañeros…',
    'Estirando los dedos…',
  ],
  pl: [
    'Nakręcamy tłumik…',
    'Przeładowujemy…',
    'Kupujemy granaty…',
    'Ostrzymy noże…',
    'Odpalamy dymy…',
    'Kalibrujemy czułość…',
    'Czyścimy AWP…',
    'Uczymy się lineupów granatów…',
    'Wchodzimy na mida…',
    'Rozgrzewamy słuchawki…',
    'Wołamy kolegów z drużyny…',
    'Rozciągamy palce…',
  ],
};

export const SEARCH_TIPS: Record<Language, string[]> = {
  ru: [
    'Стойки — это камень-ножницы-бумага: Атака бьёт Манёвр, Манёвр бьёт Защиту, Защита бьёт Атаку.',
    'Нож рвёт того, кто защищается, лечится или ставит дым. Но если полезешь на стреляющего — он тебя накажет.',
    'Дым — прикрытие своего: накрой раненого союзника, и два раунда по нему проходит вдвое меньше урона, а он сам продолжает стрелять.',
    'Флешка — наоборот, по врагу: слепит цель и её соседей, два раунда они мажут и не выбивают крит. Кидай, пока враги в полном составе.',
    'Дым не спасает от гранаты и ножа: задымлённого союзника всё равно достанут взрывом или вплотную.',
    'Граната пробивает броню в эпицентре и особенно больно бьёт того, кто встал в глухую Защиту — отсидеться не выйдет. А Манёвр, наоборот, уводит от части взрыва.',
    'Лечишься — в этот раунд не стреляешь и открыт. И чем сильнее ранен, тем больше вернёт аптечка: это отыгрыш из ямы, а не сустейн.',
    'Меньшинство не приговор: каждый боец отстающей команды получает на раунд адреналин-щит (янтарная полоска) — чем больше разрыв, тем толще. Дави числом, но добивай быстро.',
    'Не фокусь толпой одного: чем больше врагов бьёт одну отстающую цель, тем меньше проходит урона (синие цифры — удар погашен). Размазывай огонь по целям.',
    'Защита отражает часть урона обратно атакующему, но сам ты бьёшь слабее.',
    'Манёвр сбивает вражескую точность — хорош против того, кто встал в глухую оборону.',
    'Броня держит поток мелких пуль (пулемёт/автомат вязнут), но снайперский крит её пробивает — от AWP броня не спасёт.',
    'У всех одинаковый бюджет: закупка решает стиль, а не силу. Криты решают.',
    'Не угадывай вслепую — смотри, что соперник делал в прошлом раунде, и читай его.',
    'Тот, кто стреляет, держит одну цель, пока она жива — убей её, чтобы сбить ему фокус.',
    'Приз в победившей команде делят по вкладу — считается не только урон, но и польза: дым, флешка, аптечка. Чем полезнее ты команде, тем больше доля.',
    'Дым и флешка — только в командных режимах: в 1 на 1 их нет.',
    'Нож бесплатный и доступен каждый раунд — это всегда запасной план.',
    'Граната задевает и соседа цели — кидай в скопление врагов.',
    'AWP — редкий тяжёлый выстрел: крит пробивает броню и наказывает отсидку. Но медленный — в упор его переливают из пулемёта/автомата.',
    'Пулемёт бьёт часто и слабо — ровно набивает урон без качелей крита.',
    'Каждый билет добавляет в банк случайную сумму — от половины до 2.5 билета. Победители делят банк по вкладу и получают скин: победа приносит скин стоимостью минимум вход +50%, потолок — ×5.',
    'Нож казнит раненого: пассивная цель с низким HP умирает от удара мгновенно. Не отсиживайся в Защите на последнем издыхании.',
    'Не выбрал действие до конца таймера — сервер сходит за тебя выстрелом в Атаке. Лучше выбери сам.',
    'Обе команды выбиты одновременно — ничья: вход вернётся полностью.',
    'Из живого боя выйти нельзя — за отсутствующего ходит автопилот, а вход и рейтинг решает исход матча. Вернёшься — попадёшь прямо в бой. Автопилот бьёт вслепую, лучше играй сам.',
    'Победы и поражения двигают твой рейтинг (ничья не меняет) — топ во вкладке «Рейтинг». Сид боя раскрывается после матча: любой раунд можно проверить в реплее.',
    'Цель выбираешь сам: тапни врага — весь огонь пойдёт по нему; тапни своего — дым полетит прикрывать его.',
  ],
  en: [
    'Stances are rock-paper-scissors: Attack beats Maneuver, Maneuver beats Defense, Defense beats Attack.',
    'The knife shreds anyone defending, healing or smoking. Charge a shooter, though, and they punish you.',
    'Smoke covers your own: shield a hurt teammate and for two rounds they take only half the gun damage — while they keep shooting.',
    'Flash is the opposite — on the enemy: it blinds the target and its neighbours, so for two rounds they miss and can’t crit. Throw it while the enemy is at full strength.',
    'Smoke won’t save you from a grenade or a knife — a smoked teammate still gets caught by the blast or up close.',
    'A grenade punches through armor at the centre and hits a turtling defender extra hard — you can’t just sit it out. Maneuver, on the other hand, ducks part of the blast.',
    'Healing means you don’t shoot that round and you’re exposed. The more hurt you are, the more the medkit gives back — a comeback tool, not steady sustain.',
    'Being outnumbered isn’t a death sentence: every trailing fighter gets a round-long adrenaline shield (the amber bar) — the bigger the gap, the thicker. Push your numbers, but finish fast.',
    'Don’t dogpile one target: the more enemies focus the same fighter, the less each shot lands (blue numbers — the hit is braced). Spread your fire across targets.',
    'Defense reflects part of the damage back at the attacker, but your own damage is weaker.',
    'Maneuver lowers the enemy’s accuracy — great against someone turtling in Defense.',
    'Armor eats a stream of small bullets (LMG/rifle bog down in it), but a sniper crit punches through — armor won’t save you from the AWP.',
    'Everyone gets the same budget: your buy sets the style, not the power. Crits decide.',
    'Don’t guess blind — watch what your opponent did last round and read them.',
    'Shooters lock onto one target and stick to it until it dies — kill their target to break their focus.',
    'The winning team splits the prize by contribution — damage AND utility: smokes, flashes and medkits all count. The more useful you are, the bigger your cut.',
    'Smoke and flash only exist in team modes — there’s none in 1v1.',
    'The knife is free and available every round — it’s always a backup plan.',
    'A grenade also clips an ally next to the target — throw it into a cluster.',
    'The AWP is a rare heavy shot: its crit punches through armor and punishes turtling. But it’s slow — up close an LMG/rifle out-guns it.',
    'The machine gun fires often and weak — steady damage with no crit swings.',
    'Every ticket adds a random amount to the bank — from half up to 2.5× the ticket. The winners split the bank by contribution and get paid in a skin: a win is worth at least your entry +50%, the ceiling is ×5.',
    'The knife executes the wounded: a passive target on low HP dies to one strike. Don’t turtle in Defense on your last breath.',
    'Pick nothing before the timer runs out and the server shoots for you in Attack. Better pick yourself.',
    'Both teams wiped in the same instant — a draw: your entry comes back in full.',
    'You can’t quit a live fight — an absent player runs on autopilot, and your entry and rating settle with the match result. Come back and you drop straight into the battle. Autopilot shoots blind — better play it yourself.',
    'Wins and losses move your rating (a draw doesn’t) — see the top in the Rating tab. The match seed is revealed afterwards: any round can be verified in the replay.',
    'You pick the target: tap an enemy and your fire goes there; tap a teammate and your smoke covers them.',
  ],
  uz: [
    'Turishlar — tosh-qaychi-qogʻoz: Hujum Manyovrni, Manyovr Himoyani, Himoya Hujumni yengadi.',
    'Pichoq himoyalanayotgan, davolanayotgan yoki tutun qoʻyayotganni yorib tashlaydi. Otayotganga yugursang — jazolaydi.',
    'Tutun — oʻzingnikini yopadi: yarador sherigingni yop, ikki raund unga oʻq zarari yarmi tegadi, oʻzi esa otaveradi.',
    'Flesh — aksincha, dushmanga: nishon va yonidagilarni koʻr qiladi, ikki raund ular xato otadi va krit chiqarolmaydi. Dushman toʻliq kuchda turganda tashla.',
    'Tutun granata va pichoqdan saqlamaydi — tutundagi sherikni baribir portlash yoki yaqindan oladi.',
    'Granata markazda zirhni teshadi va qattiq himoyaga oʻtganni ayniqsa ogʻriq uradi — oʻtirib chiqib boʻlmaydi. Manyovr esa portlashning bir qismidan qochiradi.',
    'Davolansang — oʻsha raund otmaysan va ochiqsan. Qanchalik yarador boʻlsang, aptechka shuncha koʻp qaytaradi — bu chuqurdan chiqish vositasi, doimiy tiklanish emas.',
    'Ozchilik mahkum emas: orqada qolgan har bir jangchi raundga adrenalin-qalqon oladi (sariq chiziq) — farq qancha katta boʻlsa, qalqon shuncha qalin. Son bilan bos, lekin tez tugat.',
    'Bittaga toʻplanma: bitta nishonni qancha koʻp dushman fokuslasa, har biri shuncha kam uradi (koʻk raqamlar — zarba yumshatildi). Olovni nishonlarga taqsimla.',
    'Himoya zararning bir qismini hujumchiga qaytaradi, lekin oʻzing zaifroq urasan.',
    'Manyovr raqib aniqligini pasaytiradi — qattiq himoyaga oʻtganga qarshi zoʻr.',
    'Zirh mayda oʻqlar oqimini ushlaydi (pulemyot/avtomat unda tiqilib qoladi), lekin snayper kriti uni teshadi — AWPdan zirh saqlamaydi.',
    'Hammada bir xil byudjet: xarid uslubni belgilaydi, kuchni emas. Kritlar hal qiladi.',
    'Koʻr-koʻrona taxmin qilma — raqib oʻtgan raundda nima qilganini koʻr va oʻqib ol.',
    'Otuvchilar bitta nishonni oʻlguncha ushlab otadi — fokusni buzish uchun ularning nishonini yoʻq qil.',
    'Gʻolib jamoa mukofotni hissaga koʻra boʻlishadi — faqat zarar emas, foyda ham hisoblanadi: tutun, flesh, aptechka. Jamoaga qancha foydali boʻlsang, ulushing shuncha katta.',
    'Tutun va flesh faqat jamoaviy rejimlarda bor — 1ga1da yoʻq.',
    'Pichoq bepul va har raundda mavjud — bu doim zaxira reja.',
    'Granata nishon yonidagi sherikni ham ilintiradi — toʻplangan joyga tashla.',
    'AWP — kam otadigan ogʻir zarba: kriti zirhni teshadi va oʻtirishni jazolaydi. Lekin sekin — yaqindan uni pulemyot/avtomat oʻtkazib yuboradi.',
    'Pulemyot tez va kuchsiz otadi — krit tebranishlarisiz barqaror zarar.',
    'Har bilet bankka tasodifiy summa qoʻshadi — yarmidan 2.5 biletgacha. Gʻoliblar bankni hissaga koʻra boʻlishib skin sifatida olishadi: gʻalaba kamida kirish +50% qiymatidagi skin beradi, shift — ×5.',
    'Pichoq yaradorni qatl qiladi: HP kam passiv nishon bir zarbadan oʻladi. Oxirgi nafasda Himoyada oʻtirma.',
    'Taymer tugaguncha tanlamasang — server sen uchun Hujumda otadi. Yaxshisi oʻzing tanla.',
    'Ikkala jamoa bir vaqtda qulasa — durang: kirish toʻliq qaytadi.',
    'Jonli jangdan chiqib boʻlmaydi — yoʻq oʻyinchi oʻrniga avtopilot yuradi, kirish va reyting oʻyin natijasi bilan hal boʻladi. Qaytsang — toʻgʻri jangga tushasan. Avtopilot koʻr otadi — yaxshisi oʻzing oʻyna.',
    'Gʻalaba va magʻlubiyat reytingni oʻzgartiradi (durang — yoʻq) — top «Reyting» boʻlimida. Oʻyin seedi oʻyindan keyin ochiladi: istalgan raundni replayda tekshirsa boʻladi.',
    'Nishonni oʻzing tanlaysan: dushmanni tap qil — butun olov unga ketadi; sherigingni tap qil — tutun uni yopadi.',
  ],
  fa: [
    'ژست‌ها سنگ‌کاغذ‌قیچی‌اند: حمله جاخالی را می‌برد، جاخالی دفاع را، دفاع حمله را.',
    'چاقو کسی را که دفاع می‌کند، درمان می‌شود یا دود می‌اندازد تکه‌تکه می‌کند. اما به کسی که شلیک می‌کند حمله کنی، تنبیهت می‌کند.',
    'دود پوشش خودی است: هم‌تیمی زخمی را بپوشان تا دو راند نصف دمیج گلوله بخورد — و خودش شلیکش را ادامه بدهد.',
    'فلش برعکس، روی دشمن است: هدف و کناری‌هایش را کور می‌کند، دو راند خطا می‌زنند و کریت نمی‌گیرند. وقتی دشمن کامل است بینداز.',
    'دود جلوی نارنجک و چاقو را نمی‌گیرد — هم‌تیمی زیر دود را انفجار یا ضربه نزدیک می‌گیرد.',
    'نارنجک در مرکز از جلیقه رد می‌شود و کسی را که سفت در دفاع نشسته بدجور می‌زند — نمی‌شود فقط نشست. جاخالی برعکس، بخشی از انفجار را در می‌رود.',
    'درمان یعنی آن راند شلیک نمی‌کنی و بازی. هرچه زخمی‌تر باشی کیت بیشتر برمی‌گرداند — ابزار برگشتن است، نه دوام همیشگی.',
    'کم‌بودن حکم مرگ نیست: هر مبارز تیم عقب‌افتاده یک راند سپر آدرنالین می‌گیرد (نوار کهربایی) — هرچه فاصله بیشتر، سپر ضخیم‌تر. با تعداد فشار بده، اما سریع تمامش کن.',
    'همه روی یک نفر نریزید: هرچه دشمن بیشتری یک هدف را فوکوس کند، هر شلیک کمتر می‌نشیند (عدد آبی — ضربه مهار شد). آتش را بین هدف‌ها پخش کن.',
    'دفاع بخشی از دمیج را به مهاجم برمی‌گرداند، اما ضربه خودت ضعیف‌تر است.',
    'جاخالی دقت دشمن را می‌آورد پایین — برای کسی که سفت در دفاع نشسته عالی است.',
    'جلیقه سیل گلوله‌های ریز را می‌خورد (مسلسل و رایفل در آن گیر می‌کنند)، اما کریت اسنایپر از آن رد می‌شود — جلیقه جلوی AWP را نمی‌گیرد.',
    'بودجه همه یکی است: خرید سبک را می‌سازد، نه قدرت را. کریت‌ها تعیین‌کننده‌اند.',
    'کورکورانه حدس نزن — ببین حریفت راند قبل چه کرد و بخوانش.',
    'کسی که شلیک می‌کند تا مرگ هدف رویش قفل می‌ماند — هدفش را بکش تا فوکوسش بپاشد.',
    'تیم برنده جایزه را به نسبت سهم تقسیم می‌کند — نه فقط دمیج، بلکه فایده هم: دود، فلش و کیت درمان همه حساب‌اند. هرچه برای تیم مفیدتر باشی، سهمت بیشتر است.',
    'دود و فلش فقط در حالت‌های تیمی هستند — در 1v1 خبری از آن‌ها نیست.',
    'چاقو رایگان است و هر راند در دسترس — همیشه نقشه دوم توست.',
    'نارنجک هم‌تیمی کنار هدف را هم می‌گیرد — وسط جمعیت بینداز.',
    'AWP شلیک سنگین و کم‌شمار است: کریتش از جلیقه رد می‌شود و نشستن را تنبیه می‌کند. اما کند است — از نزدیک مسلسل و رایفل از آن جلو می‌زنند.',
    'مسلسل زیاد و ضعیف می‌زند — دمیج یکنواخت بدون نوسان کریت.',
    'هر بلیت مبلغی تصادفی به بانک اضافه می‌کند — از نصف تا 2.5 برابر بلیت. برنده‌ها بانک را به نسبت سهم تقسیم و به شکل اسکین می‌گیرند: برد دست‌کم ورودی +50% می‌ارزد، سقف ×5 است.',
    'چاقو زخمی را اعدام می‌کند: هدف منفعل با HP کم با یک ضربه می‌میرد. با آخرین نفس در دفاع ننشین.',
    'تا پایان تایمر چیزی انتخاب نکنی، سرور به‌جای تو در حمله شلیک می‌کند. بهتر است خودت انتخاب کنی.',
    'هر دو تیم هم‌زمان از پا در بیایند — مساوی: ورودی کامل برمی‌گردد.',
    'از نبرد زنده نمی‌شود بیرون آمد — به‌جای بازیکن غایب خلبان خودکار بازی می‌کند، و ورودی و رده با نتیجه مسابقه تعیین می‌شوند. برگردی، مستقیم وسط نبرد می‌افتی. خلبان خودکار کور می‌زند — بهتر است خودت بازی کنی.',
    'برد و باخت رده‌ات را جابه‌جا می‌کنند (مساوی نه) — بهترین‌ها در تب «رده‌بندی». سید مسابقه بعد از پایان باز می‌شود: هر راندی را می‌شود در پخش بررسی کرد.',
    'هدف را خودت انتخاب می‌کنی: دشمن را لمس کن تا همه آتش سمت او برود؛ هم‌تیمی را لمس کن تا دود رویش بنشیند.',
  ],
  pt: [
    'As posturas são pedra-papel-tesoura: Ataque vence Esquiva, Esquiva vence Defesa, Defesa vence Ataque.',
    'A faca destrói quem está se defendendo, se curando ou jogando smoke. Mas se você partir para cima de quem está atirando, ele te pune.',
    'O smoke é cobertura para os seus: cubra um aliado ferido e por duas rodadas ele leva metade do dano de bala — e continua atirando.',
    'A flash é o contrário — vai no inimigo: cega o alvo e os vizinhos, por duas rodadas eles erram e não tiram crítico. Jogue enquanto o time inimigo está completo.',
    'O smoke não salva de granada nem de faca: o aliado coberto ainda pode ser pego pela explosão ou de perto.',
    'A granada atravessa o colete no epicentro e machuca ainda mais quem se fechou na Defesa — não dá para só esperar passar. Já a Esquiva escapa de parte da explosão.',
    'Curar significa não atirar nessa rodada e ficar exposto. E quanto mais ferido você estiver, mais o kit médico devolve: é uma virada do fundo do poço, não sustain.',
    'Estar em menor número não é sentença: cada lutador do time que está atrás ganha um escudo de adrenalina por uma rodada (a barra âmbar) — quanto maior a diferença, mais grosso. Pressione com os números, mas finalize rápido.',
    'Não foque todo mundo em um alvo só: quanto mais inimigos batem no mesmo lutador que está atrás, menos dano passa (números azuis — golpe absorvido). Espalhe o fogo pelos alvos.',
    'A Defesa reflete parte do dano de volta no atacante, mas você mesmo bate mais fraco.',
    'A Esquiva reduz a precisão inimiga — ótima contra quem se fechou na Defesa.',
    'O colete segura a chuva de balas pequenas (metralhadora/rifle atolam nele), mas o crítico da sniper atravessa — contra a AWP o colete não salva.',
    'Todo mundo tem o mesmo orçamento: a compra define o estilo, não a força. Quem decide são os críticos.',
    'Não chute no escuro — veja o que o adversário fez na rodada anterior e leia o jogo dele.',
    'Quem atira mantém um alvo até ele morrer — mate o alvo dele para quebrar o foco.',
    'O time vencedor divide o prêmio por contribuição — conta não só o dano, mas também a utilidade: smoke, flash, kit médico. Quanto mais útil você for para o time, maior a sua parte.',
    'Smoke e flash só existem nos modos em equipe: no 1 x 1 não tem.',
    'A faca é grátis e está disponível toda rodada — é sempre um plano B.',
    'A granada pega também quem está do lado do alvo — jogue no meio do bolo de inimigos.',
    'A AWP é um tiro pesado e raro: o crítico atravessa o colete e pune quem se esconde. Mas é lenta — de perto a metralhadora/rifle passa por cima dela.',
    'A metralhadora atira com frequência e fraco — dano constante, sem oscilação de crítico.',
    'Cada ingresso adiciona ao banco uma quantia aleatória — de metade até 2,5 ingressos. Os vencedores dividem o banco por contribuição e recebem uma skin: a vitória rende uma skin que vale no mínimo a entrada +50%, o teto é ×5.',
    'A faca executa o ferido: um alvo passivo com HP baixo morre no golpe na hora. Não se esconda na Defesa no último suspiro.',
    'Não escolheu uma ação antes do fim do timer — o servidor atira por você em Ataque. Melhor escolher você mesmo.',
    'Os dois times derrubados ao mesmo tempo — empate: a entrada volta inteira.',
    'Não dá para sair de uma luta em andamento — o piloto automático joga por quem sumiu, e a entrada e o rating são decididos pelo resultado da partida. Se voltar, cai direto na batalha. O piloto automático atira às cegas, melhor jogar você mesmo.',
    'Vitórias e derrotas movem seu rating (empate não muda) — o top fica na aba «Rating». A seed da luta é revelada depois da partida: qualquer rodada pode ser conferida no replay.',
    'O alvo é você quem escolhe: toque em um inimigo — todo o fogo vai nele; toque em um aliado — o smoke vai cobrir ele.',
  ],
  tr: [
    'Duruşlar taş-kâğıt-makas gibidir: Saldırı Kaçınmayı yener, Kaçınma Savunmayı yener, Savunma Saldırıyı yener.',
    'Bıçak, savunan, iyileşen ya da smoke atanı parçalar. Ama ateş edenin üstüne gidersen o seni cezalandırır.',
    'Smoke kendi takımını korur: yaralı bir takım arkadaşını kapla, iki raund boyunca ona giden mermi hasarı yarıya iner — o da ateş etmeye devam eder.',
    'Flash ise tam tersi, düşmana atılır: hedefi ve yanındakileri kör eder, iki raund boyunca ıskalarlar ve krit çıkaramazlar. Düşman takım tam kadroyken at.',
    'Smoke bombadan ve bıçaktan kurtarmaz: smoke içindeki takım arkadaşına patlamayla ya da yakından yine ulaşılır.',
    'Bomba merkezde zırhı deler ve tam Savunmaya çekilene daha da sert vurur — oturup beklemek işe yaramaz. Kaçınma ise patlamanın bir kısmından sıyrılır.',
    'İyileşirsen o raund ateş etmezsin ve açıkta kalırsın. Ne kadar yaralıysan sağlık kiti o kadar çok geri verir: bu dipten dönüş aracıdır, sürekli iyileşme değil.',
    'Sayıca az olmak son demek değil: geride kalan takımın her savaşçısı bir raundluk adrenalin kalkanı alır (kehribar çubuk) — fark büyüdükçe kalkan kalınlaşır. Sayı üstünlüğüyle bastır ama işi hızlı bitir.',
    'Herkesle tek hedefe yüklenme: geride kalan aynı hedefe ne kadar çok düşman vurursa o kadar az hasar geçer (mavi rakamlar — vuruş soğuruldu). Ateşi hedeflere dağıt.',
    'Savunma hasarın bir kısmını saldırana geri yansıtır ama sen de daha zayıf vurursun.',
    'Kaçınma düşmanın isabetini düşürür — tam savunmaya çekilene karşı iyidir.',
    'Zırh küçük mermi yağmurunu tutar (makineli/tüfek ona takılır) ama keskin nişancı kriti onu deler — AWP karşısında zırh kurtarmaz.',
    'Herkesin bütçesi aynı: alım tarzı belirler, gücü değil. Belirleyici olan kritler.',
    'Körlemesine tahmin etme — rakibin geçen raund ne yaptığına bak ve onu oku.',
    'Ateş eden, hedefi ölene kadar aynı hedefte kalır — odağını bozmak için hedefini öldür.',
    'Kazanan takım ödülü katkıya göre paylaşır — sadece hasar değil fayda da sayılır: smoke, flash, sağlık kiti. Takıma ne kadar faydalıysan payın o kadar büyük.',
    'Smoke ve flash sadece takım modlarında var: 1v1’de yok.',
    'Bıçak bedava ve her raund elinin altında — her zaman bir yedek plan.',
    'Bomba hedefin yanındakine de değer — düşman yığınının ortasına at.',
    'AWP nadir ve ağır bir atış: kriti zırhı deler ve saklananı cezalandırır. Ama yavaş — yakın mesafede makineli/tüfek onu ezer.',
    'Makineli sık ama zayıf vurur — krit dalgalanması olmadan düzenli hasar.',
    'Her bilet bankaya rastgele bir miktar ekler — biletin yarısından 2,5 katına kadar. Kazananlar bankayı katkıya göre paylaşır ve skin alır: zafer en az giriş +50% değerinde skin getirir, tavan ×5.',
    'Bıçak yaralıyı infaz eder: düşük HP’li pasif hedef tek vuruşta anında ölür. Son nefesinde Savunmaya saklanma.',
    'Süre dolmadan hamle seçmezsen sunucu senin yerine Saldırıda ateş eder. En iyisi kendin seç.',
    'İki takım da aynı anda düşerse berabere: giriş tamamen geri döner.',
    'Süren bir dövüşten çıkılmaz — olmayan oyuncu yerine otopilot oynar, giriş ve puan maçın sonucuna göre belirlenir. Geri dönersen doğrudan savaşa düşersin. Otopilot körlemesine ateş eder, en iyisi kendin oyna.',
    'Zaferler ve yenilgiler puanını değiştirir (berabere değiştirmez) — sıralama «Puan» sekmesinde. Dövüşün seed’i maçtan sonra açıklanır: her raund tekrardan doğrulanabilir.',
    'Hedefi sen seçersin: bir düşmana dokun — tüm ateş ona gider; bir takım arkadaşına dokun — smoke onu korumaya gider.',
  ],
  uk: [
    'Стійки — це «камінь-ножиці-папір»: Атака б’є Маневр, Маневр б’є Захист, Захист б’є Атаку.',
    'Ніж рве того, хто захищається, лікується або ставить дим. Але якщо полізеш на стрільця — він тебе покарає.',
    'Дим прикриває своїх: накрий пораненого союзника — і два раунди по ньому проходить удвічі менше шкоди, а він сам продовжує стріляти.',
    'Флешка — навпаки, по ворогу: засліплює ціль і її сусідів, два раунди вони мажуть і не вибивають крит. Кидай, поки всі вороги живі.',
    'Дим не рятує від гранати й ножа: задимленого союзника все одно дістануть вибухом або впритул.',
    'Граната пробиває броню в епіцентрі й особливо боляче б’є того, хто став у глухий Захист — перечекати не вийде. А Маневр, навпаки, виводить із-під частини вибуху.',
    'Лікуєшся — цього раунду не стріляєш і лишаєшся відкритим. І чим сильніше поранений, тим більше поверне аптечка: це камбек із ями, а не стабільне відновлення.',
    'Меншість — не вирок: кожен боєць команди, що відстає, отримує на раунд адреналіновий щит (бурштинова смужка) — чим більший розрив, тим товстіший. Дави кількістю, але добивай швидко.',
    'Не лупи всім гуртом по одному: чим більше ворогів б’є одну ціль, що відстає, тим менше шкоди проходить (сині цифри — удар погашено). Розподіляй вогонь по цілях.',
    'Захист відбиває частину шкоди назад в атакуючого, але сам ти б’єш слабше.',
    'Маневр збиває точність ворога — добрий проти того, хто став у глуху оборону.',
    'Броня тримає потік дрібних куль (кулемет і автомат в’язнуть), але снайперський крит її пробиває — від AWP броня не врятує.',
    'У всіх однаковий бюджет: закупівля визначає стиль, а не силу. Крити вирішують.',
    'Не вгадуй наосліп — дивись, що суперник робив минулого раунду, і читай його.',
    'Той, хто стріляє, тримає одну ціль, поки вона жива — убий її, щоб збити йому фокус.',
    'Приз у команді-переможниці ділять за заслугами — враховується не лише шкода, а й користь: дим, флешка, аптечка. Чим корисніший ти команді, тим більша частка.',
    'Дим і флешка — лише в командних режимах: у 1 на 1 їх немає.',
    'Ніж безкоштовний і доступний кожного раунду — це завжди запасний план.',
    'Граната зачіпає й сусіда цілі — кидай у скупчення ворогів.',
    'AWP — рідкісний важкий постріл: крит пробиває броню й карає за відсидку. Але повільний — упритул його переливають із кулемета чи автомата.',
    'Кулемет б’є часто й слабко — рівно набиває шкоду без гойдалок крита.',
    'Кожен квиток додає в банк випадкову суму — від половини до 2,5 квитка. Переможці ділять банк за заслугами і отримують скін: перемога приносить скін вартістю щонайменше вхід +50%, стеля — ×5.',
    'Ніж страчує пораненого: пасивна ціль із низьким HP вмирає від удару миттєво. Не відсиджуйся в Захисті на останньому подиху.',
    'Не обрав дію до кінця таймера — сервер піде за тебе пострілом в Атаці. Краще обери сам.',
    'Обидві команди вибито одночасно — нічия: вхід повернеться повністю.',
    'З живого бою вийти не можна — за відсутнього ходить автопілот, а вхід і рейтинг вирішує підсумок матчу. Повернешся — потрапиш прямо в бій. Автопілот б’є наосліп, краще грай сам.',
    'Перемоги й програші рухають твій рейтинг (нічия не змінює) — топ у вкладці «Рейтинг». Сід бою розкривається після матчу: будь-який раунд можна перевірити в реплеї.',
    'Ціль обираєш сам: тапни ворога — весь вогонь піде по ньому; тапни свого — дим полетить прикривати його.',
  ],
  de: [
    'Haltungen sind Schere-Stein-Papier: Angriff schlägt Ausweichen, Ausweichen schlägt Verteidigung, Verteidigung schlägt Angriff.',
    'Das Messer zerlegt jeden, der sich verteidigt, heilt oder Rauch wirft. Rennst du aber auf einen Schützen zu, bestraft er dich.',
    'Rauch deckt die Eigenen: Schütze einen verletzten Teamkollegen, und zwei Runden lang nimmt er nur halb so viel Kugelschaden – und schießt dabei weiter.',
    'Flash ist das Gegenteil – auf den Gegner: Er blendet das Ziel und seine Nachbarn, zwei Runden lang verfehlen sie und landen keine Crits. Wirf ihn, solange alle Gegner noch leben.',
    'Rauch rettet dich nicht vor Granate oder Messer: Einen eingenebelten Teamkollegen erwischt die Explosion oder der Nahkampf trotzdem.',
    'Eine Granate durchschlägt im Zentrum die Rüstung und trifft einen eingeigelten Verteidiger besonders hart – aussitzen funktioniert nicht. Ausweichen entgeht dagegen einem Teil der Explosion.',
    'Wer heilt, schießt in dieser Runde nicht und ist offen. Je schwerer du verwundet bist, desto mehr gibt das Medikit zurück – ein Comeback-Werkzeug, keine dauerhafte Regeneration.',
    'Unterzahl ist kein Todesurteil: Jeder Kämpfer des zurückliegenden Teams bekommt für eine Runde einen Adrenalinschild (gelber Balken) – je größer der Rückstand, desto dicker. Setz auf deine Überzahl, aber beende es schnell.',
    'Fokussiere nicht alles auf ein Ziel: Je mehr Gegner dasselbe Ziel beschießen, desto weniger Schaden kommt durch (blaue Zahlen – der Treffer ist abgefedert). Verteile dein Feuer auf mehrere Ziele.',
    'Verteidigung reflektiert einen Teil des Schadens zurück auf den Angreifer, aber du selbst teilst weniger aus.',
    'Ausweichen senkt die Genauigkeit des Gegners – stark gegen jemanden, der sich in der Verteidigung eingeigelt hat.',
    'Rüstung hält einen Strom kleiner Kugeln auf (MG und Gewehr bleiben darin hängen), aber ein Sniper-Crit durchschlägt sie – vor der AWP rettet dich keine Rüstung.',
    'Alle haben dasselbe Budget: Der Einkauf bestimmt den Stil, nicht die Stärke. Crits entscheiden.',
    'Rate nicht blind – schau, was dein Gegner in der letzten Runde gemacht hat, und lies ihn.',
    'Wer schießt, bleibt bei einem Ziel, solange es lebt – schalte es aus, um seinen Fokus zu brechen.',
    'Der Preis des Siegerteams wird nach Leistung geteilt – es zählt nicht nur Schaden, sondern auch Nutzen: Rauch, Flash, Medikit. Je nützlicher du fürs Team bist, desto größer dein Anteil.',
    'Rauch und Flash gibt es nur in Team-Modi: Im 1-gegen-1 fehlen sie.',
    'Das Messer ist kostenlos und in jeder Runde verfügbar – immer ein Plan B.',
    'Eine Granate erwischt auch den Nachbarn des Ziels – wirf sie in eine Ansammlung von Gegnern.',
    'Die AWP ist ein seltener, schwerer Schuss: Ihr Crit durchschlägt Rüstung und bestraft Einigeln. Aber sie ist langsam – aus nächster Nähe hat ein MG oder Gewehr die Oberhand.',
    'Das MG schießt oft und schwach – steter Schaden ohne Crit-Schwankungen.',
    'Jedes Ticket füllt die Bank mit einem zufälligen Betrag – von einem halben bis zu 2,5 Tickets. Die Sieger teilen die Bank nach Leistung und bekommen einen Skin: Ein Sieg bringt einen Skin im Wert von mindestens Eintritt +50 %, die Obergrenze ist ×5.',
    'Das Messer richtet Verwundete hin: Ein passives Ziel mit wenig HP stirbt sofort an einem Schlag. Igle dich nicht mit letztem Atem in der Verteidigung ein.',
    'Wählst du bis zum Ablauf des Timers nichts, schießt der Server für dich im Angriff. Wähl lieber selbst.',
    'Beide Teams werden gleichzeitig ausgeschaltet – Unentschieden: Dein Eintritt kommt vollständig zurück.',
    'Aus einem laufenden Kampf kann man nicht aussteigen – für Abwesende spielt der Autopilot, und Eintritt und Rating entscheiden sich mit dem Matchergebnis. Kommst du zurück, landest du direkt im Kampf. Der Autopilot schießt blind – spiel lieber selbst.',
    'Siege und Niederlagen bewegen dein Rating (ein Unentschieden ändert nichts) – die Top-Liste findest du im Tab „Rating“. Der Seed des Kampfes wird nach dem Match offengelegt: Jede Runde lässt sich im Replay überprüfen.',
    'Das Ziel wählst du selbst: Tippe auf einen Gegner – dein ganzes Feuer geht auf ihn; tippe auf einen Teamkollegen – dein Rauch deckt ihn.',
  ],
  es: [
    'Las posturas son piedra, papel o tijera: el Ataque vence a la Esquiva, la Esquiva vence a la Defensa y la Defensa vence al Ataque.',
    'El cuchillo destroza a quien se defiende, se cura o lanza humo. Pero si te lanzas contra un tirador, te castiga.',
    'El humo cubre a los tuyos: protege a un compañero herido y durante dos rondas recibe la mitad del daño de bala, mientras sigue disparando.',
    'La flash va al revés, contra el enemigo: ciega al objetivo y a sus vecinos, y durante dos rondas fallan y no hacen críticos. Lánzala mientras todos los enemigos sigan vivos.',
    'El humo no te salva de una granada ni de un cuchillo: a un compañero con humo lo alcanza igual la explosión o el cuerpo a cuerpo.',
    'La granada atraviesa la armadura en el centro y golpea con más fuerza a quien se atrinchera en Defensa: no puedes esperar sin más. La Esquiva, en cambio, evita parte de la explosión.',
    'Si te curas, esa ronda no disparas y quedas expuesto. Y cuanto más herido estés, más devuelve el botiquín: sirve para remontar, no para aguantar sin más.',
    'Estar en minoría no es una condena: cada combatiente del equipo que va por detrás recibe durante una ronda un escudo de adrenalina (barra ámbar), más grueso cuanto mayor es la diferencia. Aprovecha tu número, pero remata rápido.',
    'No te ensañes con uno solo: cuantos más enemigos disparan al mismo objetivo, menos daño pasa (los números azules indican un golpe amortiguado). Reparte tu fuego entre varios objetivos.',
    'La Defensa devuelve parte del daño al atacante, pero tú golpeas más flojo.',
    'La Esquiva reduce la precisión del enemigo: va muy bien contra quien se atrinchera en Defensa.',
    'La armadura aguanta una lluvia de balas pequeñas (la ametralladora y el rifle se atascan), pero un crítico de francotirador la atraviesa: contra la AWP la armadura no te salva.',
    'Todos tienen el mismo presupuesto: la compra decide el estilo, no la fuerza. Deciden los críticos.',
    'No adivines a ciegas: mira qué hizo tu rival en la ronda anterior y léelo.',
    'Quien dispara mantiene un solo objetivo mientras siga vivo: elimínalo para romperle el foco.',
    'El premio del equipo ganador se reparte según los méritos: cuenta no solo el daño, sino también la utilidad: humo, flash, botiquín. Cuanto más útil seas para el equipo, mayor será tu parte.',
    'El humo y la flash solo existen en los modos por equipos: en 1 contra 1 no hay.',
    'El cuchillo es gratis y está disponible cada ronda: siempre es un plan de reserva.',
    'La granada también alcanza al vecino del objetivo: lánzala contra un grupo de enemigos.',
    'La AWP es un disparo pesado y poco frecuente: su crítico atraviesa la armadura y castiga a quien se atrinchera. Pero es lenta: de cerca, una ametralladora o un rifle la superan.',
    'La ametralladora dispara mucho y flojo: acumula daño de forma constante, sin altibajos de críticos.',
    'Cada ticket añade al bote una cantidad aleatoria, de la mitad hasta 2,5 tickets. Los ganadores se reparten el bote según sus méritos y cobran en una skin: una victoria vale como mínimo tu entrada +50 %, y el techo es ×5.',
    'El cuchillo remata al herido: un objetivo pasivo con poca vida muere de un solo golpe. No te atrincheres en Defensa con el último aliento.',
    'Si no eliges nada antes de que acabe el temporizador, el servidor dispara por ti en Ataque. Mejor elige tú.',
    'Los dos equipos caen a la vez: empate, y tu entrada se devuelve completa.',
    'No se puede abandonar un combate en curso: por quien falta juega el piloto automático, y tu entrada y tu ranking dependen del resultado de la partida. Si vuelves, entras directo al combate. El piloto automático dispara a ciegas: mejor juega tú.',
    'Las victorias y las derrotas mueven tu ranking (el empate no lo cambia): el top está en la pestaña «Ranking». La semilla del combate se revela al terminar: cualquier ronda se puede comprobar en la repetición.',
    'El objetivo lo eliges tú: toca a un enemigo y todo tu fuego irá hacia él; toca a un compañero y tu humo irá a cubrirlo.',
  ],
  pl: [
    'Postawy to kamień, papier, nożyce: Atak bije Unik, Unik bije Obronę, Obrona bije Atak.',
    'Nóż rozszarpuje tego, kto się broni, leczy albo stawia dym. Ale jak rzucisz się na strzelca, to cię ukarze.',
    'Dym osłania swoich: osłoń rannego sojusznika, a przez dwie rundy dostaje o połowę mniej obrażeń od pocisków, a sam dalej strzela.',
    'Flash działa odwrotnie, na wroga: oślepia cel i jego sąsiadów, przez dwie rundy pudłują i nie trafiają krytyków. Rzucaj, póki wszyscy wrogowie żyją.',
    'Dym nie uratuje cię przed granatem ani nożem: osłoniętego dymem sojusznika i tak dosięgnie wybuch albo atak z bliska.',
    'Granat przebija pancerz w epicentrum i szczególnie mocno uderza w tego, kto zamknął się w Obronie – przeczekać się nie da. A Unik z kolei pozwala uciec przed częścią wybuchu.',
    'Gdy się leczysz, w tej rundzie nie strzelasz i jesteś odsłonięty. Im bardziej jesteś ranny, tym więcej oddaje apteczka: to odbicie się z dołka, a nie stałe regenerowanie.',
    'Mniejszość to nie wyrok: każdy wojownik przegrywającej drużyny dostaje na rundę tarczę adrenaliny (bursztynowy pasek) – im większa strata, tym grubsza. Naciskaj liczebnością, ale kończ szybko.',
    'Nie skupiaj całego ognia na jednym celu: im więcej wrogów bije ten sam przegrywający cel, tym mniej obrażeń przechodzi (niebieskie cyfry – cios wytłumiony). Rozdzielaj ogień na różne cele.',
    'Obrona odbija część obrażeń z powrotem w atakującego, ale ty sam bijesz słabiej.',
    'Unik obniża celność wroga – dobry przeciwko temu, kto zamknął się w Obronie.',
    'Pancerz wytrzymuje strumień drobnych pocisków (karabin maszynowy i karabin grzęzną), ale krytyk snajperski go przebija – przed AWP pancerz nie ochroni.',
    'Wszyscy mają taki sam budżet: zakup decyduje o stylu, a nie o sile. Krytyki rozstrzygają.',
    'Nie zgaduj na ślepo – patrz, co rywal robił w poprzedniej rundzie, i czytaj go.',
    'Ten, kto strzela, trzyma jeden cel, dopóki żyje – zabij go, żeby zburzyć mu skupienie.',
    'Nagrodę w zwycięskiej drużynie dzieli się według zasług – liczą się nie tylko obrażenia, ale i pożytek: dym, flash, apteczka. Im bardziej jesteś przydatny drużynie, tym większy udział.',
    'Dym i flash są tylko w trybach drużynowych: w 1 na 1 ich nie ma.',
    'Nóż jest darmowy i dostępny w każdej rundzie – to zawsze plan awaryjny.',
    'Granat zahacza też sąsiada celu – rzucaj w skupisko wrogów.',
    'AWP to rzadki, ciężki strzał: krytyk przebija pancerz i karze za przeczekiwanie. Ale jest wolna – z bliska wygrywa z nią karabin maszynowy albo karabin.',
    'Karabin maszynowy strzela często i słabo – równo nabija obrażenia, bez huśtawki krytyków.',
    'Każdy bilet dorzuca do puli losową kwotę – od połowy do 2,5 biletu. Zwycięzcy dzielą pulę według zasług i dostają skina: wygrana to skin wart co najmniej wejście +50%, sufit to ×5.',
    'Nóż dobija rannego: bierny cel z niskim HP ginie od jednego ciosu. Nie przeczekuj w Obronie na ostatnim tchu.',
    'Jeśli do końca timera nic nie wybierzesz, serwer strzeli za ciebie w Ataku. Lepiej wybierz sam.',
    'Obie drużyny padły jednocześnie – remis: wejście wraca w całości.',
    'Z walki na żywo nie da się wyjść – za nieobecnego gra autopilot, a wejście i ranking rozstrzyga wynik meczu. Wrócisz – wpadniesz prosto do walki. Autopilot strzela na ślepo, lepiej graj sam.',
    'Wygrane i porażki zmieniają twój ranking (remis nie zmienia) – top znajdziesz w zakładce „Ranking”. Seed walki jest ujawniany po meczu: każdą rundę można sprawdzić w powtórce.',
    'Cel wybierasz sam: tapnij wroga – cały ogień pójdzie w niego; tapnij swojego – dym poleci go osłonić.',
  ],
};
